// GENERATED by scripts/build-locales.mjs — do not edit.
// JSON in packages/locales/ is the source of truth.
// Run: node scripts/build-locales.mjs

type _Locale = "en-TC" | "ht" | "es";

export const TRANSLATIONS: Record<_Locale, Record<string, string>> = {
  "en-TC": {
    "aboutPelican.certsDisclosure": "Certifications & awards ({isoCount} ISO + {awardCount} industry)",
    "aboutPelican.heading": "Pelican Energy TCI",
    "aboutPelican.isoBizCont": "Business continuity",
    "aboutPelican.isoEnvMgmt": "Environmental management",
    "aboutPelican.isoInfoSec": "Information security",
    "aboutPelican.isoOHS": "Occupational health/safety",
    "aboutPelican.isoServiceMgmt": "Service management",
    "aboutPelican.narrative": "Pelican Energy TCI is the public electricity supplier serving eight islands of the Turks and Caicos, with the vision of “Transforming Energy in the Turks and Caicos Islands” under the “Energy for Good™” tagline. Led by an executive team headquartered in Providenciales, with 88% Turks and Caicos Islander workforce, the company operates as a subsidiary of Vision Ridge Partners (global sustainable real assets investor) and holds five ISO certifications and multiple industry awards.",
    "aboutPelican.overline": "ABOUT PELICAN ENERGY TCI",
    "aboutPelican.source": "Source:",
    "aboutPelican.statCustomers": "Customers",
    "aboutPelican.statReliability": "Reliability (3-year)",
    "aboutPelican.statStaff": "Staff",
    "aboutPelican.statWorkforce": "TC Islander workforce",
    "aboutPreview.builtFor": "Built for customers like {name}",
    "aboutPreview.builtForGeneric": "Built for customers like you",
    "aboutPreview.bullet1": "4 customer personas to switch between — residential, commercial, hotel, property manager",
    "aboutPreview.bullet2": "Web and mobile, same persona-aware experience",
    "aboutPreview.bullet3": "Programs across residential, commercial, hotel, and property-manager customers",
    "aboutPreview.bullet4": "All 8 inhabited islands of the Turks and Caicos",
    "aboutPreview.heading": "About this preview",
    "aboutPreview.overline": "ABOUT THIS PREVIEW",
    "aboutPreview.p1": "This preview is an internal Pelican Energy TCI initiative showing what the company’s customer experience can be. Nothing connects to live accounts, billing, or payments. Every interaction runs on synthetic data. It exists to show, end to end, what self-service for the Turks and Caicos Islands looks like.",
    "aboutPreview.p2": "Pelican customers today access their account through the company’s existing portal for bill pay and usage. This preview shows what bill explanations in plain English, persona-aware mobile, and storm-mode offline can add — extending what’s there, not replacing the parts that work.",
    "access.heading": "Help, install, and coverage",
    "access.helpTitle": "Get help",
    "access.mobileAlt": "Pelican Energy TCI mobile home screen",
    "access.mobileDesc": "Native mobile app — built for storm-mode resilience",
    "access.mobileTitle": "Mobile companion",
    "access.overline": "GET STARTED",
    "access.territoryDesc": "Pelican Energy TCI serves eight inhabited islands across the Turks and Caicos.",
    "access.territoryTitle": "Service territory",
    "access.viewMap": "View interactive map →",
    "account.accountNumber": "Account #{number}",
    "account.billingPrefs": "Billing Preferences",
    "account.channelEmail": "Email",
    "account.channelPush": "Push",
    "account.channelSms": "SMS",
    "account.commPrefs": "Communication Preferences",
    "account.contactInfo": "Contact Information",
    "account.datePlaceholder": "YYYY-MM-DD",
    "account.eBilling": "E-billing",
    "account.eBillingDesc": "Receive bills by email instead of paper mail",
    "account.eBillingToggleAria": "Toggle e-billing",
    "account.emailAddress": "Email Address",
    "account.feedbackImprove": "What could we do better?",
    "account.feedbackPlaceholder": "Your thoughts...",
    "account.feedbackRateAria": "Rate {n} out of 5",
    "account.feedbackRateLegend": "How would you rate your experience?",
    "account.feedbackSubmit": "Submit feedback",
    "account.feedbackSubtitle": "Tell us what's working and what isn't — your feedback shapes what comes next.",
    "account.feedbackThankBody": "Your input helps shape what we build next for Pelican Energy TCI customers.",
    "account.feedbackThankTitle": "Thank you for your feedback",
    "account.feedbackTitle": "Send feedback",
    "account.fieldName": "Name",
    "account.from": "From",
    "account.fullName": "Full Name",
    "account.mailingAddress": "Mailing Address",
    "account.phone": "Phone",
    "account.saveChanges": "Save Changes",
    "account.saveVacation": "Save Vacation Mode",
    "account.title": "Account & Settings",
    "account.to": "To",
    "account.updateSuccess": "Profile updated successfully",
    "account.updateTitle": "Account Update",
    "account.vacActivate": "Activate Vacation Mode",
    "account.vacActive": "Vacation Mode Active",
    "account.vacActiveRange": "Active from {from} to {to}",
    "account.vacationSubtitle": "Let Pelican know when you're away — we'll watch for unusual usage",
    "account.vacationTitle": "Vacation Mode",
    "account.vacBullet1": "Alert you if usage spikes unexpectedly (leak detection)",
    "account.vacBullet2": "Send daily usage summaries instead of real-time alerts",
    "account.vacBullet3": "Flag any meter anomalies for review when you return",
    "account.vacBullet4": "Auto-adjust HVAC set-point recommendations (if connected)",
    "account.vacFootnote": "Vacation Mode is a TCI-native feature designed for snowbird homeowners and frequent travelers — supporting customers who spend part of the year off-island.",
    "account.vacSaved": "Vacation mode saved",
    "account.vacSetDates": "Set dates below, then activate",
    "account.vacToggleAria": "Toggle vacation mode",
    "account.vacWhileAway": "While you're away, Pelican will:",
    "ai.askAnything": "Ask Pelican about your account — try one of these:",
    "ai.assistantDescription": "The AI assistant can answer questions about outages, solar, demand, and more.",
    "ai.assistantName": "Pelican Assistant",
    "ai.backToTopics": "Back to topics",
    "ai.closeAria": "Close assistant",
    "ai.footerDisclaimer": "Preview prototype — synthetic data only · Not financial advice",
    "ai.inputPlaceholder": "Ask about your account…",
    "ai.openAssistant": "Open assistant →",
    "ai.panelAria": "Pelican Assistant",
    "ai.preview": "Preview",
    "ai.processing": "Processing",
    "ai.sendAria": "Send message",
    "ai.standardExplanation": "Live AI unavailable — showing standard explanation",
    "ai.thinking": "Thinking…",
    "ai.wantToAsk": "Want to ask anything else?",
    "ask.ariaLabelInput": "Ask the assistant a question",
    "ask.ariaLabelSubmit": "Ask the assistant",
    "ask.ctaAskAnother": "Ask another",
    "ask.ctaSignIn": "Sign in to the preview and continue as a persona",
    "ask.ctaSubmit": "Ask",
    "ask.ctaSwitchPersona": "Switch persona",
    "ask.disclaimer": "Synthetic data only · grounded on your active persona",
    "ask.errorAiDown": "The assistant is unavailable right now. Try a pre-rendered example or sign in.",
    "ask.errorNetwork": "Network issue. Try again or use a pre-rendered example.",
    "ask.errorQuotaExhausted": "You've used today's live questions — come back tomorrow, or sign in to keep exploring. The examples above are always available.",
    "ask.errorRateLimited": "Too many questions just now. Try an example above.",
    "ask.heading": "Ask. Get answers cited to your data.",
    "ask.inputPlaceholder": "Ask your own question…",
    "ask.inputPlaceholderShort": "Ask a question…",
    "ask.loading": "Thinking",
    "ask.moduleDesc": "Ask about a bill, an outage, your usage — answers cite the data behind them.",
    "ask.moduleDisclaimer": "Routes into the preview assistant — synthetic data only.",
    "ask.overline": "ASK ANYTHING",
    "ask.quotaWarning": "{remaining} live questions left today",
    "ask.subhead": "Active: {persona} · {type} persona",
    "autopay.comingSoon": "Autopay — in the delivery roadmap",
    "balance.currentBalance": "Current Balance",
    "balance.dueDate": "Due {date}",
    "balance.noBalanceDue": "No balance due",
    "balance.paidInFull": "Paid in full",
    "balance.payNow": "Pay now",
    "balance.setUpAutopay": "Set Up AutoPay",
    "batchPay.processedOn": "Batch payment processed {date}",
    "bill.accountAddress": "Account #{account} · {address}",
    "bill.aiBadge": "AI",
    "bill.aiDisclaimer": "AI-generated explanation based on your bill data. Your actual usage and rates apply.",
    "bill.aiExplainer": "AI Bill Explainer",
    "bill.aiExplainerSub": "AI-powered explanation based on your usage data",
    "bill.askAnythingSub": "The AI assistant can answer questions about outages, solar, demand, and more.",
    "bill.askAnythingTitle": "Want to ask anything else?",
    "bill.askFollowUp": "Ask a follow-up",
    "bill.balanceDue": "Balance due",
    "bill.batchPayAllAccounts": "Batch Pay All Accounts",
    "bill.billAssistant": "Bill Assistant",
    "bill.billingPeriod": "Billing period",
    "bill.billTotal": "Bill total",
    "bill.chargeDetail": "{kwh} × ${rate}/kWh",
    "bill.charges": "Charges",
    "bill.confusedAboutBill": "Confused about your bill? Ask the AI assistant",
    "bill.currentBill": "Current Bill",
    "bill.currentBillLink": "Current bill",
    "bill.customerCharge": "Customer Charge",
    "bill.demandCharge": "Demand Charge",
    "bill.demandDetail": "{kw} kW peak × $15.00/kW",
    "bill.demandFee": "Demand Fee",
    "bill.downloadPdf": "Download PDF",
    "bill.downloadStatement": "Download statement (PDF)",
    "bill.dueBadge": "Due {date}",
    "bill.electricCharge": "Electric Charge",
    "bill.energyLabel": "Energy",
    "bill.explainAccountLine": "{month} · Account #{account}",
    "bill.explainGroundedTip": "Every claim on this page is grounded in your actual bill data. If a statement can't be cited to your records, it's not shown.",
    "bill.explainMyBill": "Explain my bill",
    "bill.fixedFee": "Fixed fee",
    "bill.fuelFactor": "Fuel Factor",
    "bill.generatingExplanation": "Generating explanation…",
    "bill.historyAccountLine": "Account #{account} · {count} payments",
    "bill.historyCountTotalOne": "{count} payment · {total} total",
    "bill.historyCountTotalOther": "{count} payments · {total} total",
    "bill.historyEmpty": "No payments in this period.",
    "bill.kitchenAnomaly": "Kitchen +18% vs last MTD — brunch event",
    "bill.meterAggregate": "{count}-Meter Aggregate",
    "bill.meterIdLocation": "Meter ID: {id} · Location: {location}",
    "bill.meterRowAria": "{name} meter details — {kwh}",
    "bill.meterUsage": "Usage: {kwh}",
    "bill.monthlyBaseFee": "Monthly base fee",
    "bill.monthsFilter": "{months}mo",
    "bill.multiMeterBreakdown": "Multi-meter breakdown",
    "bill.net": "net",
    "bill.noPriorBills": "No prior bills on record",
    "bill.openAssistant": "Open assistant →",
    "bill.openDesktopFullView": "Open on desktop for the full view",
    "bill.openPortfolioDesktopAria": "Open full portfolio on desktop",
    "bill.paymentHistory": "Payment History",
    "bill.paymentHistorySub": "View all past payments and download statements",
    "bill.payNow": "Pay {amount}",
    "bill.portfolioBreakdown": "Portfolio breakdown",
    "bill.portfolioTotal": "Portfolio Total",
    "bill.preparingPdf": "Preparing PDF…",
    "bill.priorPeriod": "Prior period",
    "bill.rangeMonths": "{count}mo",
    "bill.shareBill": "Share Bill",
    "bill.smallCommercial": "Small commercial",
    "bill.solar": "solar",
    "bill.sourceLabel": "Source: {badge}",
    "bill.sources": "Sources:",
    "bill.stmtRoadmapBody": "Statement download is in the delivery roadmap.",
    "bill.stmtRoadmapTitle": "Delivery roadmap",
    "bill.subtotal": "Subtotal",
    "bill.tariffRefCore": "Reference: Pelican Energy TCI tariff §4.2 (CORE)",
    "bill.tariffRefUore": "§4.3 (UORE)",
    "bill.thAmount": "Amount",
    "bill.thDate": "Date",
    "bill.thisPeriod": "This period",
    "bill.thMethod": "Method",
    "bill.thMonth": "Month",
    "bill.thRef": "Ref",
    "bill.thStatus": "Status",
    "bill.thTotal": "Total",
    "bill.thUsage": "Usage (kWh)",
    "bill.thVsPrior": "vs prior",
    "bill.totalDue": "Total Due",
    "bill.totalPaidRange": "Total paid (last {count} months)",
    "bill.transactionOne": "{count} transaction",
    "bill.transactionOther": "{count} transactions",
    "bill.trendFootnote": "Full 12-month history · Monthly detail view in the delivery roadmap",
    "bill.trendPast12": "Past 12 months",
    "bill.trendTitle": "12-Month Usage & Cost Trend",
    "bill.twelveMonthHistory": "12-month history",
    "bill.understandTitle": "Understand your bill",
    "bill.usageLabel": "Usage",
    "bill.viewBill": "View bill",
    "bill.viewSourceAria": "View source: {label}",
    "bill.whyHigher": "Why is my bill higher?",
    "billing.nextBillLate": "Next bill expected late {month}",
    "billing.paidOn": "Paid {date}",
    "brand.homeAria": "Pelican Energy TCI home",
    "common.back": "Back",
    "common.backToHome": "Back to home",
    "common.continue": "Continue",
    "common.deliveryRoadmap": "In the delivery roadmap",
    "common.dismissAlert": "Dismiss alert",
    "common.done": "Done",
    "common.goBack": "Go back",
    "common.loading": "Loading",
    "common.notificationsOff": "Notifications are off",
    "common.openDeviceSettingsAria": "Open device settings",
    "common.openSettings": "Open Settings →",
    "demo.backToOverview": "← Back to overview",
    "demo.banner": "Preview prototype — synthetic data only",
    "desktopOnly.batchPaySummary": "Pay all 4 managed accounts in one transaction. Available on desktop.",
    "desktopOnly.batchPayTitle": "Batch pay all accounts",
    "desktopOnly.copied": "✓ Copied!",
    "desktopOnly.copyUrl": "Copy URL",
    "desktopOnly.copyUrlAria": "Copy URL to clipboard",
    "desktopOnly.ecorSummary": "Adjust occupancy rate in real-time to see energy cost per room night. Laptop-optimised.",
    "desktopOnly.ecorTitle": "ECOR live occupancy slider",
    "desktopOnly.esgSummary": "Download carbon footprint and energy intensity report for your portfolio.",
    "desktopOnly.esgTitle": "ESG report export",
    "desktopOnly.optimisedNote": "This view is optimised for laptop / desktop.",
    "desktopOnly.portfolioSummary": "6 meters · detailed analytics grid · multi-year trend. Best on a large screen.",
    "desktopOnly.portfolioTitle": "Hotel / PM portfolio",
    "desktopOnly.scanToOpen": "Scan to open on desktop",
    "errors.connectionIssue": "Connection issue",
    "errors.dateRangeInvalid": "Return date must be after departure date.",
    "errors.emailInvalid": "Please enter a valid email address.",
    "errors.emailRequired": "Email is required.",
    "errors.fieldRequired": "{field} is required.",
    "errors.gatewayUnreachable": "Unable to reach the payment gateway. Please try again.",
    "errors.ratingRequired": "Please select a rating before submitting.",
    "errors.resetDemoState": "Reset demo state",
    "errors.somethingWrong": "Something went wrong",
    "errors.tryAgain": "Try again",
    "followUp.compareLastMay": "Compare to this time last year",
    "followUp.fuelFactor": "What's a fuel factor?",
    "followUp.reduceBill": "How can I reduce my bill?",
    "footer.accessibility": "Accessibility",
    "footer.disclaimer": "Synthetic data only · No real accounts · No real payments",
    "footer.forms": "Customer Forms",
    "footer.initiative": "Customer Experience Preview — an internal Pelican Energy TCI initiative.",
    "footer.linkApplyService": "Apply for service",
    "footer.linkAskAssistant": "Ask the assistant",
    "footer.linkCore": "CORE",
    "footer.linkDamageClaim": "Damage claim",
    "footer.linkEvCharging": "EV charging",
    "footer.linkHurricanePrep": "Hurricane prep",
    "footer.linkOutageMap": "Outage map",
    "footer.linkPayBill": "Pay your bill",
    "footer.linkReportOutage": "Report outage",
    "footer.linkSignIn": "Sign in",
    "footer.linkStopService": "Stop service",
    "footer.linkStreetlight": "Streetlight report",
    "footer.linkUore": "UORE",
    "footer.previewBadge": "Preview",
    "footer.privacy": "Privacy: Synthetic data only · No PII collected",
    "footer.programs": "Programs",
    "footer.quicklinks": "Quick Links",
    "footer.siteLinks": "Site links",
    "footer.subfooter": "Pelican Energy TCI · Customer Experience Preview · Synthetic data only · Built in the spirit of Energy for Good",
    "greeting.afternoon": "Good afternoon, {name}",
    "greeting.evening": "Good evening, {name}",
    "greeting.morning": "Good morning, {name}",
    "help.ai.desc": "Answers with citations to your synthetic account data.",
    "help.ai.title": "Ask the assistant",
    "help.banner": "This preview shows what your future Pelican customer experience can be. For anything affecting your live account today — billing questions, real outages, account changes — contact Pelican Energy TCI using the phone or email above.",
    "help.banner.link": "Or visit pelicanenergytci.com →",
    "help.email.title": "Email Pelican Energy TCI",
    "help.phone.hours": "Hours: see pelicanenergytci.com →",
    "help.phone.title": "Call Pelican Energy TCI",
    "hero.checkMap": "Check map",
    "hero.enterAs": "Enter the preview as {name} →",
    "hero.enterGeneric": "Enter the preview →",
    "hero.exploreAs": "Choose a customer to explore as",
    "hero.exploringAs": "Exploring as {name} · {type} persona. Switch anytime inside the preview.",
    "hero.exploringGeneric": "Switch personas anytime inside the preview.",
    "hero.eyebrow": "CUSTOMER EXPERIENCE PREVIEW",
    "hero.headlineAccent": "made for these islands.",
    "hero.headlinePrimary": "Energy,",
    "hero.langCommitment": "Available in English · Kreyòl Ayisyen · Español",
    "hero.langHonestScope": "The landing and your account home are available in all three languages; deeper pages are still being translated.",
    "hero.openHurricanePrep": "Open hurricane prep →",
    "hero.reportOutage": "Report outage",
    "hero.statusAllClear": "All systems normal · Service operating across all eight islands",
    "hero.statusPersona": "Service in {island}: normal · All systems operating",
    "hero.stormActive": "preparedness mode active",
    "hero.stormEtaBanner": "{name} — ETA {eta}",
    "hero.subhead": "The customer experience for Pelican Energy TCI — pay your bill, prepare for storms, ask anything, all in one place.",
    "hero.trustMicrocopy": "30-second start · No registration",
    "home.accountsCount": "{count} accounts",
    "home.accountsCountDue": "{count} accounts · Due {date}",
    "home.accountsCountPaid": "{count} accounts · Paid {date} ✓",
    "home.activeOutagesAriaOne": "{count} active outage, view map",
    "home.activeOutagesAriaOther": "{count} active outages, view map",
    "home.activeRequests": "Active Requests",
    "home.activity.batchPayment": "Batch payment {amount}",
    "home.activity.billIssued": "Bill issued {amount}",
    "home.activity.billsIssuedTotal": "{count} bills issued — {amount} total",
    "home.activity.demandChargeApplied": "Demand charge applied",
    "home.activity.demandNearMiss": "Demand near-miss {load}/{cap} kW",
    "home.activity.highUsageAlertProperty": "High-usage alert — {property}",
    "home.activity.highUsageAlertSent": "High-usage alert sent",
    "home.activity.kitchenMeterAnomaly": "Kitchen meter {pct} anomaly",
    "home.activity.outageResolved": "Outage resolved — {area} area",
    "home.activity.paymentReceived": "Payment received {amount}",
    "home.activity.portfolioTrend": "Portfolio trend {pct}",
    "home.activity.solarExport": "Solar export {kwh} kWh",
    "home.activity.solarExportCredited": "Solar export {kwh} kWh credited",
    "home.activity.usageAbovePrior": "Usage {pct} above prior cycle",
    "home.activity.vacantAnomaly": "Vacant anomaly — {property}",
    "home.aiCalloutSub": "Plain-English explanation with citations from your usage data",
    "home.alert.anomaly": "Anomaly flagged",
    "home.alert.countOne": "{count} alert",
    "home.alert.countOther": "{count} alerts",
    "home.alert.demand": "Demand near threshold",
    "home.alert.storm": "{name}",
    "home.allPowerOn": "All power on",
    "home.anomaly": "Anomaly",
    "home.askNow": "Ask now →",
    "home.contextHighlightDiveDay": "avg cost per dive day",
    "home.demand": "Demand",
    "home.demandShedHint": "Current load within {pct} of the {cap} kW threshold — consider shedding HVAC in unoccupied rooms.",
    "home.ecorPerRoomNight": "per occupied room night",
    "home.etaLabel": "ETA:",
    "home.kwValue": "{value} kW",
    "home.liveOccupancySlider": "Live occupancy slider →",
    "home.liveOccupancySliderDesktop": "Live occupancy slider (desktop) →",
    "home.managedProperties": "Managed properties",
    "home.managedPropertiesSub": "{count} properties · anomaly monitoring",
    "home.nearThreshold": "near threshold",
    "home.networkStatus": "Network Status",
    "home.noActiveRequests": "No active requests",
    "home.noRecentActivity": "No recent activity",
    "home.ofKwThreshold": " / {cap} kW threshold",
    "home.openEcorDesktopAria": "Open ECOR live slider on desktop",
    "home.openPortfolio": "Open portfolio →",
    "home.outageActiveAria": "Power outage active in {circuit} — tap for details",
    "home.outageCountOne": "{count} outage",
    "home.outageCountOther": "{count} outages",
    "home.outageIn": "Outage in {circuit}",
    "home.peakDemand": "Peak Demand",
    "home.peakDemandAria": "Peak demand {load} kW of {cap} kW threshold",
    "home.pelicanInsights": "Pelican Insights",
    "home.portfolioBalance": "Portfolio Balance",
    "home.portfolioDashboard": "Portfolio Dashboard",
    "home.portfolioMetersSub": "{count} meters · occupancy · anomaly detection",
    "home.powerOn": "Power on",
    "home.propertiesFlagged": "{count} of {total} properties flagged this period",
    "home.recentActivity": "Recent Activity",
    "home.report": "Report →",
    "home.reportOutageAria": "Report a power outage",
    "home.reportPowerOut": "Power out? Report now",
    "home.reportPowerOutSub": "One tap — drop a pin at {address} or pick a different address",
    "home.solarCapacityPanels": "{kw} kW CORE · {panels} panels",
    "home.solarExportedOffset": "{kwh} exported · {pct}% of usage offset",
    "home.solarThisMonth": "Solar This Month",
    "home.tapForPrepMode": "Tap for Prep Mode →",
    "home.time.lastMonth": "Last month",
    "home.time.lastWeek": "Last week",
    "home.time.thisCycle": "This cycle",
    "home.time.thisMonth": "This month",
    "home.time.today": "Today",
    "home.usage12mo": "Usage (12 months)",
    "home.usageAnomalyDetected": "Usage anomaly detected",
    "home.usageCostTrend": "{sign}{pct}% cost vs prior cycle",
    "home.usageLastMonth": "{kwh} last month",
    "home.usageThisMonth": "Usage This Month",
    "home.usageVsPriorCycle": "{sign}{pct}% vs prior cycle",
    "home.viewActivity": "View activity →",
    "home.viewAll": "View all",
    "home.viewAllRequestsAria": "View all requests",
    "home.viewAnomalyAria": "View anomaly details",
    "home.viewHurricaneChecklistAria": "View hurricane preparedness checklist",
    "home.viewInvestigation": "View investigation →",
    "home.viewMap": "View map",
    "home.viewProperties": "View properties →",
    "hotel.alerts.demandNearMiss": "Demand near-miss: {actual} kW / {threshold} kW threshold",
    "hotel.alerts.demandNearMissSub": "Resolved automatically",
    "hotel.alerts.kitchen": "Kitchen & F&B meter +18% vs last MTD",
    "hotel.alerts.kitchenSub": "brunch event",
    "hotel.alerts.panelMaintenance": "Panel maintenance overdue — {meter}",
    "hotel.alerts.panelMaintenanceSub": "Pool & Spa distribution panel",
    "hotel.alerts.timeLastMonth": "Last month",
    "hotel.alerts.timeTwoMonthsAgo": "2 months ago",
    "hotel.band.occupancy": "{pct}% occupancy",
    "hotel.ecor.aboveBy": "{pct}% above",
    "hotel.ecor.ariaEcor": "ECOR: {amount} per occupied room night",
    "hotel.ecor.ariaSlider": "{pct}% occupancy — ECOR {amount}",
    "hotel.ecor.avgSuffix": "avg",
    "hotel.ecor.barCaribbeanLuxury": "Caribbean luxury",
    "hotel.ecor.barTciAvg": "TCI tourism avg",
    "hotel.ecor.barThisHotel": "This hotel (current)",
    "hotel.ecor.benchmarkLine": "TCI-adjusted Caribbean luxury benchmark {amount} — you''re {delta}",
    "hotel.ecor.bestNights": "Best 3 nights ({month})",
    "hotel.ecor.betterBy": "{pct}% better",
    "hotel.ecor.compareHeading": "How does my ECOR compare?",
    "hotel.ecor.currentSeason": "{pct}% (current)",
    "hotel.ecor.dragHint": "Drag the occupancy slider above to see how load changes your position vs benchmarks.",
    "hotel.ecor.fullSeason": "{pct}% (full)",
    "hotel.ecor.industryBenchmarks": "Industry Benchmarks",
    "hotel.ecor.kwhPerGuestNight": "kWh/guest night",
    "hotel.ecor.lowSeason": "{pct}% (low season)",
    "hotel.ecor.occupancy": "Occupancy",
    "hotel.ecor.perRoomNight": "per occupied room-night",
    "hotel.ecor.renewableAvg": "% Renewable avg",
    "hotel.ecor.stubBody": "Available for hotel accounts only. Switch to Long Bay Reef Resort (P3).",
    "hotel.ecor.stubTitle": "ECOR Slider",
    "hotel.ecor.subtitle": "Energy Cost per Occupied Room-night",
    "hotel.ecor.titleSuffix": "Live Slider",
    "hotel.ecor.worstNights": "Worst 3 nights ({month})",
    "hotel.esg.actionHvacDetail": "Install sensors in each of the {suites} suites to auto-setback AC when rooms are vacant.",
    "hotel.esg.actionHvacSaving": "~8% HVAC energy",
    "hotel.esg.actionHvacTitle": "Occupancy-sensor HVAC",
    "hotel.esg.actionLedDetail": "Swap remaining 400 W metal-halide path lights to 40 W LED equivalents across all grounds.",
    "hotel.esg.actionLedSaving": "~3,200 kWh/month",
    "hotel.esg.actionLedTitle": "LED landscape upgrade",
    "hotel.esg.actionSolarDetail": "Replace electric resistance pool heaters with roof-mounted solar thermal collectors.",
    "hotel.esg.actionSolarSaving": "~15 kW demand reduction",
    "hotel.esg.actionSolarTitle": "Solar thermal pool heating",
    "hotel.esg.co2Avoided": "CO₂e Avoided",
    "hotel.esg.coreProgramme": "CORE programme",
    "hotel.esg.currentCycle": "Current cycle",
    "hotel.esg.energySummary": "Current Energy Summary",
    "hotel.esg.exportPdf": "Export PDF",
    "hotel.esg.generating": "Generating…",
    "hotel.esg.goalHeatPump": "Install heat-pump water heating in all {suites} suites",
    "hotel.esg.goalKwh": "Reduce kWh/guest-night below 35 by year-end",
    "hotel.esg.goalLeed": "Achieve LEED Silver certification by 2027",
    "hotel.esg.goalRenewable": "Reach 40% renewable share by 2027",
    "hotel.esg.goalsFootnote": "DOI Sustainability Goals programme — targets aligned to TCI Department of Environment",
    "hotel.esg.goalsHeading": "{year} Sustainability Goals",
    "hotel.esg.grossConsumption": "Gross consumption",
    "hotel.esg.industryAvg": "Industry avg {value}",
    "hotel.esg.industryAvgPct": "Industry avg {value}%",
    "hotel.esg.netBilled": "Net billed kWh",
    "hotel.esg.policyReferences": "Policy references",
    "hotel.esg.renewableLine": "Renewable (solar + grid green)",
    "hotel.esg.stubBody": "Available for hotel accounts only. Switch to Long Bay Reef Resort (P3).",
    "hotel.esg.stubTitle": "ESG Report",
    "hotel.esg.suggestedActions": "Suggested actions to improve your score",
    "hotel.esg.title": "ESG Energy Report",
    "hotel.esg.totalCost": "Total energy cost",
    "hotel.esg.uoreProgramme": "UORE programme",
    "hotel.esg.vsGridBaseline": "vs grid baseline",
    "hotel.kpi.ecor": "ECOR",
    "hotel.kpi.ecorSub": "per occupied room night",
    "hotel.kpi.kwhPerGuestNight": "kWh/Guest Night",
    "hotel.kpi.kwhPerGuestNightSub": "industry avg {value}",
    "hotel.kpi.pctRenewable": "% Renewable",
    "hotel.kpi.pctRenewableSub": "industry avg {pct}%",
    "hotel.kpi.peakDemand": "Peak Demand",
    "hotel.kpi.peakDemandSub": "threshold {kw} kW",
    "hotel.mobile.meterMainKitchen": "Main Kitchen",
    "hotel.mobile.meterPoolSpa": "Pool & Spa",
    "hotel.mobile.metersSummaryOne": "{name} · {count} meter",
    "hotel.mobile.metersSummaryOther": "{name} · {count} meters",
    "hotel.mobile.meterSuiteBlockA": "Suite Block A",
    "hotel.mobile.occupancyAtSync": "Occupancy at last sync · {pct}%",
    "hotel.mobile.openDashboardDesktop": "Open hotel dashboard on desktop",
    "hotel.mobile.propertyOverview": "Property overview",
    "hotel.mobile.topMeters": "Top meters this period",
    "hotel.portfolio.actionsAria": "Portfolio actions",
    "hotel.portfolio.anomalyBadge": "Anomaly",
    "hotel.portfolio.anomalyDetail": "+18% vs last MTD — brunch event",
    "hotel.portfolio.ecorSlider": "ECOR Live Slider",
    "hotel.portfolio.esgReport": "ESG Report",
    "hotel.portfolio.kpisHeading": "KPIs",
    "hotel.portfolio.loadShedPlaybook": "Load-Shed Playbook",
    "hotel.portfolio.metersHeading": "{count} Meters",
    "hotel.portfolio.nearPeakDemand": "Near peak demand",
    "hotel.portfolio.occupancyAria": "Occupancy {pct}% — drag the slider on the ECOR page",
    "hotel.portfolio.occupancyBadge": "{pct}% occupancy · drag →",
    "hotel.portfolio.payAllMeters": "Pay All {count} Meters",
    "hotel.portfolio.pctOfTotal": "{pct}% of total",
    "hotel.portfolio.projected": "projected",
    "hotel.portfolio.recentAlerts": "Recent Alerts",
    "hotel.portfolio.setDemandAlert": "Set Demand Alert",
    "hotel.portfolio.stubBody": "This view is only available for hotel accounts. Switch to Long Bay Reef Resort & Spa (P3) to see the portfolio dashboard.",
    "hotel.portfolio.stubTitle": "Hotel Portfolio",
    "hotel.portfolio.thisMonthToDate": "This month to date",
    "hotel.portfolio.viewDetails": "View details →",
    "hotel.portfolioLink": "Portfolio",
    "hurricane.activeAdvisory": "Active advisory",
    "hurricane.alertTitle": "⚠ Hurricane Warning",
    "hurricane.atlanticSeason": "Atlantic Season:",
    "hurricane.autoActivates": "Auto-activates when a storm approaches your service area.",
    "hurricane.callContactAria": "Call {name}",
    "hurricane.check": "Check",
    "hurricane.checklistCharger": "Portable phone charger",
    "hurricane.checklistFlashlights": "Flashlights + batteries",
    "hurricane.checklistFood": "Non-perishable food",
    "hurricane.checklistMedication": "Medication 7-day supply",
    "hurricane.checklistProgress": "{done}/{total} complete",
    "hurricane.checklistWater": "Water (2 gal × persons × 3 days)",
    "hurricane.connectivityBand": "Designed for the real Caribbean storm experience — offline-first storm mode on mobile and SMS fallback are on the delivery roadmap.",
    "hurricane.contactDdmeDetail": "Official emergency management authority",
    "hurricane.contactHospitalDetail": "Main hospital, Providenciales",
    "hurricane.contactHotlineDetail": "Storm preparedness and shelter information",
    "hurricane.contactOutageDetail": "Power outages and emergencies",
    "hurricane.emergencyContacts": "Emergency Contacts",
    "hurricane.etaLabel": "ETA",
    "hurricane.explorePrep": "Explore hurricane prep",
    "hurricane.genCriticalLoads": "Critical loads identified",
    "hurricane.genCriticalLoadsDetail": "Life-safety, kitchen cold-rooms, and guest elevators on generator circuits",
    "hurricane.generatorCoordination": "Generator Coordination",
    "hurricane.generatorIntro": "Hotel-specific pre-storm generator readiness for Long Bay Reef Resort.",
    "hurricane.genFuelLevel": "Fuel level",
    "hurricane.genFuelLevelDetail": "Minimum 72-hour reserve (target: 100% tank)",
    "hurricane.genMaintenanceLog": "Maintenance log updated",
    "hurricane.genMaintenanceLogDetail": "Last service date and next scheduled service on record",
    "hurricane.genManualTest": "Manual test run",
    "hurricane.genManualTestDetail": "Run main generator for 30 min under load",
    "hurricane.genTransferSwitch": "Transfer switch tested",
    "hurricane.genTransferSwitchDetail": "Verify automatic transfer within 10 seconds of mains failure",
    "hurricane.heading": "Storm-ready, always.",
    "hurricane.loadingStormMap": "Loading storm map…",
    "hurricane.offSeasonIntro": "Hurricane season runs Jun 1 – Nov 30. Pelican Energy TCI customers get a personalized prep mode, live storm tracker, prep checklist, emergency contacts, and post-storm restoration tracking.",
    "hurricane.offSeasonMessage": "Hurricane season runs 1 Jun – 30 Nov. Check back closer to the season.",
    "hurricane.openPrep": "Open hurricane prep",
    "hurricane.overline": "STORM-READY",
    "hurricane.preparedness": "Atlantic hurricane season runs Jun 1 – Nov 30. Keep your preparedness checklist up to date.",
    "hurricane.prepChargeDevices": "Charge all devices to 100%",
    "hurricane.prepChecklist": "Prep checklist",
    "hurricane.prepChecklistTitle": "Prep Checklist",
    "hurricane.prepFillBathtub": "Fill bathtub with water",
    "hurricane.prepFillCoolers": "Fill coolers with ice",
    "hurricane.prepIdentifyShelter": "Identify your shelter location",
    "hurricane.prepIdentifyShelterDetail": "Government TCI shelter list: gov.tc/dcr",
    "hurricane.prepLocateFlashlights": "Locate flashlights and batteries",
    "hurricane.prepModeLink": "Prep Mode →",
    "hurricane.prepModeTitle": "Hurricane Prep Mode",
    "hurricane.prepMoveFurniture": "Move outdoor furniture inside",
    "hurricane.prepRefillPrescriptions": "Refill prescriptions",
    "hurricane.prepSecureDocuments": "Secure important documents in waterproof bag",
    "hurricane.prepSecureDocumentsDetail": "Passports, insurance, property deeds",
    "hurricane.prepStockFood": "Stock 3 days of non-perishable food and water",
    "hurricane.prepStockFoodDetail": "1 gallon of water per person per day",
    "hurricane.prepTestGenerator": "Test backup generator",
    "hurricane.prepTestGeneratorDetail": "Run for 15 min; check fuel level and transfer switch",
    "hurricane.projectedTrack": "{name} — projected track",
    "hurricane.reEnableAlerts": "Re-enable in Settings to send hurricane alerts.",
    "hurricane.sampleChecklist": "Sample prep checklist",
    "hurricane.seasonActive": "Hurricane season",
    "hurricane.seasonActiveBadge": "Season Active",
    "hurricane.seasonDates": "Jun 1 – Nov 30",
    "hurricane.seasonIndicator": "Hurricane season indicator",
    "hurricane.seeFullChecklist": "See full checklist →",
    "hurricane.seeFullTracker": "See full storm tracker →",
    "hurricane.shelterDept": "Department of Disaster Management & Emergencies",
    "hurricane.shelterRegister": "Official TCI Shelter Register",
    "hurricane.stormApproaching": "{name} approaching · ETA {eta}",
    "hurricane.stormBannerMessage": "Hurricane Season Active — {name} approaching Provo, ETA {eta}. Tap for prep mode.",
    "hurricane.stormEta": "ETA:",
    "hurricane.stormName": "Name:",
    "hurricane.stormTracker": "Storm tracker",
    "hurricane.trackerAria": "Storm tracker map showing projected path of {name}",
    "hurricane.trackerDisclaimer": "Synthesized track for demo purposes only — not live NHC data.",
    "hurricane.uncheck": "Uncheck",
    "hurricane.viewChecklist": "View checklist →",
    "hurricane.viewFullChecklist": "View full checklist (12 items) →",
    "hurricane.viewOutageMap": "View outage map",
    "insights.cta.claimCredit": "Claim credit",
    "insights.cta.scheduleTechnician": "Schedule technician",
    "insights.cta.tellMeMore": "Tell me more",
    "insights.cta.viewDetail": "View detail",
    "insights.duration.hoursMinutes": "{hours} hr {minutes} min",
    "insights.duration.hoursOnly": "{hours} hr",
    "insights.duration.minutesOnly": "{minutes} min",
    "insights.leadFigure.kwhPerDay": "{value} kWh/day",
    "insights.p1OutageSpoilage.body": "Bight Park feeder outage on {date} — you may qualify for spoilage credit up to $25.",
    "insights.p1SolarApril.body": "in solar export credit this cycle — your best on record (38% of usage offset).",
    "insights.p1UsageTrend.body": "usage this cycle vs last — mostly weekend AC overnight (12% above weekday average).",
    "insights.p2DiveDayCost.body": "average electricity cost per dive day this cycle — air compressor cycle is your biggest line.",
    "insights.p2GrandTurkFuel.body": "Grand Turk fuel factor this month — slightly below Provo's 0.1564 due to fuel-shipment timing.",
    "insights.p2WeeklyPattern.body": "Tue/Wed usage bump every week — likely tank-fill compressor runs after weekend dives.",
    "insights.p3DemandNearMiss.body": "Peak demand last Wednesday — deferring laundry to 2–6 AM could prevent the next threshold breach.",
    "insights.p3EsgOffset.body": "of this cycle's usage offset by your 80 kW CORE solar — the TCI luxury benchmark is 12%, and the board-approved +200 kW closes the gap.",
    "insights.p3KitchenAnomaly.body": "Kitchen & F&B meter Tue–Thu {recency} — matches the brunch event on your calendar.",
    "insights.p4PortfolioTrend.body": "portfolio usage this cycle vs last (5,568 vs 5,580 kWh) — seasonal-steady across 4 properties; the Sea Breeze anomaly is the one exception.",
    "insights.p4SandyCoveSavings.body": "Villa Sandy Cove run-rate vs the pre-audit baseline — a tenant-turnover meter audit caught a 24/7 well pump.",
    "insights.p4VillaAnomaly.body": "Villa Sea Breeze during 2-week vacancy — possible always-on equipment, water heater suspected.",
    "insights.recencyLastWeek": "last week",
    "install.androidCta": "Download .apk",
    "install.androidDesc": "Real native app. Scan to download the latest .apk and sideload on Android.",
    "install.browserCta": "Continue to preview →",
    "install.browserDesc": "Full web experience on any device. Recommended for desktop.",
    "install.gotIt": "Got it",
    "install.iphoneDesc": "Scan with your iPhone camera, then tap ‘Add to Home Screen’ in Safari.",
    "install.iphoneModalLabel": "Install on iPhone",
    "install.iphoneModalTitle": "Add to iPhone Home Screen",
    "install.iphoneSteps": "View step-by-step instructions",
    "install.step1Open": "Open",
    "install.step1Safari": "in Safari on your iPhone.",
    "install.step2Share": "Share",
    "install.step2TapThe": "Tap the",
    "install.step2Toolbar": "button (box with arrow) in the Safari toolbar.",
    "install.step3AddHome": "“Add to Home Screen”",
    "install.step3ScrollTap": "Scroll down and tap",
    "install.step4Add": "Add",
    "install.step4Confirm": "to confirm. The Pelican icon appears on your home screen.",
    "install.step4Tap": "Tap",
    "install.tablistLabel": "Install path",
    "landing.backToTop": "Back to top",
    "latest.ariaLabel": "Latest news from Pelican Energy TCI",
    "latest.heading": "Latest from Pelican Energy TCI",
    "latest.more": "More from Pelican Energy TCI",
    "more.aiAssistant": "Pelican Assistant",
    "more.changeLanguageAria": "Change language. Current: {name}",
    "more.sectionAccount": "Switch property",
    "more.sectionLanguage": "Language",
    "more.sectionNavigate": "Navigate",
    "more.sectionPersona": "Persona",
    "more.sectionSession": "Session",
    "more.sectionShortcuts": "Shortcuts",
    "more.signOut": "Sign out",
    "more.tapToCycle": "Tap to cycle",
    "more.viewAccountAria": "View property {name}",
    "nav.account": "Account",
    "nav.bill": "Bill",
    "nav.home": "Home",
    "nav.menu": "Menu",
    "nav.outageMap": "Outage Map",
    "nav.pay": "Pay",
    "nav.report": "Report",
    "nav.services": "Services",
    "nav.support": "Support",
    "notifications.allShown": "All notifications",
    "notifications.ariaOne": "Notifications ({count} unread)",
    "notifications.ariaOther": "Notifications ({count} unread)",
    "notifications.close": "Close notifications",
    "notifications.markAll": "Mark all as read",
    "notifications.title": "Notifications",
    "outage.activeIncidentsOne": "{count} active incident",
    "outage.activeIncidentsOther": "{count} active incidents",
    "outage.activeOutagesOne": "{count} active outage",
    "outage.activeOutagesOther": "{count} active outages",
    "outage.advanceState": "Advance state (demo) →",
    "outage.affected": "{count} affected",
    "outage.allNormal": "All systems normal",
    "outage.backToMap": "Outage map",
    "outage.closeDetail": "Close outage details",
    "outage.crew": "Crew",
    "outage.crewNotDispatched": "Crew not yet dispatched",
    "outage.crewOnSite": "Crew on site — 2 technicians, Truck #14",
    "outage.crewStatus": "Crew Status",
    "outage.customersAffected": "{count} customers affected",
    "outage.customersCountOne": "{count} customer",
    "outage.customersCountOther": "{count} customers",
    "outage.detailAria": "Outage details — {circuit}",
    "outage.dismissReportAria": "Dismiss outage report success",
    "outage.distanceKm": "{km} km",
    "outage.distanceToSite": "Distance to site",
    "outage.eta": "ETA",
    "outage.getNotified": "Get notified when restored",
    "outage.lastUpdate": "Last update",
    "outage.legendActiveEtaSet": "Active — ETA set",
    "outage.legendActiveNoEta": "Active — no ETA",
    "outage.legendHide": "Hide map legend",
    "outage.legendResolved": "Resolved",
    "outage.legendScheduled": "Scheduled",
    "outage.legendShow": "Show map legend",
    "outage.legendTitle": "Legend",
    "outage.listAria": "Outage list",
    "outage.listView": "List view",
    "outage.loadingMap": "Loading map…",
    "outage.mapAppAria": "TCI outage map",
    "outage.mapTitle": "Outage Map",
    "outage.mapView": "Map view",
    "outage.metaAffected": "Affected",
    "outage.metaCause": "Cause",
    "outage.metaCircuit": "Circuit",
    "outage.metaReported": "Reported",
    "outage.minAgo": "{min} min ago",
    "outage.moduleHeading": "Outages & storm readiness",
    "outage.notFound": "Outage not found.",
    "outage.notifPushBody": "{circuit} is back online. Your service should be active.",
    "outage.notifPushTitle": "Power restored",
    "outage.notifReEnable": "Re-enable in Settings to subscribe to outage updates.",
    "outage.notifyConfirm": "You'll be notified when power is restored. (Demo: arrives in 5 s.)",
    "outage.notifySubtitle": "Get a notification when your power is back",
    "outage.notifyTitle": "Notify when restored",
    "outage.notifyToggleAria": "Toggle outage restore notification",
    "outage.pinAria": "{status} outage — {circuit}",
    "outage.prepModeActive": "Preparedness mode active · ETA {eta}",
    "outage.recentUpdates": "Recent Updates",
    "outage.reporter.confirmingSubmit": "Reporting…",
    "outage.reporter.dismiss": "Dismiss",
    "outage.reporter.idleSubmit": "Report Now",
    "outage.reporter.idleTitle": "Power out at your location?",
    "outage.reporter.reference": "Reference",
    "outage.reporter.submittedSuffix": "We'll notify you when crews are dispatched.",
    "outage.reporter.submittedTitle": "Outage reported — thank you",
    "outage.reportOutage": "Report an outage →",
    "outage.scheduled": "Scheduled",
    "outage.serviceLocationAria": "Your service location",
    "outage.simulatedStatus": "Simulated circuit status across eight islands.",
    "outage.started": "Started {date}",
    "outage.statusTimeline": "Status timeline",
    "outage.step.crewDispatched": "Crew dispatched",
    "outage.step.investigating": "Investigating",
    "outage.step.received": "Received by dispatch",
    "outage.step.resolved": "Power restored",
    "outage.step.restoring": "Restoring power",
    "outage.step.submitted": "Report submitted",
    "outage.stepCurrent": "current",
    "outage.stormLabel": "Storm {name}",
    "outage.subscribed": "Subscribed — we'll notify you when power is restored",
    "outage.timeline.crewDispatched": "Crew Dispatched",
    "outage.timeline.investigating": "Investigating",
    "outage.timeline.received": "Received",
    "outage.timeline.resolved": "Resolved",
    "outage.timeline.restoring": "Restoring",
    "outage.timeline.submitted": "Submitted",
    "outage.timelineAria": "Outage progress timeline",
    "outage.timelineTitle": "Timeline",
    "outage.viewLatest": "View latest outage",
    "outage.viewMap": "View the outage map →",
    "outage.viewTimeline": "View full timeline",
    "outage.yourCircuit": "Your circuit",
    "outageStatus.activeNoEta": "Active — no ETA",
    "outageStatus.activeWithEta": "Active — crew en route",
    "outageStatus.resolved": "Resolved",
    "outageStatus.scheduled": "Scheduled maintenance",
    "pay.accountLabel": "Account #{account}",
    "pay.addMethod": "+ Add new method",
    "pay.amountExceedsBalance": "That's more than your current balance of {amount}.",
    "pay.amountOptionsLegend": "Payment amount options",
    "pay.amountProcessed": "{amount} has been processed.",
    "pay.batchPayAll": "Batch Pay All",
    "pay.cancel": "Cancel",
    "pay.cancelAria": "Cancel payment",
    "pay.confirmation": "Confirmation #",
    "pay.confirmBatchPayment": "Confirm Batch Payment",
    "pay.confirmBiometric": "Confirm with Face ID / fingerprint",
    "pay.confirmPayment": "Confirm Payment",
    "pay.confirmTitle": "Confirm payment",
    "pay.copyConfirmation": "Copy confirmation number",
    "pay.customAmount": "Custom amount",
    "pay.customAmountLabel": "Custom amount in USD",
    "pay.dismiss": "Dismiss",
    "pay.doneReturnDashboard": "Done — Return to Dashboard",
    "pay.emailReceipt": "Email receipt",
    "pay.enterCustomAmountAria": "Enter custom amount",
    "pay.expires": "Expires {expiry}",
    "pay.fullBalance": "Full balance",
    "pay.identityVerified": "Identity verified",
    "pay.lastMonth": "Last month",
    "pay.lastPayment": "Last payment",
    "pay.makePayment": "Make a payment",
    "pay.masterConfirmation": "Master confirmation #",
    "pay.memoValue": "Bill payment — {month}",
    "pay.meterLabel": "Meter {id}",
    "pay.methodAria": "{brand} ending {last4}",
    "pay.monthsAgo": "{count} months ago",
    "pay.newBalance": "New balance: {amount} — updated on next bill cycle",
    "pay.noMethod": "No payment method on file.",
    "pay.noRecentPayments": "No recent payments",
    "pay.onFile": "On file",
    "pay.paidInFull": "Paid in full",
    "pay.paidInFullBody": "This account is paid in full — nothing due right now.",
    "pay.payFullAmountAria": "Pay full amount {amount}",
    "pay.payInFull": "Pay in full",
    "pay.paymentArrangement": "Set up a payment arrangement",
    "pay.paymentMethodTitle": "Payment method",
    "pay.paymentProcessed": "Your payment has been processed.",
    "pay.paymentSuccessful": "Payment successful!",
    "pay.payOnlyMeter": "Pay only this meter",
    "pay.payOther": "Pay other amount",
    "pay.paySpecificBills": "Pay specific bills",
    "pay.perAccountConfirmations": "Per-account confirmations",
    "pay.plannedForDelivery": "Planned for delivery",
    "pay.processing": "Processing your payment…",
    "pay.processingAria": "Processing payment",
    "pay.processingSubtitle": "Please do not close this page",
    "pay.processingTitle": "Processing your payment",
    "pay.progressLabel": "Payment progress",
    "pay.recentBatch": "Recent batch payments",
    "pay.retry": "Retry",
    "pay.retryAria": "Retry payment",
    "pay.securedDisclaimer": "Secured · Preview prototype — no real payment processed",
    "pay.selectAmount": "Select payment amount",
    "pay.selectMethod": "Select payment method",
    "pay.smsReceipt": "SMS receipt",
    "pay.stepAmount": "Select Amount",
    "pay.stepConfirm": "Confirm",
    "pay.stepDone": "Done",
    "pay.stepMethod": "Select Method",
    "pay.stepProcessing": "Processing",
    "pay.summaryAccount": "Account",
    "pay.summaryAmount": "Amount",
    "pay.summaryMemo": "Memo",
    "pay.summaryMethod": "Payment method",
    "pay.title": "Pay now",
    "pay.total": "Total",
    "pay.underThresholdNote": "Batch totals under {amount} skip the step-up biometric verification.",
    "pay.verifyBiometrics": "Verify with biometrics (mocked)",
    "pay.verifying": "Verifying…",
    "pay.whyNoBankAria": "Why no real payment gateway?",
    "pay.whyNoBankBody": "Gateway is mocked per the preview security posture. Production integration would require PCI-DSS scope and live banking credentials — out of scope for this preview.",
    "pay.whyNoBankTitle": "Why no real bank connection?",
    "payStatus.confirmed": "Confirmed",
    "payStatus.failed": "Failed",
    "payStatus.pending": "Pending",
    "persona.lockedAria": "Persona switching disabled during payment",
    "persona.lockedHint": "Finish payment to switch",
    "persona.switchAria": "Switch persona",
    "persona.switchTo": "Switch to {name}",
    "pm.accountDetails": "Account details",
    "pm.accountNotFound": "Account not found.",
    "pm.actions.makeRequest": "Make a Request",
    "pm.actions.payBill": "Pay Bill",
    "pm.actions.reportOutage": "Report Outage",
    "pm.actions.viewBill": "View Bill",
    "pm.allAccountsCount": "All properties ({count})",
    "pm.anomaly.actionHvac": "Review HVAC scheduling program via smart-thermostat portal",
    "pm.anomaly.actionTenant": "Contact tenant to confirm occupancy pattern change",
    "pm.anomaly.actionThermostat": "Inspect hot-water heater thermostat — schedule technician",
    "pm.anomaly.allOthersNormal": "All other accounts are within normal range.",
    "pm.anomaly.badgeSummary": "+18% week-over-week vs same week last year",
    "pm.anomaly.causeHeaterDetail": "Circuit {meter} draw elevated by 8 kWh/day since Apr 28 — possible thermostat fault [metering]",
    "pm.anomaly.causeHeaterTitle": "Hot-water heater overrun",
    "pm.anomaly.causeHvacDetail": "A/C runtime increased 22% since March — scheduling program may have reset after April power interruption [metering]",
    "pm.anomaly.causeHvacTitle": "HVAC scheduling drift",
    "pm.anomaly.causeTenantDetail": "Account shows 2 tenant turnover events over the past year [CIS record]",
    "pm.anomaly.causeTenantTitle": "Tenant change — new occupancy pattern",
    "pm.anomaly.dailyKwh": "Daily kWh — last 7 days",
    "pm.anomaly.dayFri": "Fri",
    "pm.anomaly.dayMon": "Mon",
    "pm.anomaly.daySun": "Sun",
    "pm.anomaly.elevated": "Energy use elevated",
    "pm.anomaly.likelyCauses": "Likely causes",
    "pm.anomaly.recentAnomalies": "Recent anomalies in your portfolio",
    "pm.anomaly.recentBadge": "+18% wk-over-wk",
    "pm.anomaly.recentDate": "This month",
    "pm.anomaly.scheduleTechnician": "Schedule technician visit",
    "pm.anomaly.subtitle": "{property} · Account #{account}",
    "pm.anomaly.suggestedActions": "Suggested actions",
    "pm.anomaly.title": "Energy anomaly",
    "pm.breadcrumbAria": "Breadcrumb",
    "pm.dueDate": "due {date}",
    "pm.managedAccountsAria": "Managed properties",
    "pm.managedProperties": "{count} managed properties",
    "pm.metaAccountNum": "Account #",
    "pm.metaAddress": "Address",
    "pm.metaLastMonthUsage": "Last month usage",
    "pm.metaMeters": "Meters",
    "pm.meterCountOne": "{count} meter",
    "pm.meterCountOther": "{count} meters",
    "pm.portfolio": "Portfolio",
    "pm.portfolioView": "Portfolio view",
    "pm.portfolioViewP4Only": "This view is available for the property manager persona (P4).",
    "pm.property": "Property",
    "pm.quickActionsAria": "Quick actions",
    "pm.selectAccount": "Select property",
    "pm.statusNormal": "Normal",
    "pm.switchAccount": "Switch property:",
    "pm.switchAria": "Switch to another managed property",
    "pm.thBalance": "Balance",
    "pm.thisMonth": "This Month",
    "pm.thStatus": "Status",
    "pm.thUsage": "Usage",
    "pm.usage": "usage",
    "pm.vacant": "Vacant",
    "pm.vacantAnomaly.guidance": "This may indicate a plumbing leak, appliance fault, or unauthorised occupancy. Consider scheduling an on-site inspection.",
    "pm.vacantAnomaly.markedVacant": "{property} is marked vacant.",
    "pm.vacantAnomaly.title": "Vacant property anomaly detected",
    "pm.viewPropertyAria": "View {name}",
    "publicNav.about": "About",
    "publicNav.askPelican": "Ask Pelican",
    "publicNav.enterPreview": "Enter the preview",
    "publicNav.help": "Help",
    "publicNav.home": "Home",
    "publicNav.hurricane": "Hurricane",
    "publicNav.sectionNavLabel": "Page sections",
    "publicNav.status": "Status",
    "report.attachPhoto": "Attach a photo (optional)",
    "report.availableNow": "Available now",
    "report.descriptionLabel": "Description (optional)",
    "report.descriptionPlaceholder": "e.g. Light flickering, completely out, broken glass",
    "report.enterPoleNumber": "Enter Pole Number",
    "report.mapAreaAria": "Map area — tap to drop a pin on the faulty streetlight",
    "report.mapRoadLabel": "Leeward Hwy",
    "report.outageDescription": "Drop a pin on the map or pick your address; track restoration in real-time.",
    "report.outageName": "Report a Power Outage",
    "report.photoFilename": "streetlight-photo.jpg",
    "report.photoUploaded": "1.2 MB · Uploaded just now",
    "report.pinPlaced": "Pin placed near Leeward Highway",
    "report.poleNumber": "Pole Number",
    "report.poleNumberHint": "Look for the number stamped or tagged on the metal post (e.g. TCI-4821)",
    "report.poleNumberPlaceholder": "e.g. TCI-4821",
    "report.reference": "Reference",
    "report.reportNow": "Report now →",
    "report.slSubmittedTitle": "Report Submitted",
    "report.slSubtitle": "Tap the light on the map OR enter the pole number printed on the post.",
    "report.slTitle": "Report a Faulty Streetlight",
    "report.submitReport": "Submit Report",
    "report.subtitle": "What kind of issue are you reporting? Tap an option below — we'll route you to the right form.",
    "report.tapFaultyLight": "Tap the faulty streetlight on the map",
    "report.tapOnMap": "Tap on Map",
    "report.tapToDropPin": "Tap to drop a pin on the faulty light",
    "report.title": "Report an Issue",
    "report.trackRequests": "Track My Requests",
    "report.viewDetails": "View details →",
    "services.allServices": "All Services",
    "services.backToServices": "Back to Services",
    "services.backToServicesAria": "Back to services",
    "services.continue": "Continue",
    "services.dcAttachPrompt": "Tap to attach repair quote (PDF, JPG)",
    "services.dcAttachQuotes": "Attach Repair Quotes",
    "services.dcAuthorize": "I confirm this claim is accurate and understand that false claims may result in denial and account action per Pelican Energy TCI terms of service.",
    "services.dcClaimReference": "Claim Reference",
    "services.dcClaimSubmitted": "Claim Submitted",
    "services.dcDescribeLabel": "Describe the damaged equipment or property",
    "services.dcDescribePlaceholder": "e.g. HVAC compressor, refrigerator, TV — describe damage and estimated repair cost",
    "services.dcIntro": "Submit within 10 days of the outage. Decision in 15 business days.",
    "services.dcNeedHelp": "Need help?",
    "services.dcOutageDate": "Outage Date",
    "services.dcOutageDateValue": "Your outage date",
    "services.dcQuoteFilename": "repair-quote.pdf",
    "services.dcQuoteSize": "180 KB",
    "services.dcReceivedMsg": "Your damage claim has been received. Decision within 15 business days.",
    "services.dcSubmit": "Submit Damage Claim",
    "services.dcTitle": "Damage Claim",
    "services.dcViewProcess": "View the claims process on pelicanenergytci.com",
    "services.districtArea": "District / Area",
    "services.newRequest": "New Request",
    "services.noRequests": "No service requests yet.",
    "services.serviceAddress": "Service Address",
    "services.serviceNotFound": "Service not found.",
    "services.sstAddressSubConfirm": "Confirm your current service address",
    "services.sstAddressSubStart": "Enter the address where you need service",
    "services.sstAuthConfirm": "I confirm the information provided is accurate and authorize Pelican Energy TCI to process this request. I understand that false information may delay processing.",
    "services.sstAuthSubtitle": "Review and authorize your service request.",
    "services.sstConfirmSubtitle": "Your service request has been received and is being processed.",
    "services.sstConfirmTitle": "Request Submitted",
    "services.sstDateNote": "Pelican Energy TCI will confirm the exact processing date within 1 business day.",
    "services.sstDateSubtitle": "When should this change take effect? Minimum 2 business days from today.",
    "services.sstDistrictPlaceholder": "The Bight, Providenciales",
    "services.sstDocFilename": "passport-scan.pdf",
    "services.sstDocFormats": "PDF, JPG, or PNG · Max 10 MB",
    "services.sstDocPrompt": "Tap to select a file",
    "services.sstDocSize": "245 KB · Uploaded just now",
    "services.sstDocsSubtitle": "Upload a valid photo ID and proof of property ownership or tenancy.",
    "services.sstDocsTitle": "Supporting Documents",
    "services.sstEffectiveValue": "your selected start date",
    "services.sstExpectedCompletion": "Expected completion: 5–7 business days",
    "services.sstNewAddress": "New Address",
    "services.sstNewDistrictPlaceholder": "District, Island",
    "services.sstNewStreetPlaceholder": "Enter new address",
    "services.sstOptStartDesc": "Moving into a property that needs a new connection",
    "services.sstOptStartLabel": "Start new service",
    "services.sstOptStopDesc": "Moving out and need to close the account",
    "services.sstOptStopLabel": "Stop existing service",
    "services.sstOptTransferDesc": "Moving to a new address and want to keep your account",
    "services.sstOptTransferLabel": "Transfer service",
    "services.sstReferenceNumber": "Reference Number",
    "services.sstReqStop": "Stop service",
    "services.sstRequestedDate": "Requested Date",
    "services.sstSelectedDate": "Your selected date",
    "services.sstStepAddress": "Address",
    "services.sstStepAuthorize": "Authorization",
    "services.sstStepConfirmation": "Confirmation",
    "services.sstStepDate": "Effective Date",
    "services.sstStepDocuments": "Documents",
    "services.sstStepType": "Request Type",
    "services.sstStreetPlaceholder": "14 Bight Park Lane",
    "services.sstSubmit": "Submit Request",
    "services.sstSummaryAccount": "Account:",
    "services.sstSummaryAddress": "Address:",
    "services.sstSummaryEffective": "Effective:",
    "services.sstSummaryRequest": "Request:",
    "services.sstTypeSubtitle": "Start, stop, or transfer your electricity service — no office visit required.",
    "services.sstTypeTitle": "What would you like to do?",
    "services.sstUploadAria": "Upload a document",
    "services.startNewRequest": "Start a new request →",
    "services.startRequest": "Start a request",
    "services.streetAddress": "Street Address",
    "services.subtitle": "Request a service change, submit forms, or file a claim — we handle the paperwork so you don't need to visit the office.",
    "services.title": "Services",
    "services.track": "Track ({count})",
    "services.trackAria": "Track requests ({count} active)",
    "services.trackSubtitle": "View the status of your service requests, claims, and account changes.",
    "services.trackTitle": "Track My Requests",
    "serviceStatus.activeOutages": "{count} active outages",
    "serviceStatus.allNormal": "All systems normal across all eight islands",
    "serviceStatus.eta": "ETA {eta}",
    "serviceStatus.hurricanePrep": "Hurricane prep",
    "serviceStatus.lastRestoration": "Last restoration: more than 24 hours ago · Service operating normally",
    "serviceStatus.outagesAcross": "{count} active outages across {islandCount} islands",
    "serviceStatus.stormApproaching": "{name} approaching",
    "serviceStatus.viewMap": "View map",
    "serviceStatus.viewOutageMap": "View outage map →",
    "serviceStatus.yourService": "Your service ({island}): check map",
    "serviceStatus.yourServiceNormal": "Your service in {island}: normal · No active outages",
    "signin.biometricAria": "Sign in with biometrics",
    "signin.biometricButton": "Sign in with Face ID / fingerprint",
    "signin.biometricCancel": "Use password instead",
    "signin.biometricFallback": "Use password",
    "signin.biometricNotEnrolledBody": "Please set up Face ID or fingerprint in Settings, or sign in with email and password.",
    "signin.biometricNotEnrolledTitle": "No biometric enrolled",
    "signin.biometricPrompt": "Sign in to Pelican Energy TCI",
    "signin.biometricUnavailableBody": "This device does not support biometric authentication.",
    "signin.biometricUnavailableTitle": "Biometric not available",
    "signin.continueAs": "Continue as {name} →",
    "signin.credentialsHint": "Any email and password work in the preview.",
    "signin.emailLabel": "Email address",
    "signin.emailPlaceholder": "your@email.com",
    "signin.errorEmpty": "Please enter your email and password.",
    "signin.heading": "Sign in",
    "signin.hide": "Hide",
    "signin.hidePasswordAria": "Hide password",
    "signin.orChooseDifferent": "Or choose a different persona",
    "signin.passwordLabel": "Password",
    "signin.quickPickTitle": "Quick-pick persona (presenter shortcut)",
    "signin.show": "Show",
    "signin.showPasswordAria": "Show password",
    "signin.signInAsAria": "Sign in as {name}",
    "signin.signInButton": "Sign in",
    "signin.signingIn": "Signing in…",
    "signin.subtitle": "Choose a persona to enter the preview — or use any email and password.",
    "signin.subtitlePreview": "Customer self-service · Preview",
    "signin.useCredentials": "Or sign in with email + password",
    "signin.welcomeBack": "Welcome back, {name}",
    "srDetail.completed": "Completed {date}",
    "srDetail.decisionBy": "Decision by {date}",
    "srDetail.expectedBy": "Expected by {date}",
    "srDetail.received": "Received {date}",
    "srStatus.comingSoon": "Coming soon",
    "srStatus.completed": "Completed",
    "srStatus.inProgress": "In Progress",
    "srStatus.inReview": "Under Review",
    "srStatus.received": "Received",
    "srType.accountUpdate": "Account Update",
    "srType.damageClaim": "Damage Claim",
    "srType.duskToDawnLight": "Dusk-to-Dawn Light",
    "srType.outageReport": "Outage Report",
    "srType.startService": "Start Service",
    "srType.stopService": "Stop Service",
    "srType.streetlightReport": "Streetlight Report",
    "srType.transferService": "Transfer Service",
    "stubs.accountClosure.description": "Permanently close your service account when moving out, with final-bill summary and refund-of-deposit workflow.",
    "stubs.accountClosure.name": "Close My Account",
    "stubs.accountClosure.why": "Closing an account runs the same final-reading and settlement checks as a transfer, so it follows once that flow is settled.",
    "stubs.accountUpdate.description": "Update your contact info, mailing address, and communication preferences.",
    "stubs.accountUpdate.name": "Account Update",
    "stubs.accountUpdate.why": "Keeping your contact details current is basic to everything else, so it shipped in the first release.",
    "stubs.applyNewService.description": "Request a new electricity service connection at a property — initial application, supporting documents, schedule connection date.",
    "stubs.applyNewService.link": "Current form on pelicanenergytci.com",
    "stubs.applyNewService.name": "Apply for New Service",
    "stubs.applyNewService.why": "Connecting a brand-new property needs a site visit booked and tracked — we're building that scheduling step next.",
    "stubs.autopay.description": "Set up automatic payment of your monthly bill from a saved card.",
    "stubs.autopay.name": "Autopay",
    "stubs.autopay.why": "Storing a card safely enough to charge it automatically needs bank-grade protection, which we're putting in place.",
    "stubs.availableNow": "Available now",
    "stubs.comingTitle": "Coming",
    "stubs.comingWhen": "Coming {when}",
    "stubs.damageClaims.description": "Submit a claim for damage caused by an outage — within 10 days, with repair quotes attached. Decision in 15 business days.",
    "stubs.damageClaims.link": "Current process on pelicanenergytci.com",
    "stubs.damageClaims.name": "Damage Claims",
    "stubs.damageClaims.why": "The claims process already existed — we brought it into the app so you don't have to go looking for it.",
    "stubs.duskToDawn.description": "Request installation or replacement of a residential street-side light, including quantity needed and location.",
    "stubs.duskToDawn.name": "Apply for Dusk-to-Dawn Light",
    "stubs.duskToDawn.why": "We're finishing the most-used requests first. This one needs a form that captures how many lights you need and exactly where.",
    "stubs.feedback.description": "Your feedback helps shape what we build next for Pelican Energy TCI customers.",
    "stubs.feedback.name": "Send Feedback",
    "stubs.feedback.why": "We want to hear what's working and what isn't while the app is still taking shape.",
    "stubs.hazard.description": "Downed power line, exposed wires, hazardous tree-on-line, or other safety concern. Photo upload supported.",
    "stubs.hazard.name": "Report a Hazard",
    "stubs.hazard.why": "We're building the photo upload and the direct line to field crews that a safety report depends on.",
    "stubs.liveChat.description": "Real-time chat with a Pelican Energy TCI customer-service agent during business hours.",
    "stubs.liveChat.name": "Live Chat with Pelican Energy TCI Support",
    "stubs.liveChat.why": "Live chat only helps if someone is always there to answer, so we're getting the support desk ready first.",
    "stubs.meterTools.description": "Submit a self-read of your meter when an automated read isn’t available, or see the energy mix powering your address.",
    "stubs.meterTools.name": "Meter Tools",
    "stubs.meterTools.why": "These tools need a live link to your meter, and we're confirming how prepaid meters fit in.",
    "stubs.notifications.description": "Choose delivery channels (Email, SMS, Push) and set quiet hours for each notification type.",
    "stubs.notifications.name": "Notification Channels & Quiet Hours",
    "stubs.notifications.why": "Sending texts and emails reliably — and remembering exactly which ones you want — is the piece we're building now.",
    "stubs.notifyAlert": "We''ll notify you when {name} is available.",
    "stubs.notifyMe": "Notify me when ready",
    "stubs.notifyMeAria": "Notify me when {name} is ready",
    "stubs.ownersConsent.description": "Authorize a service change on a property you own when the occupant is making the request — with signature capture.",
    "stubs.ownersConsent.name": "Submit Owner’s Consent",
    "stubs.ownersConsent.why": "This one needs secure signature capture in the app before we can accept it.",
    "stubs.personalGuarantee.description": "Provide a personal guarantee for a service connection or upgrade where Pelican requires one.",
    "stubs.personalGuarantee.name": "Submit Personal Guarantee",
    "stubs.personalGuarantee.why": "It needs the same secure signature step as Owner's Consent, so the two arrive together.",
    "stubs.powerLineClearance.description": "SafeMoves (moving heavy equipment), High-Load (oversized vehicle), Line Locate (digging) — request safety clearance from Pelican Energy TCI.",
    "stubs.powerLineClearance.link": "SafeMoves on pelicanenergytci.com",
    "stubs.powerLineClearance.name": "Power Line Clearance Forms",
    "stubs.powerLineClearance.why": "Clearance work involves your contractor as well as you — we're getting the requests you make on your own right first.",
    "stubs.shareBill.description": "Send a copy of this bill as proof of address — via email, WhatsApp, or printable PDF.",
    "stubs.shareBill.name": "Share Bill",
    "stubs.shareBill.why": "Sharing a bill as proof of address means generating a clean PDF and handing it to WhatsApp or email — that's what we're building.",
    "stubs.startStopTransfer.description": "Move into a property, close an account, or transfer service to a new address — all from your phone, no office visit needed.",
    "stubs.startStopTransfer.link": "Current form on pelicanenergytci.com",
    "stubs.startStopTransfer.name": "Start, Stop, or Transfer Service",
    "stubs.startStopTransfer.why": "Moving home is the request we hear most, so it was the first thing we built.",
    "stubs.streetlight.description": "Tap the streetlight on the map OR enter the pole number stamped on the post.",
    "stubs.streetlight.name": "Report a Faulty Streetlight",
    "stubs.streetlight.why": "Reporting a dark street should take seconds, so we started with the map and the pole-number lookup.",
    "stubs.upgradeExtend.description": "Request a capacity upgrade (e.g. single-phase to 3-phase, increased amperage) or grid extension to a remote property.",
    "stubs.upgradeExtend.name": "Upgrade Service or Grid Extension",
    "stubs.upgradeExtend.why": "An upgrade needs an engineering survey of your supply before anyone can quote it. We're working out how to book that from the app.",
    "stubs.vacationMode.description": "Let Pelican know when you're away — we'll watch for unusual usage and alert you.",
    "stubs.vacationMode.name": "Vacation Mode",
    "stubs.vacationMode.why": "Plenty of homes here sit empty for part of the year, so this was worth building early.",
    "stubs.viewDetails": "View details →",
    "stubs.voiceAlexa.description": "Ask Alexa: ‘What’s my Pelican balance?’ / ‘Report a power outage.’",
    "stubs.voiceAlexa.name": "Amazon Alexa Voice Integration",
    "stubs.voiceAlexa.why": "We're asking customers whether voice is something they'd actually use before we build it.",
    "stubs.whyLater": "Why later:",
    "stubs.whyNow": "Why now:",
    "support.aiCta": "Ask a question →",
    "support.aiDescription": "Ask any question about your account, your bill, or Pelican Energy TCI services — answers cite your real account data.",
    "support.aiTitle": "Pelican Assistant",
    "support.backToSupport": "Back to Support",
    "support.open": "Open →",
    "support.subtitle": "Get help with your account — our AI assistant is available 24/7, or reach a human during business hours.",
    "support.title": "Customer Support",
    "toolbar.activePersona": "Active persona",
    "toolbar.collapse": "Close preview controls",
    "toolbar.exit": "Visit pelicanenergytci.com",
    "toolbar.expand": "Open preview controls",
    "toolbar.label": "Demo mode",
    "toolbar.payLockHint": "Complete or cancel payment first",
    "toolbar.personaTypeCommercial": "Commercial",
    "toolbar.personaTypeHotel": "Hotel / Commercial",
    "toolbar.personaTypeProperty": "Property Mgr",
    "toolbar.personaTypeResidential": "Residential",
    "toolbar.reset": "Reset preview",
    "toolbar.resetConfirmation": "Reset complete",
  },
  ht: {
    "aboutPelican.certsDisclosure": "Sètifikasyon ak pri ({isoCount} ISO + {awardCount} endistri)",
    "aboutPelican.heading": "Pelican Energy TCI",
    "aboutPelican.isoBizCont": "Kontinyite biznis",
    "aboutPelican.isoEnvMgmt": "Jesyon anviwònman",
    "aboutPelican.isoInfoSec": "Sekirite enfòmasyon",
    "aboutPelican.isoOHS": "Sante/sekirite nan travay",
    "aboutPelican.isoServiceMgmt": "Jesyon sèvis",
    "aboutPelican.narrative": "Pelican Energy TCI se founisè elektrisite piblik ki sèvi uit zile nan Turks ak Caicos, ak vizyon \"Transfòme Enèji nan Zile Turks ak Caicos yo\" anba deviz \"Energy for Good™\". Dirije pa yon ekip egzekitif ki baze nan Providenciales, ak 88% anplwaye ki se moun Turks ak Caicos, konpayi an opere kòm yon filyal Vision Ridge Partners (envestisè mondyal nan byen dirab) epi li gen senk sètifikasyon ISO ak plizyè pri endistri.",
    "aboutPelican.overline": "KONSÈNAN PELICAN ENERGY TCI",
    "aboutPelican.source": "Sous:",
    "aboutPelican.statCustomers": "Kliyan",
    "aboutPelican.statReliability": "Fyabilite (3 an)",
    "aboutPelican.statStaff": "Anplwaye",
    "aboutPelican.statWorkforce": "Fòs travay TC",
    "aboutPreview.builtFor": "Fèt pou kliyan tankou {name}",
    "aboutPreview.builtForGeneric": "Fèt pou kliyan tankou ou",
    "aboutPreview.bullet1": "4 pwofil kliyan pou chanje — rezidansyèl, komèsyal, otèl, jesyonè pwopriyete",
    "aboutPreview.bullet2": "Wèb ak mobil, menm eksperyans ki konnen pwofil",
    "aboutPreview.bullet3": "Pwogram nan rezidansyèl, komèsyal, otèl, ak kliyan jesyonè pwopriyete",
    "aboutPreview.bullet4": "Tout 8 zile abite nan Turks ak Caicos",
    "aboutPreview.heading": "Konsènan apèsi sa a",
    "aboutPreview.overline": "KONSÈNAN APÈSI SA A",
    "aboutPreview.p1": "Apèsi sa a se yon inisyativ entèn Pelican Energy TCI ki montre kisa eksperyans kliyan konpayi an ka ye. Anyen pa konekte ak kont reyèl, faktirasyon, oswa pèman. Chak entèraksyon fonksyone sou done sentètik. Li egziste pou montre, bout an bout, kisa sèvis otomatik pou Zile Turks ak Caicos yo sanble.",
    "aboutPreview.p2": "Kliyan Pelican jodi a jwenn aksè nan kont yo atravè pòtal aktyèl konpayi an pou peye bòdwo ak itilizasyon. Apèsi sa a montre kisa eksplikasyon bòdwo an anglè klè, mobil ki konnen pwofil, ak mòd tanpèt san entènèt ka ajoute — pwolonje sa ki la deja, pa ranplase pati ki fonksyone yo.",
    "access.heading": "Èd, enstalasyon, ak kouvèti",
    "access.helpTitle": "Jwenn èd",
    "access.mobileAlt": "Ekran akèy mobil Pelican Energy TCI",
    "access.mobileDesc": "Aplikasyon mobil natif — fèt pou rezistans nan mòd tanpèt",
    "access.mobileTitle": "Konpayon mobil",
    "access.overline": "KÒMANSE",
    "access.territoryDesc": "Pelican Energy TCI sèvi uit zile abite nan Turks and Caicos.",
    "access.territoryTitle": "Teritwa sèvis",
    "access.viewMap": "Gade kat entèraktif →",
    "account.accountNumber": "Kont #{number}",
    "account.billingPrefs": "Preferans faktirasyon",
    "account.channelEmail": "Imèl",
    "account.channelPush": "Push",
    "account.channelSms": "SMS",
    "account.commPrefs": "Preferans kominikasyon",
    "account.contactInfo": "Enfòmasyon kontak",
    "account.datePlaceholder": "YYYY-MM-DD",
    "account.eBilling": "Faktirasyon elektwonik",
    "account.eBillingDesc": "Resevwa fakti yo pa imèl olye papye",
    "account.eBillingToggleAria": "Aktive oswa dezaktive faktirasyon elektwonik",
    "account.emailAddress": "Adrès imèl",
    "account.feedbackImprove": "Kisa nou ta ka fè pi byen?",
    "account.feedbackPlaceholder": "Panse ou...",
    "account.feedbackRateAria": "Evalye {n} sou 5",
    "account.feedbackRateLegend": "Kijan ou ta evalye eksperyans ou?",
    "account.feedbackSubmit": "Voye kòmantè",
    "account.feedbackSubtitle": "Di nou sa k ap mache ak sa ki pa mache — kòmantè ou defini sa k ap vini apre.",
    "account.feedbackThankBody": "Opinyon ou ede defini sa n ap konstwi apre pou kliyan Pelican Energy TCI yo.",
    "account.feedbackThankTitle": "Mèsi pou kòmantè ou",
    "account.feedbackTitle": "Voye kòmantè",
    "account.fieldName": "Non",
    "account.from": "Depi",
    "account.fullName": "Non konplè",
    "account.mailingAddress": "Adrès postal",
    "account.phone": "Telefòn",
    "account.saveChanges": "Anrejistre chanjman",
    "account.saveVacation": "Anrejistre mòd vakans",
    "account.title": "Kont ak Paramèt",
    "account.to": "Rive",
    "account.updateSuccess": "Pwofil mizajou avèk siksè",
    "account.updateTitle": "Mizajou kont",
    "account.vacActivate": "Aktive mòd vakans",
    "account.vacActive": "Mòd vakans aktif",
    "account.vacActiveRange": "Aktif depi {from} rive {to}",
    "account.vacationSubtitle": "Fè Pelican konnen lè ou pa la — n ap siveye itilizasyon ki pa nòmal",
    "account.vacationTitle": "Mòd vakans",
    "account.vacBullet1": "Avize w si itilizasyon ogmante san atann (deteksyon fwit)",
    "account.vacBullet2": "Voye rezime itilizasyon chak jou olye alèt an tan reyèl",
    "account.vacBullet3": "Make nenpòt anomali kontè pou revizyon lè ou retounen",
    "account.vacBullet4": "Ajiste otomatikman rekòmandasyon tanperati HVAC (si li konekte)",
    "account.vacFootnote": "Mòd vakans se yon karakteristik natif TCI ki fèt pou pwopriyetè snowbird ak vwayajè regilye — pou kliyan ki pase yon pati nan ane a andeyò zile a.",
    "account.vacSaved": "Mòd vakans anrejistre",
    "account.vacSetDates": "Mete dat yo anba a, epi aktive l",
    "account.vacToggleAria": "Aktive oswa dezaktive mòd vakans",
    "account.vacWhileAway": "Pandan ou pa la, Pelican ap:",
    "ai.askAnything": "Mande Pelican sou kont ou — eseye youn nan sa yo:",
    "ai.assistantDescription": "Asistan AI a ka reponn kesyon sou pàn, solè, demann, ak plis.",
    "ai.assistantName": "Asistan Pelican",
    "ai.backToTopics": "Retounen nan sijè yo",
    "ai.closeAria": "Fèmen asistan",
    "ai.footerDisclaimer": "Pwototip apèsi — done sentetik sèlman · Se pa konsèy finansye",
    "ai.inputPlaceholder": "Mande sou kont ou…",
    "ai.openAssistant": "Ouvri asistan →",
    "ai.panelAria": "Asistan Pelican",
    "ai.preview": "Apèsi",
    "ai.processing": "N ap trete",
    "ai.sendAria": "Voye mesaj",
    "ai.standardExplanation": "AI an dirèk pa disponib — n'ap montre eksplikasyon estanda",
    "ai.thinking": "Ap reflechi…",
    "ai.wantToAsk": "Ou vle mande yon lòt bagay?",
    "ask.ariaLabelInput": "Poze asistan an yon kesyon",
    "ask.ariaLabelSubmit": "Poze asistan an",
    "ask.ctaAskAnother": "Mande yon lòt",
    "ask.ctaSignIn": "Konekte nan apèsi a epi kontinye ak yon pwofil",
    "ask.ctaSubmit": "Mande",
    "ask.ctaSwitchPersona": "Chanje pwofil",
    "ask.disclaimer": "Done sentètik sèlman · baze sou pwofil aktif ou",
    "ask.errorAiDown": "Asistan an pa disponib kounye a. Eseye yon egzanp pre-rann oswa konekte.",
    "ask.errorNetwork": "Pwoblèm rezo. Eseye ankò oswa itilize yon egzanp pre-rann.",
    "ask.errorQuotaExhausted": "Ou itilize kesyon an dirèk jou a — tounen demen, oswa konekte pou kontinye eksplore. Egzanp anlè yo toujou disponib.",
    "ask.errorRateLimited": "Twòp kesyon kounye a. Eseye yon egzanp anlè.",
    "ask.heading": "Mande. Pran repons ki site sou done ou.",
    "ask.inputPlaceholder": "Mande pwòp kesyon ou…",
    "ask.inputPlaceholderShort": "Poze yon kesyon…",
    "ask.loading": "Ap reflechi",
    "ask.moduleDesc": "Mande sou yon bòdwo, yon pàn, itilizasyon ou — repons yo site done ki dèyè yo.",
    "ask.moduleDisclaimer": "Voye nan asistan apèsi a — done sentètik sèlman.",
    "ask.overline": "MANDE NENPÒT BAGAY",
    "ask.quotaWarning": "{remaining} kesyon an dirèk rete jodi a",
    "ask.subhead": "Aktif: {persona} · pwofil {type}",
    "autopay.comingSoon": "Otopeman — nan plan devlopman an",
    "balance.currentBalance": "Balans aktyèl",
    "balance.dueDate": "Delè {date}",
    "balance.noBalanceDue": "Pa gen balans pou peye",
    "balance.paidInFull": "Peye nèt",
    "balance.payNow": "Peye kounye a",
    "balance.setUpAutopay": "Konfigire otopeman",
    "batchPay.processedOn": "Pèman an gwoup trete {date}",
    "bill.accountAddress": "Kont #{account} · {address}",
    "bill.aiBadge": "IA",
    "bill.aiDisclaimer": "Eksplikasyon jenere pa AI baze sou done bòdwo ou. Se konsomasyon ak tarif reyèl ou yo ki aplike.",
    "bill.aiExplainer": "Eksplikasyon Bòdwo AI",
    "bill.aiExplainerSub": "Eksplikasyon klè ki baze sou done itilizasyon ou",
    "bill.askAnythingSub": "Asistan AI a ka reponn kesyon sou pàn, enèji solè, demand, ak plis ankò.",
    "bill.askAnythingTitle": "Ou vle mande yon lòt bagay?",
    "bill.askFollowUp": "Poze yon kesyon swivi",
    "bill.balanceDue": "Balans dwe",
    "bill.batchPayAllAccounts": "Peye Tout Kont",
    "bill.billAssistant": "Asistan Fakti",
    "bill.billingPeriod": "Peryòd faktirasyon",
    "bill.billTotal": "Total bòdwo a",
    "bill.chargeDetail": "{kwh} × ${rate}/kWh",
    "bill.charges": "Chaj",
    "bill.confusedAboutBill": "Konfonn sou bòdwo ou? Mande asistan AI a",
    "bill.currentBill": "Bòdwo Aktyèl",
    "bill.currentBillLink": "Bòdwo aktyèl",
    "bill.customerCharge": "Chaj Kliyan",
    "bill.demandCharge": "Chaj Demand",
    "bill.demandDetail": "{kw} kW pik × $15.00/kW",
    "bill.demandFee": "Frè Demand",
    "bill.downloadPdf": "Telechaje PDF",
    "bill.downloadStatement": "Telechaje deklarasyon (PDF)",
    "bill.dueBadge": "Delè {date}",
    "bill.electricCharge": "Chaj Elektrik",
    "bill.energyLabel": "Enèji",
    "bill.explainAccountLine": "{month} · Kont #{account}",
    "bill.explainGroundedTip": "Chak deklarasyon sou paj sa a baze sou done reyèl bòdwo ou. Si yon deklarasyon pa ka site nan dosye ou yo, nou pa montre l.",
    "bill.explainMyBill": "Eksplike fakti mwen",
    "bill.fixedFee": "Frè fiks",
    "bill.fuelFactor": "Faktè Gaz",
    "bill.generatingExplanation": "Ap jenere eksplikasyon…",
    "bill.historyAccountLine": "Kont #{account} · {count} peman",
    "bill.historyCountTotalOne": "{count} peman · {total} total",
    "bill.historyCountTotalOther": "{count} peman · {total} total",
    "bill.historyEmpty": "Pa gen peman nan peryòd sa a.",
    "bill.kitchenAnomaly": "Kwizin +18% vs sa ki pase nan mwa a — evènman brunch",
    "bill.meterAggregate": "Total {count} Kontè",
    "bill.meterIdLocation": "ID Kontè: {id} · Kote: {location}",
    "bill.meterRowAria": "Detay kontè {name} — {kwh}",
    "bill.meterUsage": "Itilizasyon: {kwh}",
    "bill.monthlyBaseFee": "Frè baz chak mwa",
    "bill.monthsFilter": "{months} m",
    "bill.multiMeterBreakdown": "Detay plizyè kontè",
    "bill.net": "nèt",
    "bill.noPriorBills": "Pa gen bòdwo anvan anrejistre",
    "bill.openAssistant": "Ouvri asistan →",
    "bill.openDesktopFullView": "Louvri sou desktop pou vi konplè a",
    "bill.openPortfolioDesktopAria": "Louvri pòtfolyo konplè sou desktop",
    "bill.paymentHistory": "Istwa Peman",
    "bill.paymentHistorySub": "Wè tout peman anvan yo epi telechaje deklarasyon yo",
    "bill.payNow": "Peye {amount}",
    "bill.portfolioBreakdown": "Detay pòtfolyo",
    "bill.portfolioTotal": "Total Pòtfolyo",
    "bill.preparingPdf": "Ap prepare PDF…",
    "bill.priorPeriod": "Peryòd anvan",
    "bill.rangeMonths": "{count}mwa",
    "bill.shareBill": "Pataje Bòdwo",
    "bill.smallCommercial": "Ti komèsyal",
    "bill.solar": "solè",
    "bill.sourceLabel": "Sous: {badge}",
    "bill.sources": "Sous:",
    "bill.stmtRoadmapBody": "Telechajman deklarasyon nan plan devlopman an.",
    "bill.stmtRoadmapTitle": "Plan devlopman",
    "bill.subtotal": "Soutotal",
    "bill.tariffRefCore": "Referans: tarif Pelican Energy TCI §4.2 (CORE)",
    "bill.tariffRefUore": "§4.3 (UORE)",
    "bill.thAmount": "Montan",
    "bill.thDate": "Dat",
    "bill.thisPeriod": "Peryòd sa a",
    "bill.thMethod": "Metòd",
    "bill.thMonth": "Mwa",
    "bill.thRef": "Ref",
    "bill.thStatus": "Estati",
    "bill.thTotal": "Total",
    "bill.thUsage": "Itilizasyon (kWh)",
    "bill.thVsPrior": "vs anvan",
    "bill.totalDue": "Total pou Peye",
    "bill.totalPaidRange": "Total peye (dènye {count} mwa)",
    "bill.transactionOne": "{count} tranzaksyon",
    "bill.transactionOther": "{count} tranzaksyon",
    "bill.trendFootnote": "Istwa konplè 12 mwa · Vi detay chak mwa nan plan devlopman an",
    "bill.trendPast12": "12 dènye mwa yo",
    "bill.trendTitle": "Tandans Itilizasyon ak Kou 12 Mwa",
    "bill.twelveMonthHistory": "Istwa 12 mwa",
    "bill.understandTitle": "Konprann bòdwo ou",
    "bill.usageLabel": "Itilizasyon",
    "bill.viewBill": "Wè bòdwo",
    "bill.viewSourceAria": "Gade sous: {label}",
    "bill.whyHigher": "Poukisa bòdwo mwen pi wo?",
    "billing.nextBillLate": "Pwochen bòdwo prevwa nan fen {month}",
    "billing.paidOn": "Peye {date}",
    "brand.homeAria": "Akèy Pelican Energy TCI",
    "common.back": "Retounen",
    "common.backToHome": "Retounen nan akèy",
    "common.continue": "Kontinye",
    "common.deliveryRoadmap": "Nan plan devlopman an",
    "common.dismissAlert": "Fèmen alèt la",
    "common.done": "Fini",
    "common.goBack": "Retounen",
    "common.loading": "Ap chaje",
    "common.notificationsOff": "Notifikasyon yo dezaktive",
    "common.openDeviceSettingsAria": "Louvri paramèt aparèy la",
    "common.openSettings": "Louvri Paramèt →",
    "demo.backToOverview": "← Retounen nan apèsi",
    "demo.banner": "Pwototip prevyou — done sentètik sèlman",
    "desktopOnly.batchPaySummary": "Peye tout 4 kont jere yo nan yon sèl tranzaksyon. Disponib sou desktop.",
    "desktopOnly.batchPayTitle": "Peye tout kont yo an gwoup",
    "desktopOnly.copied": "✓ Kopye!",
    "desktopOnly.copyUrl": "Kopye URL",
    "desktopOnly.copyUrlAria": "Kopye URL nan clipboard",
    "desktopOnly.ecorSummary": "Ajiste to okipasyon an an tan reyèl pou wè kou enèji pou chak nwit chanm. Optimize pou laptop.",
    "desktopOnly.ecorTitle": "Slider okipasyon ECOR an dirèk",
    "desktopOnly.esgSummary": "Telechaje rapò anprint kabòn ak entansite enèji pou pòtfolyo ou.",
    "desktopOnly.esgTitle": "Ekspòte rapò ESG",
    "desktopOnly.optimisedNote": "Vi sa a optimize pou laptop / desktop.",
    "desktopOnly.portfolioSummary": "6 kontè · griy analiz detaye · tandans sou plizyè ane. Pi bon sou yon gwo ekran.",
    "desktopOnly.portfolioTitle": "Pòtfolyo otèl / jesyonè",
    "desktopOnly.scanToOpen": "Eskane pou louvri sou desktop",
    "errors.connectionIssue": "Pwoblèm koneksyon",
    "errors.dateRangeInvalid": "Dat retou a dwe apre dat depa a.",
    "errors.emailInvalid": "Antre yon imèl ki valab.",
    "errors.emailRequired": "Imèl obligatwa.",
    "errors.fieldRequired": "{field} obligatwa.",
    "errors.gatewayUnreachable": "Nou pa ka jwenn pasrèl pèman an. Tanpri eseye ankò.",
    "errors.ratingRequired": "Chwazi yon nòt anvan ou voye.",
    "errors.resetDemoState": "Reyinisyalize eta demo a",
    "errors.somethingWrong": "Yon bagay pa mache",
    "errors.tryAgain": "Eseye ankò",
    "followUp.compareLastMay": "Konpare ak menm peryòd ane pase a",
    "followUp.fuelFactor": "Kisa faktè gaz la ye?",
    "followUp.reduceBill": "Kijan mwen ka rédui bòdwo mwen?",
    "footer.accessibility": "Aksesibilite",
    "footer.disclaimer": "Done sentètik sèlman · Pa gen kont reyèl · Pa gen peman reyèl",
    "footer.forms": "Fòm Kliyan",
    "footer.initiative": "Apèsi Eksperyans Kliyan — yon inisyativ entèn Pelican Energy TCI.",
    "footer.linkApplyService": "Aplike pou sèvis",
    "footer.linkAskAssistant": "Mande asistan an",
    "footer.linkCore": "CORE",
    "footer.linkDamageClaim": "Reklamasyon domaj",
    "footer.linkEvCharging": "Chaj VE",
    "footer.linkHurricanePrep": "Preparasyon siklòn",
    "footer.linkOutageMap": "Kat pàn",
    "footer.linkPayBill": "Peye bòdwo ou",
    "footer.linkReportOutage": "Rapòte pàn",
    "footer.linkSignIn": "Konekte",
    "footer.linkStopService": "Sispann sèvis",
    "footer.linkStreetlight": "Rapòte limyè lari",
    "footer.linkUore": "UORE",
    "footer.previewBadge": "Apèsi",
    "footer.privacy": "Konfidansyalite: Done sentètik sèlman · Pa gen PII kolekte",
    "footer.programs": "Pwogram",
    "footer.quicklinks": "Lyen Rapid",
    "footer.siteLinks": "Lyen sit",
    "footer.subfooter": "Pelican Energy TCI · Apèsi Eksperyans Kliyan · Done sentètik sèlman · Bati nan lespri Enèji pou Byen",
    "greeting.afternoon": "Bonswa, {name}",
    "greeting.evening": "Bonswa, {name}",
    "greeting.morning": "Bonjou, {name}",
    "help.ai.desc": "Repons AI ak sitasyon nan done sentètik kont ou.",
    "help.ai.title": "Mande asistan an",
    "help.banner": "Apèsi sa a montre kisa eksperyans kliyan Pelican ou ka ye. Pou nenpòt bagay ki afekte kont reyèl ou jodi a — kesyon fakti, pàn reyèl, chanjman kont — kontakte Pelican Energy TCI lè w itilize telefòn oswa imèl ki anwo a.",
    "help.banner.link": "Oswa vizite pelicanenergytci.com →",
    "help.email.title": "Imèl Pelican Energy TCI",
    "help.phone.hours": "Lè: gade pelicanenergytci.com →",
    "help.phone.title": "Rele Pelican Energy TCI",
    "hero.checkMap": "Tcheke kat la",
    "hero.enterAs": "Antre nan apèsi a kòm {name} →",
    "hero.enterGeneric": "Antre nan apèsi a →",
    "hero.exploreAs": "Chwazi yon kliyan pou eksplore",
    "hero.exploringAs": "Ap eksplore kòm {name} · pwofil {type}. Chanje nenpòt lè nan apèsi a.",
    "hero.exploringGeneric": "Chanje pwofil nenpòt lè nan apèsi a.",
    "hero.eyebrow": "APÈSI EKSPERYANS KLIYAN",
    "hero.headlineAccent": "fèt pou zile sa yo.",
    "hero.headlinePrimary": "Enèji,",
    "hero.langCommitment": "Disponib an Anglè · Kreyòl Ayisyen · Espanyòl",
    "hero.langHonestScope": "Paj dakèy la ak akèy kont ou an disponib nan tout twa lang yo; paj ki pi detaye yo ap tradui toujou.",
    "hero.openHurricanePrep": "Ouvri preparasyon siklòn →",
    "hero.reportOutage": "Rapòte pàn",
    "hero.statusAllClear": "Tout sistèm nòmal · Sèvis ap fonksyone nan tout uit zile yo",
    "hero.statusPersona": "Sèvis nan {island}: nòmal · Tout sistèm ap fonksyone",
    "hero.stormActive": "mòd preparasyon aktif",
    "hero.stormEtaBanner": "{name} — ETA {eta}",
    "hero.subhead": "Eksperyans kliyan pou Pelican Energy TCI — peye bòdwo ou, prepare pou tanpèt, mande nenpòt bagay, tout nan yon sèl kote.",
    "hero.trustMicrocopy": "30 segonn pou kòmanse · Pa gen enskripsyon",
    "home.accountsCount": "{count} kont",
    "home.accountsCountDue": "{count} kont · Delè {date}",
    "home.accountsCountPaid": "{count} kont · Peye {date} ✓",
    "home.activeOutagesAriaOne": "{count} pàn aktif, gade kat la",
    "home.activeOutagesAriaOther": "{count} pàn aktif, gade kat la",
    "home.activeRequests": "Demann aktif",
    "home.activity.batchPayment": "Peman an gwoup {amount}",
    "home.activity.billIssued": "Bòdwo emèt {amount}",
    "home.activity.billsIssuedTotal": "{count} bòdwo emèt — {amount} an total",
    "home.activity.demandChargeApplied": "Chaj demann aplike",
    "home.activity.demandNearMiss": "Demann prèske depase {load}/{cap} kW",
    "home.activity.highUsageAlertProperty": "Alèt gwo itilizasyon — {property}",
    "home.activity.highUsageAlertSent": "Alèt gwo itilizasyon voye",
    "home.activity.kitchenMeterAnomaly": "Anomali kontè kizin {pct}",
    "home.activity.outageResolved": "Pàn rezoud — zòn {area}",
    "home.activity.paymentReceived": "Peman resevwa {amount}",
    "home.activity.portfolioTrend": "Tandans pòtfolyo {pct}",
    "home.activity.solarExport": "Ekspòtasyon solè {kwh} kWh",
    "home.activity.solarExportCredited": "Ekspòtasyon solè {kwh} kWh kredite",
    "home.activity.usageAbovePrior": "Itilizasyon {pct} pi wo pase sik anvan an",
    "home.activity.vacantAnomaly": "Anomali pandan vakans — {property}",
    "home.aiCalloutSub": "Eksplikasyon an lang senp ak sitasyon ki soti nan done itilizasyon ou",
    "home.alert.anomaly": "Anomali detekte",
    "home.alert.countOne": "{count} alèt",
    "home.alert.countOther": "{count} alèt",
    "home.alert.demand": "Demann toupre limit la",
    "home.alert.storm": "{name}",
    "home.allPowerOn": "Tout kouran limen",
    "home.anomaly": "Anomali",
    "home.askNow": "Mande kounye a →",
    "home.contextHighlightDiveDay": "depans mwayèn pa jou plonje",
    "home.demand": "Demann",
    "home.demandShedHint": "Chaj aktyèl la nan {pct} nan limit {cap} kW la — konsidere redwi klimatizè nan chanm ki vid yo.",
    "home.ecorPerRoomNight": "pou chak nwit chanm okipe",
    "home.etaLabel": "Lè prevwa:",
    "home.kwValue": "{value} kW",
    "home.liveOccupancySlider": "Kontwòl okipasyon an dirèk →",
    "home.liveOccupancySliderDesktop": "Slider okipasyon an dirèk (desktop) →",
    "home.managedProperties": "Pwopriyete jere",
    "home.managedPropertiesSub": "{count} pwopriyete · siveyans anomali",
    "home.nearThreshold": "toupre limit la",
    "home.networkStatus": "Eta rezo a",
    "home.noActiveRequests": "Pa gen demann aktif",
    "home.noRecentActivity": "Pa gen aktivite resan",
    "home.ofKwThreshold": " / {cap} kW limit",
    "home.openEcorDesktopAria": "Louvri slider ECOR an dirèk sou desktop",
    "home.openPortfolio": "Ouvri pòtfolyo →",
    "home.outageActiveAria": "Pàn kouran aktif nan {circuit} — peze pou detay",
    "home.outageCountOne": "{count} pàn",
    "home.outageCountOther": "{count} pàn",
    "home.outageIn": "Pàn nan {circuit}",
    "home.peakDemand": "Demann pik",
    "home.peakDemandAria": "Demann pik {load} kW sou yon limit {cap} kW",
    "home.pelicanInsights": "Apèsi Pelican",
    "home.portfolioBalance": "Balans pòtfolyo",
    "home.portfolioDashboard": "Tablodbò pòtfolyo",
    "home.portfolioMetersSub": "{count} kontè · okipasyon · deteksyon anomali",
    "home.powerOn": "Kouran limen",
    "home.propertiesFlagged": "{count} nan {total} pwopriyete make peryòd sa a",
    "home.recentActivity": "Aktivite resan",
    "home.report": "Rapòte →",
    "home.reportOutageAria": "Rapòte yon pàn kouran",
    "home.reportPowerOut": "Kouran koupe? Rapòte kounye a",
    "home.reportPowerOutSub": "Yon sèl peze — mete yon pin nan {address} oswa chwazi yon lòt adrès",
    "home.solarCapacityPanels": "{kw} kW CORE · {panels} panno",
    "home.solarExportedOffset": "{kwh} ekspòte · {pct}% nan itilizasyon konpanse",
    "home.solarThisMonth": "Solè mwa sa a",
    "home.tapForPrepMode": "Tape pou mòd preparasyon →",
    "home.time.lastMonth": "Mwa pase",
    "home.time.lastWeek": "Semèn pase",
    "home.time.thisCycle": "Sik sa a",
    "home.time.thisMonth": "Mwa sa a",
    "home.time.today": "Jodi a",
    "home.usage12mo": "Itilizasyon (12 mwa)",
    "home.usageAnomalyDetected": "Anomali itilizasyon detekte",
    "home.usageCostTrend": "{sign}{pct}% depans vs. sik anvan an",
    "home.usageLastMonth": "{kwh} mwa pase",
    "home.usageThisMonth": "Itilizasyon mwa sa a",
    "home.usageVsPriorCycle": "{sign}{pct}% vs. sik anvan an",
    "home.viewActivity": "Gade aktivite →",
    "home.viewAll": "Gade tout",
    "home.viewAllRequestsAria": "Gade tout demann yo",
    "home.viewAnomalyAria": "Gade detay anomali",
    "home.viewHurricaneChecklistAria": "Gade lis preparasyon pou siklòn",
    "home.viewInvestigation": "Gade envestigasyon an →",
    "home.viewMap": "Gade kat la",
    "home.viewProperties": "Gade pwopriyete yo →",
    "hotel.alerts.demandNearMiss": "Demand prèske depase: {actual} kW / limit {threshold} kW",
    "hotel.alerts.demandNearMissSub": "Rezoud otomatikman",
    "hotel.alerts.kitchen": "Kontè kwizin ak manje +18% konpare ak mwa pase a jiska dat",
    "hotel.alerts.kitchenSub": "evènman brunch",
    "hotel.alerts.panelMaintenance": "Antretyen panèl an reta — {meter}",
    "hotel.alerts.panelMaintenanceSub": "Panèl distribisyon pisin ak spa",
    "hotel.alerts.timeLastMonth": "Mwa pase",
    "hotel.alerts.timeTwoMonthsAgo": "Sa gen 2 mwa",
    "hotel.band.occupancy": "{pct}% okipasyon",
    "hotel.ecor.aboveBy": "{pct}% pi wo",
    "hotel.ecor.ariaEcor": "ECOR: {amount} pou chak chanm okipe pa nwit",
    "hotel.ecor.ariaSlider": "{pct}% okipasyon — ECOR {amount}",
    "hotel.ecor.avgSuffix": "mwayèn",
    "hotel.ecor.barCaribbeanLuxury": "Liks Karayib",
    "hotel.ecor.barTciAvg": "Mwayèn touris TCI",
    "hotel.ecor.barThisHotel": "Otèl sa a (aktyèl)",
    "hotel.ecor.benchmarkLine": "Referans liks Karayib ajiste pou TCI {amount} — ou {delta}",
    "hotel.ecor.bestNights": "3 pi bon nwit yo ({month})",
    "hotel.ecor.betterBy": "{pct}% pi bon",
    "hotel.ecor.compareHeading": "Kijan ECOR mwen konpare?",
    "hotel.ecor.currentSeason": "{pct}% (aktyèl)",
    "hotel.ecor.dragHint": "Rale kontwòl okipasyon an anwo a pou wè kijan chaj la chanje pozisyon ou konpare ak referans yo.",
    "hotel.ecor.fullSeason": "{pct}% (konplè)",
    "hotel.ecor.industryBenchmarks": "Referans endistri a",
    "hotel.ecor.kwhPerGuestNight": "kWh pa nwit kliyan",
    "hotel.ecor.lowSeason": "{pct}% (sezon fèb)",
    "hotel.ecor.occupancy": "Okipasyon",
    "hotel.ecor.perRoomNight": "pou chak chanm okipe pa nwit",
    "hotel.ecor.renewableAvg": "% renouvlab mwayèn",
    "hotel.ecor.stubBody": "Disponib sèlman pou kont otèl. Chanje pou Long Bay Reef Resort (P3).",
    "hotel.ecor.stubTitle": "Kontwòl ECOR",
    "hotel.ecor.subtitle": "Kou enèji pou chak chanm okipe pa nwit",
    "hotel.ecor.titleSuffix": "an dirèk",
    "hotel.ecor.worstNights": "3 pi move nwit yo ({month})",
    "hotel.esg.actionHvacDetail": "Enstale detektè nan chak nan {suites} suit yo pou bese klimatizasyon an otomatikman lè chanm yo vid.",
    "hotel.esg.actionHvacSaving": "~8% enèji klimatizasyon",
    "hotel.esg.actionHvacTitle": "Klimatizasyon ak detektè okipasyon",
    "hotel.esg.actionLedDetail": "Chanje limyè chemen 400 W ki rete yo pou ekivalan LED 40 W nan tout teren an.",
    "hotel.esg.actionLedSaving": "~3,200 kWh pa mwa",
    "hotel.esg.actionLedTitle": "Amelyorasyon limyè LED deyò",
    "hotel.esg.actionSolarDetail": "Ranplase chofaj elektrik pisin yo ak kolektè solè tèmik sou tèt kay la.",
    "hotel.esg.actionSolarSaving": "~15 kW mwens demand",
    "hotel.esg.actionSolarTitle": "Chofaj solè tèmik pou pisin",
    "hotel.esg.co2Avoided": "CO₂e evite",
    "hotel.esg.coreProgramme": "Pwogram CORE",
    "hotel.esg.currentCycle": "Sik aktyèl",
    "hotel.esg.energySummary": "Rezime enèji aktyèl",
    "hotel.esg.exportPdf": "Ekspòte PDF",
    "hotel.esg.generating": "Ap jenere…",
    "hotel.esg.goalHeatPump": "Enstale chofaj dlo ak ponp chalè nan tout {suites} suit yo",
    "hotel.esg.goalKwh": "Redwi kWh pa nwit kliyan anba 35 anvan fen ane a",
    "hotel.esg.goalLeed": "Jwenn sètifikasyon LEED Silver anvan 2027",
    "hotel.esg.goalRenewable": "Rive nan 40% pòsyon renouvlab anvan 2027",
    "hotel.esg.goalsFootnote": "Pwogram Objektif Dirabilite DOI — objektif yo aliyen ak Depatman Anviwònman TCI",
    "hotel.esg.goalsHeading": "Objektif dirabilite {year}",
    "hotel.esg.grossConsumption": "Konsomasyon brit",
    "hotel.esg.industryAvg": "Mwayèn endistri a {value}",
    "hotel.esg.industryAvgPct": "Mwayèn endistri a {value}%",
    "hotel.esg.netBilled": "kWh nèt faktire",
    "hotel.esg.policyReferences": "Referans politik",
    "hotel.esg.renewableLine": "Renouvlab (solè + rezo vèt)",
    "hotel.esg.stubBody": "Disponib sèlman pou kont otèl. Chanje pou Long Bay Reef Resort (P3).",
    "hotel.esg.stubTitle": "Rapò ESG",
    "hotel.esg.suggestedActions": "Aksyon sijere pou amelyore nòt ou",
    "hotel.esg.title": "Rapò enèji ESG",
    "hotel.esg.totalCost": "Kou total enèji",
    "hotel.esg.uoreProgramme": "Pwogram UORE",
    "hotel.esg.vsGridBaseline": "konpare ak baz rezo a",
    "hotel.kpi.ecor": "ECOR",
    "hotel.kpi.ecorSub": "pou chak chanm okipe pa nwit",
    "hotel.kpi.kwhPerGuestNight": "kWh pa nwit kliyan",
    "hotel.kpi.kwhPerGuestNightSub": "mwayèn endistri a {value}",
    "hotel.kpi.pctRenewable": "% renouvlab",
    "hotel.kpi.pctRenewableSub": "mwayèn endistri a {pct}%",
    "hotel.kpi.peakDemand": "Demand maksimòm",
    "hotel.kpi.peakDemandSub": "limit {kw} kW",
    "hotel.mobile.meterMainKitchen": "Kizin Prensipal",
    "hotel.mobile.meterPoolSpa": "Pisin ak Spa",
    "hotel.mobile.metersSummaryOne": "{name} · {count} kontè",
    "hotel.mobile.metersSummaryOther": "{name} · {count} kontè",
    "hotel.mobile.meterSuiteBlockA": "Blòk Suit A",
    "hotel.mobile.occupancyAtSync": "Okipasyon nan dènye senkronizasyon · {pct}%",
    "hotel.mobile.openDashboardDesktop": "Louvri tablodbò otèl la sou desktop",
    "hotel.mobile.propertyOverview": "Apèsi pwopriyete a",
    "hotel.mobile.topMeters": "Pi gwo kontè peryòd sa a",
    "hotel.portfolio.actionsAria": "Aksyon pòtfèy",
    "hotel.portfolio.anomalyBadge": "Anomali",
    "hotel.portfolio.anomalyDetail": "+18% konpare ak mwa pase a jiska dat — evènman brunch",
    "hotel.portfolio.ecorSlider": "Kontwòl ECOR an dirèk",
    "hotel.portfolio.esgReport": "Rapò ESG",
    "hotel.portfolio.kpisHeading": "Endikatè",
    "hotel.portfolio.loadShedPlaybook": "Plan pou redwi chaj",
    "hotel.portfolio.metersHeading": "{count} kontè",
    "hotel.portfolio.nearPeakDemand": "Prèske nan demand maksimòm",
    "hotel.portfolio.occupancyAria": "Okipasyon {pct}% — rale kontwòl la sou paj ECOR la",
    "hotel.portfolio.occupancyBadge": "{pct}% okipasyon · rale →",
    "hotel.portfolio.payAllMeters": "Peye tout {count} kontè yo",
    "hotel.portfolio.pctOfTotal": "{pct}% nan total la",
    "hotel.portfolio.projected": "prevwa",
    "hotel.portfolio.recentAlerts": "Alèt resan",
    "hotel.portfolio.setDemandAlert": "Kreye alèt demand",
    "hotel.portfolio.stubBody": "Vi sa a disponib sèlman pou kont otèl. Chanje pou Long Bay Reef Resort & Spa (P3) pou wè tablo pòtfèy la.",
    "hotel.portfolio.stubTitle": "Pòtfèy otèl",
    "hotel.portfolio.thisMonthToDate": "Mwa sa a jiska jodi a",
    "hotel.portfolio.viewDetails": "Wè detay →",
    "hotel.portfolioLink": "Pòtfèy",
    "hurricane.activeAdvisory": "Avi aktif",
    "hurricane.alertTitle": "⚠ Avètisman siklòn",
    "hurricane.atlanticSeason": "Sezon Atlantik:",
    "hurricane.autoActivates": "Aktive otomatikman lè yon tanpèt pwoche zòn sèvis ou.",
    "hurricane.callContactAria": "Rele {name}",
    "hurricane.check": "Make",
    "hurricane.checklistCharger": "Chajè telefòn pòtab",
    "hurricane.checklistFlashlights": "Flach ak batri",
    "hurricane.checklistFood": "Manje ki pa gate",
    "hurricane.checklistMedication": "Medikaman pou 7 jou",
    "hurricane.checklistProgress": "{done}/{total} fini",
    "hurricane.checklistWater": "Dlo (2 galon × moun × 3 jou)",
    "hurricane.connectivityBand": "Konsevwa pou eksperyans tanpèt Karayib reyèl la — mòd tanpèt san entènèt sou mobil ak SMS ranplasan sou plan livrezon an.",
    "hurricane.contactDdmeDetail": "Otorite ofisyèl jesyon ijans",
    "hurricane.contactHospitalDetail": "Prensipal lopital, Providenciales",
    "hurricane.contactHotlineDetail": "Preparasyon tanpèt ak enfòmasyon abri",
    "hurricane.contactOutageDetail": "Pàn kouran ak ijans",
    "hurricane.emergencyContacts": "Kontak ijans",
    "hurricane.etaLabel": "ETA",
    "hurricane.explorePrep": "Eksplore preparasyon siklòn",
    "hurricane.genCriticalLoads": "Chaj kritik idantifye",
    "hurricane.genCriticalLoadsDetail": "Sekirite lavi, chanm frèt kwizin, ak asansè kliyan sou sikwi dèlko yo",
    "hurricane.generatorCoordination": "Kowòdinasyon dèlko",
    "hurricane.generatorIntro": "Preparasyon dèlko anvan tanpèt espesifik pou otèl, pou Long Bay Reef Resort.",
    "hurricane.genFuelLevel": "Nivo gaz",
    "hurricane.genFuelLevelDetail": "Rezèv minimòm 72 èdtan (objektif: rezèvwa a 100%)",
    "hurricane.genMaintenanceLog": "Rejis antretyen ajou",
    "hurricane.genMaintenanceLogDetail": "Dènye dat sèvis ak pwochen sèvis pwograme anrejistre",
    "hurricane.genManualTest": "Tès manyèl",
    "hurricane.genManualTestDetail": "Kouri dèlko prensipal la 30 min anba chaj",
    "hurricane.genTransferSwitch": "Switch transfè teste",
    "hurricane.genTransferSwitchDetail": "Verifye transfè otomatik nan 10 segonn apre yon pàn rezo",
    "hurricane.heading": "Pare pou tanpèt, toujou.",
    "hurricane.loadingStormMap": "Ap chaje kat tanpèt…",
    "hurricane.offSeasonIntro": "Sezon siklòn kouri 1 Jen – 30 Nov. Kliyan Pelican Energy TCI jwenn yon mòd preparasyon pèsonalize, siveyans tanpèt an dirèk, lis preparasyon, kontak ijans, ak suivi restorasyon apre tanpèt.",
    "hurricane.offSeasonMessage": "Sezon siklòn kouri 1 Jen – 30 Nov. Tounen pi pre sezon an.",
    "hurricane.openPrep": "Ouvri preparasyon siklòn",
    "hurricane.overline": "PARE POU TANPÈT",
    "hurricane.preparedness": "Sezon siklòn Atlantik la kouri 1 Jen – 30 Nov. Kenbe lis preparasyon ou ajou.",
    "hurricane.prepChargeDevices": "Chaje tout aparèy yo a 100%",
    "hurricane.prepChecklist": "Lis preparasyon",
    "hurricane.prepChecklistTitle": "Lis preparasyon",
    "hurricane.prepFillBathtub": "Plen benywa a ak dlo",
    "hurricane.prepFillCoolers": "Plen glasyè yo ak glas",
    "hurricane.prepIdentifyShelter": "Idantifye kote abri ou a",
    "hurricane.prepIdentifyShelterDetail": "Lis abri gouvènman TCI: gov.tc/dcr",
    "hurricane.prepLocateFlashlights": "Jwenn flach ak batri",
    "hurricane.prepModeLink": "Mòd preparasyon →",
    "hurricane.prepModeTitle": "Mòd preparasyon siklòn",
    "hurricane.prepMoveFurniture": "Antre mèb deyò yo",
    "hurricane.prepRefillPrescriptions": "Ranplen preskripsyon ou yo",
    "hurricane.prepSecureDocuments": "Sere dokiman enpòtan yo nan yon sak enpèmeyab",
    "hurricane.prepSecureDocumentsDetail": "Paspò, asirans, tit pwopriyete",
    "hurricane.prepStockFood": "Estoke 3 jou manje ki pa gate ak dlo",
    "hurricane.prepStockFoodDetail": "1 galon dlo pou chak moun chak jou",
    "hurricane.prepTestGenerator": "Teste dèlko rezèv la",
    "hurricane.prepTestGeneratorDetail": "Kouri li 15 min; tcheke nivo gaz ak switch transfè a",
    "hurricane.projectedTrack": "{name} — trajè pwojte",
    "hurricane.reEnableAlerts": "Reyaktive nan Paramèt pou voye alèt siklòn.",
    "hurricane.sampleChecklist": "Egzanp lis preparasyon",
    "hurricane.seasonActive": "Sezon siklòn",
    "hurricane.seasonActiveBadge": "Sezon aktif",
    "hurricane.seasonDates": "1 Jen – 30 Nov",
    "hurricane.seasonIndicator": "Endikatè sezon siklòn",
    "hurricane.seeFullChecklist": "Wè lis konplè →",
    "hurricane.seeFullTracker": "Wè tout siveyans tanpèt →",
    "hurricane.shelterDept": "Depatman Jesyon Dezas ak Ijans",
    "hurricane.shelterRegister": "Rejis Ofisyèl Abri TCI",
    "hurricane.stormApproaching": "{name} ap pwoche · ETA {eta}",
    "hurricane.stormBannerMessage": "Sezon siklòn aktif — {name} ap pwoche Provo, ETA {eta}. Tape pou mòd preparasyon.",
    "hurricane.stormEta": "ETA:",
    "hurricane.stormName": "Non:",
    "hurricane.stormTracker": "Siveyans tanpèt",
    "hurricane.trackerAria": "Kat siveyans tanpèt ki montre trajè pwojte {name}",
    "hurricane.trackerDisclaimer": "Trajè sentetize pou demonstrasyon sèlman — se pa done an dirèk NHC.",
    "hurricane.uncheck": "Demake",
    "hurricane.viewChecklist": "Wè lis preparasyon →",
    "hurricane.viewFullChecklist": "Wè lis konplè (12 atik) →",
    "hurricane.viewOutageMap": "Wè kat pàn",
    "insights.cta.claimCredit": "Reklame kredi",
    "insights.cta.scheduleTechnician": "Pwograme teknisyen",
    "insights.cta.tellMeMore": "Di m plis",
    "insights.cta.viewDetail": "Gade detay",
    "insights.duration.hoursMinutes": "{hours} è {minutes} min",
    "insights.duration.hoursOnly": "{hours} è",
    "insights.duration.minutesOnly": "{minutes} min",
    "insights.leadFigure.kwhPerDay": "{value} kWh/jou",
    "insights.p1OutageSpoilage.body": "Pàn alimantatè Bight Park nan dat {date} — ou ka kalifye pou yon kredi domaj jiska $25.",
    "insights.p1SolarApril.body": "nan kredi ekspòtasyon solè sik sa a — pi bon rezilta ou anrejistre (38% nan konsomasyon konpanse).",
    "insights.p1UsageTrend.body": "konsomasyon sik sa a kont dènye a — sitou èkondisyone wikenn lannwit (12% pi wo pase mwayèn jou semèn).",
    "insights.p2DiveDayCost.body": "mwayèn depans elektrik pou chak jou plonje sik sa a — sik konpresè lè a se pi gwo liy ou.",
    "insights.p2GrandTurkFuel.body": "faktè gaz Grand Turk mwa sa a — yon ti kras anba 0.1564 Provo akoz orè livrezon gaz.",
    "insights.p2WeeklyPattern.body": "ogmantasyon konsomasyon chak Madi/Mèkredi — pwobableman ranpli tank ak konpresè apre plonje wikenn.",
    "insights.p3DemandNearMiss.body": "demand pik Mèkredi pase — ranvwaye lesiv ant 2–6 AM ta ka anpeche pwochen depasman sèy la.",
    "insights.p3EsgOffset.body": "nan konsomasyon sik sa a konpanse pa 80 kW solè CORE ou — referans liks TCI se 12%, epi +200 kW konsèy la apwouve fèmen twou a.",
    "insights.p3KitchenAnomaly.body": "Konptè Kwizin ak F&B Madi–Jedi {recency} — koresponn ak evènman brunch nan kalandriye ou.",
    "insights.p4PortfolioTrend.body": "konsomasyon pòtfolyo sik sa a kont dènye a (5,568 kont 5,580 kWh) — sezon-estab nan 4 pwopriyete; anomali Sea Breeze la se sèl eksepsyon an.",
    "insights.p4SandyCoveSavings.body": "to konsomasyon Villa Sandy Cove kont baz anvan-odit la — yon odit kontè pou chanjman lokatè te kenbe yon ponp pwi k ap mache 24/7.",
    "insights.p4VillaAnomaly.body": "Villa Sea Breeze pandan 2 semèn vakans — posib aparèy ki toujou limen, yo sispèk chofaj dlo.",
    "insights.recencyLastWeek": "semèn pase",
    "install.androidCta": "Telechaje .apk",
    "install.androidDesc": "Aplikasyon natif reyèl. Eskane pou telechaje dènye .apk epi enstale sou Android.",
    "install.browserCta": "Kontinye nan apèsi a →",
    "install.browserDesc": "Eksperyans wèb konplè sou nenpòt aparèy. Rekòmande pou òdinatè.",
    "install.gotIt": "Konprann",
    "install.iphoneDesc": "Eskane ak kamera iPhone ou, epi tape 'Ajoute nan Ekran Akèy' nan Safari.",
    "install.iphoneModalLabel": "Enstale sou iPhone",
    "install.iphoneModalTitle": "Ajoute nan Ekran Akèy iPhone",
    "install.iphoneSteps": "Gade enstriksyon etap pa etap",
    "install.step1Open": "Ouvri",
    "install.step1Safari": "nan Safari sou iPhone ou.",
    "install.step2Share": "Pataje",
    "install.step2TapThe": "Tape sou",
    "install.step2Toolbar": "bouton (bwat ak flèch) nan ba zouti Safari a.",
    "install.step3AddHome": "\"Ajoute nan Ekran Akèy\"",
    "install.step3ScrollTap": "Glise desann epi tape sou",
    "install.step4Add": "Ajoute",
    "install.step4Confirm": "pou konfime. Ikòn Pelican an ap parèt sou ekran akèy ou.",
    "install.step4Tap": "Tape sou",
    "install.tablistLabel": "Chemen enstalasyon",
    "landing.backToTop": "Retounen anlè",
    "latest.ariaLabel": "Dènye nouvèl Pelican Energy TCI",
    "latest.heading": "Dènye nouvèl Pelican Energy TCI",
    "latest.more": "Plis nan Pelican Energy TCI",
    "more.aiAssistant": "Asistan Pelican",
    "more.changeLanguageAria": "Chanje lang. Kounye a: {name}",
    "more.sectionAccount": "Chanje pwopriyete",
    "more.sectionLanguage": "Lang",
    "more.sectionNavigate": "Navige",
    "more.sectionPersona": "Pèsonaj",
    "more.sectionSession": "Sesyon",
    "more.sectionShortcuts": "Rakousi",
    "more.signOut": "Dekonekte",
    "more.tapToCycle": "Tape pou chanje",
    "more.viewAccountAria": "Gade pwopriyete {name}",
    "nav.account": "Kont",
    "nav.bill": "Bòdwo",
    "nav.home": "Akèy",
    "nav.menu": "Meni",
    "nav.outageMap": "Kat Pàn",
    "nav.pay": "Peye",
    "nav.report": "Rapòte",
    "nav.services": "Sèvis",
    "nav.support": "Sipò",
    "notifications.allShown": "Tout notifikasyon",
    "notifications.ariaOne": "Notifikasyon ({count} pa li)",
    "notifications.ariaOther": "Notifikasyon ({count} pa li)",
    "notifications.close": "Fèmen notifikasyon yo",
    "notifications.markAll": "Make tout kòm li",
    "notifications.title": "Notifikasyon",
    "outage.activeIncidentsOne": "{count} ensidan aktif",
    "outage.activeIncidentsOther": "{count} ensidan aktif",
    "outage.activeOutagesOne": "{count} pàn aktif",
    "outage.activeOutagesOther": "{count} pàn aktif",
    "outage.advanceState": "Avanse eta (demo) →",
    "outage.affected": "{count} afekte",
    "outage.allNormal": "Tout sistèm nòmal",
    "outage.backToMap": "Kat pàn",
    "outage.closeDetail": "Fèmen detay pàn",
    "outage.crew": "Ekip",
    "outage.crewNotDispatched": "Ekip poko voye",
    "outage.crewOnSite": "Ekip sou plas — 2 teknisyen, Kamyon #14",
    "outage.crewStatus": "Estati ekip la",
    "outage.customersAffected": "{count} kliyan afekte",
    "outage.customersCountOne": "{count} kliyan",
    "outage.customersCountOther": "{count} kliyan",
    "outage.detailAria": "Detay pàn — {circuit}",
    "outage.dismissReportAria": "Fèmen konfimasyon rapò pàn nan",
    "outage.distanceKm": "{km} km",
    "outage.distanceToSite": "Distans jiska sit la",
    "outage.eta": "ETA",
    "outage.getNotified": "Resevwa avi lè kouran tounen",
    "outage.lastUpdate": "Dènye mizajou",
    "outage.legendActiveEtaSet": "Aktif — gen ETA",
    "outage.legendActiveNoEta": "Aktif — pa gen ETA",
    "outage.legendHide": "Kache lejand kat la",
    "outage.legendResolved": "Rezoud",
    "outage.legendScheduled": "Pwograme",
    "outage.legendShow": "Montre lejand kat la",
    "outage.legendTitle": "Lejand",
    "outage.listAria": "Lis pàn",
    "outage.listView": "Wè lis",
    "outage.loadingMap": "Ap chaje kat…",
    "outage.mapAppAria": "Kat pàn TCI",
    "outage.mapTitle": "Kat pàn",
    "outage.mapView": "Wè kat",
    "outage.metaAffected": "Afekte",
    "outage.metaCause": "Kòz",
    "outage.metaCircuit": "Sikwi",
    "outage.metaReported": "Rapòte",
    "outage.minAgo": "{min} min pase",
    "outage.moduleHeading": "Pàn ak preparasyon tanpèt",
    "outage.notFound": "Pàn pa jwenn.",
    "outage.notifPushBody": "{circuit} tounen an liy. Sèvis ou ta dwe aktif.",
    "outage.notifPushTitle": "Kouran retabli",
    "outage.notifReEnable": "Reyaktive nan Paramèt pou abòne ak mizajou pàn yo.",
    "outage.notifyConfirm": "Yo pral avèti w lè kouran an retabli. (Demo: li rive nan 5 s.)",
    "outage.notifySubtitle": "Resevwa yon notifikasyon lè kouran an tounen",
    "outage.notifyTitle": "Avèti lè li retabli",
    "outage.notifyToggleAria": "Chanje notifikasyon retablisman pàn",
    "outage.pinAria": "Pàn {status} — {circuit}",
    "outage.prepModeActive": "Mòd preparasyon aktif · ETA {eta}",
    "outage.recentUpdates": "Dènye mizajou yo",
    "outage.reporter.confirmingSubmit": "Ap rapòte…",
    "outage.reporter.dismiss": "Ignore",
    "outage.reporter.idleSubmit": "Rapòte kounye a",
    "outage.reporter.idleTitle": "Kouran koupe kote w ye a?",
    "outage.reporter.reference": "Referans",
    "outage.reporter.submittedSuffix": "N ap avize w lè yo voye ekip yo.",
    "outage.reporter.submittedTitle": "Pàn rapòte — mèsi",
    "outage.reportOutage": "Rapòte yon pàn →",
    "outage.scheduled": "Pwograme",
    "outage.serviceLocationAria": "Kote sèvis ou",
    "outage.simulatedStatus": "Estati sikilasyon similye sou uit zile.",
    "outage.started": "Kòmanse {date}",
    "outage.statusTimeline": "Kwonoloji estati",
    "outage.step.crewDispatched": "Ekip voye",
    "outage.step.investigating": "N ap envestige",
    "outage.step.received": "Resevwa pa depatch",
    "outage.step.resolved": "Kouran retabli",
    "outage.step.restoring": "N ap retabli kouran",
    "outage.step.submitted": "Rapò voye",
    "outage.stepCurrent": "aktyèl",
    "outage.stormLabel": "Tanpèt {name}",
    "outage.subscribed": "Abòne — n ap avize w lè kouran an tounen",
    "outage.timeline.crewDispatched": "Ekip voye",
    "outage.timeline.investigating": "Ap envestige",
    "outage.timeline.received": "Resevwa",
    "outage.timeline.resolved": "Rezoud",
    "outage.timeline.restoring": "Ap retabli",
    "outage.timeline.submitted": "Soumèt",
    "outage.timelineAria": "Kwonoloji pwogrè pàn nan",
    "outage.timelineTitle": "Kwonoloji",
    "outage.viewLatest": "Gade dènye pàn nan",
    "outage.viewMap": "Gade kat pàn →",
    "outage.viewTimeline": "Wè kwonoloji konplè",
    "outage.yourCircuit": "Sikwi ou",
    "outageStatus.activeNoEta": "Aktif — pa gen ETA",
    "outageStatus.activeWithEta": "Aktif — ekip an wout",
    "outageStatus.resolved": "Rezoud",
    "outageStatus.scheduled": "Antretyen pwograme",
    "pay.accountLabel": "Kont #{account}",
    "pay.addMethod": "+ Ajoute nouvo metòd",
    "pay.amountExceedsBalance": "Sa depase balans aktyèl ou a ki se {amount}.",
    "pay.amountOptionsLegend": "Opsyon montan pèman",
    "pay.amountProcessed": "{amount} trete.",
    "pay.batchPayAll": "Peye Tout Kont",
    "pay.cancel": "Anile",
    "pay.cancelAria": "Anile peman an",
    "pay.confirmation": "Konfimasyon #",
    "pay.confirmBatchPayment": "Konfime Pèman an Gwoup",
    "pay.confirmBiometric": "Konfime ak Face ID / anprint dijital",
    "pay.confirmPayment": "Konfime Pèman",
    "pay.confirmTitle": "Konfime pèman",
    "pay.copyConfirmation": "Kopye nimewo konfimasyon an",
    "pay.customAmount": "Montan pèsonalize",
    "pay.customAmountLabel": "Montan pèsonalize an USD",
    "pay.dismiss": "Ranvwaye",
    "pay.doneReturnDashboard": "Fini — Retounen nan Tablodbò",
    "pay.emailReceipt": "Resi pa imèl",
    "pay.enterCustomAmountAria": "Antre montan pèsonalize",
    "pay.expires": "Ekspire {expiry}",
    "pay.fullBalance": "Balans konplè",
    "pay.identityVerified": "Idantite verifye",
    "pay.lastMonth": "Mwa pase a",
    "pay.lastPayment": "Dènye pèman",
    "pay.makePayment": "Fè yon pèman",
    "pay.masterConfirmation": "Konfimasyon prensipal #",
    "pay.memoValue": "Pèman bòdwo — {month}",
    "pay.meterLabel": "Kontè {id}",
    "pay.methodAria": "{brand} ki fini ak {last4}",
    "pay.monthsAgo": "sa gen {count} mwa",
    "pay.newBalance": "Nouvo balans: {amount} — mizajou nan pwochen sik bòdwo a",
    "pay.noMethod": "Pa gen metòd pèman anrejistre.",
    "pay.noRecentPayments": "Pa gen pèman resan",
    "pay.onFile": "Anrejistre",
    "pay.paidInFull": "Peye nèt",
    "pay.paidInFullBody": "Kont sa a peye nèt — pa gen anyen pou peye kounye a.",
    "pay.payFullAmountAria": "Peye tout montan {amount}",
    "pay.payInFull": "Peye tout",
    "pay.paymentArrangement": "Konfigire yon antant pèman",
    "pay.paymentMethodTitle": "Metòd pèman",
    "pay.paymentProcessed": "Peman ou an trete.",
    "pay.paymentSuccessful": "Pèman fèt!",
    "pay.payOnlyMeter": "Peye sèlman kontè sa a",
    "pay.payOther": "Peye yon lòt montan",
    "pay.paySpecificBills": "Peye bòdwo espesifik",
    "pay.perAccountConfirmations": "Konfimasyon pou chak kont",
    "pay.plannedForDelivery": "Prevwa pou livrezon",
    "pay.processing": "Ap trete pèman ou…",
    "pay.processingAria": "Ap trete pèman",
    "pay.processingSubtitle": "Tanpri pa fèmen paj sa a",
    "pay.processingTitle": "Ap trete pèman ou",
    "pay.progressLabel": "Pwogrè pèman an",
    "pay.recentBatch": "Pèman an gwoup resan",
    "pay.retry": "Reeseye",
    "pay.retryAria": "Reeseye peman an",
    "pay.securedDisclaimer": "Sekirize · Pwotòtip demo — pa gen vrè pèman trete",
    "pay.selectAmount": "Chwazi montan pèman an",
    "pay.selectMethod": "Chwazi metòd pèman an",
    "pay.smsReceipt": "Resi pa SMS",
    "pay.stepAmount": "Chwazi Montan",
    "pay.stepConfirm": "Konfime",
    "pay.stepDone": "Fini",
    "pay.stepMethod": "Chwazi Metòd",
    "pay.stepProcessing": "Ap trete",
    "pay.summaryAccount": "Kont",
    "pay.summaryAmount": "Montan",
    "pay.summaryMemo": "Memo",
    "pay.summaryMethod": "Metòd pèman",
    "pay.title": "Peye kounye a",
    "pay.total": "Total",
    "pay.underThresholdNote": "Lo ki mwens pase {amount} sote verifikasyon byometrik anplis la.",
    "pay.verifyBiometrics": "Verifye ak byometri (similye)",
    "pay.verifying": "Ap verifye…",
    "pay.whyNoBankAria": "Poukisa pa gen vrè pasrèl pèman?",
    "pay.whyNoBankBody": "Pasrèl la similye selon pozisyon sekirite apèsi a. Entegrasyon pwodiksyon ta mande sikonferans PCI-DSS ak vrè kredansyèl labank — deyò limit apèsi sa a.",
    "pay.whyNoBankTitle": "Poukisa pa gen vrè koneksyon labank?",
    "payStatus.confirmed": "Konfime",
    "payStatus.failed": "Echwe",
    "payStatus.pending": "An atant",
    "persona.lockedAria": "Chanjman pwofil dezaktive pandan peman an",
    "persona.lockedHint": "Fini peman an pou chanje",
    "persona.switchAria": "Chanje pwofil",
    "persona.switchTo": "Chanje pou {name}",
    "pm.accountDetails": "Detay kont",
    "pm.accountNotFound": "Nou pa jwenn kont la.",
    "pm.actions.makeRequest": "Fè yon demann",
    "pm.actions.payBill": "Peye fakti",
    "pm.actions.reportOutage": "Rapòte yon pàn",
    "pm.actions.viewBill": "Wè fakti",
    "pm.allAccountsCount": "Tout pwopriyete ({count})",
    "pm.anomaly.actionHvac": "Revize pwogram klimatizasyon an sou pòtal tèmosta entelijan an",
    "pm.anomaly.actionTenant": "Kontakte lokatè a pou konfime chanjman nan modèl okipasyon an",
    "pm.anomaly.actionThermostat": "Tcheke tèmosta chofaj dlo a — pwograme yon teknisyen",
    "pm.anomaly.allOthersNormal": "Tout lòt kont yo nan ranje nòmal la.",
    "pm.anomaly.badgeSummary": "+18% semèn apre semèn konpare ak menm semèn nan ane pase a",
    "pm.anomaly.causeHeaterDetail": "Sikwi {meter} monte 8 kWh pa jou depi 28 avril — tèmosta a ka an pàn [mezi]",
    "pm.anomaly.causeHeaterTitle": "Chofaj dlo ap depase",
    "pm.anomaly.causeHvacDetail": "Tan fonksyònman klimatizè a monte 22% depi mas — pwogram nan ka reinisyalize apre koupi kouran avril la [mezi]",
    "pm.anomaly.causeHvacTitle": "Dekalaj nan pwogram klimatizasyon an",
    "pm.anomaly.causeTenantDetail": "Kont lan montre 2 chanjman lokatè pandan ane ki sot pase a [dosye CIS]",
    "pm.anomaly.causeTenantTitle": "Chanjman lokatè — nouvo modèl okipasyon",
    "pm.anomaly.dailyKwh": "kWh chak jou — 7 dènye jou yo",
    "pm.anomaly.dayFri": "Van",
    "pm.anomaly.dayMon": "Len",
    "pm.anomaly.daySun": "Dim",
    "pm.anomaly.elevated": "Itilizasyon enèji wo",
    "pm.anomaly.likelyCauses": "Kòz posib",
    "pm.anomaly.recentAnomalies": "Anomali resan nan pòtfèy ou",
    "pm.anomaly.recentBadge": "+18% sem. apre sem.",
    "pm.anomaly.recentDate": "Mwa sa a",
    "pm.anomaly.scheduleTechnician": "Pwograme yon vizit teknisyen",
    "pm.anomaly.subtitle": "{property} · Kont #{account}",
    "pm.anomaly.suggestedActions": "Aksyon sijere",
    "pm.anomaly.title": "Anomali enèji",
    "pm.breadcrumbAria": "Chemen navigasyon",
    "pm.dueDate": "delè {date}",
    "pm.managedAccountsAria": "Pwopriyete jere",
    "pm.managedProperties": "{count} pwopriyete jere",
    "pm.metaAccountNum": "Kont #",
    "pm.metaAddress": "Adrès",
    "pm.metaLastMonthUsage": "Itilizasyon mwa pase",
    "pm.metaMeters": "Kontè",
    "pm.meterCountOne": "{count} kontè",
    "pm.meterCountOther": "{count} kontè",
    "pm.portfolio": "Pòtfèy",
    "pm.portfolioView": "Vi pòtfolyo",
    "pm.portfolioViewP4Only": "Vi sa a disponib pou pwofil jesyonè pwopriyete a (P4).",
    "pm.property": "Pwopriyete",
    "pm.quickActionsAria": "Aksyon rapid",
    "pm.selectAccount": "Chwazi yon pwopriyete",
    "pm.statusNormal": "Nòmal",
    "pm.switchAccount": "Chanje pwopriyete:",
    "pm.switchAria": "Chanje pou yon lòt pwopriyete jere",
    "pm.thBalance": "Balans",
    "pm.thisMonth": "Mwa sa a",
    "pm.thStatus": "Estati",
    "pm.thUsage": "Itilizasyon",
    "pm.usage": "itilizasyon",
    "pm.vacant": "Vid",
    "pm.vacantAnomaly.guidance": "Sa ka vle di gen yon fwit tiyo, yon aparèy ki gate, oswa yon okipasyon san otorizasyon. Konsidere pwograme yon enspeksyon sou plas.",
    "pm.vacantAnomaly.markedVacant": "{property} make kòm vid.",
    "pm.vacantAnomaly.title": "Anomali detekte nan yon pwopriyete vid",
    "pm.viewPropertyAria": "Gade {name}",
    "publicNav.about": "Konsènan",
    "publicNav.askPelican": "Mande Pelican",
    "publicNav.enterPreview": "Antre nan apèsi a",
    "publicNav.help": "Èd",
    "publicNav.home": "Akèy",
    "publicNav.hurricane": "Siklòn",
    "publicNav.sectionNavLabel": "Seksyon paj",
    "publicNav.status": "Estati",
    "report.attachPhoto": "Tache yon foto (opsyonèl)",
    "report.availableNow": "Disponib kounye a",
    "report.descriptionLabel": "Deskripsyon (opsyonèl)",
    "report.descriptionPlaceholder": "egz. Limyè k ap klere-etenn, konplètman etenn, vit kase",
    "report.enterPoleNumber": "Antre nimewo poto",
    "report.mapAreaAria": "Zòn kat la — tape pou mete yon pin sou limyè lari ki an pàn nan",
    "report.mapRoadLabel": "Leeward Hwy",
    "report.outageDescription": "Mete yon pin sou kat la oswa chwazi adrès ou; swiv restorasyon an an tan reyèl.",
    "report.outageName": "Rapòte yon pàn kouran",
    "report.photoFilename": "streetlight-photo.jpg",
    "report.photoUploaded": "1.2 MB · Telechaje kounye a",
    "report.pinPlaced": "Pin mete toupre Leeward Highway",
    "report.poleNumber": "Nimewo poto",
    "report.poleNumberHint": "Chèche nimewo ki make oswa tage sou poto metal la (egz. TCI-4821)",
    "report.poleNumberPlaceholder": "egz. TCI-4821",
    "report.reference": "Referans",
    "report.reportNow": "Rapòte kounye a →",
    "report.slSubmittedTitle": "Rapò voye",
    "report.slSubtitle": "Tape limyè a sou kat la OSWA antre nimewo poto ki make sou poto a.",
    "report.slTitle": "Rapòte yon limyè lari ki gate",
    "report.submitReport": "Voye rapò a",
    "report.subtitle": "Ki kalite pwoblèm w ap rapòte? Tape yon opsyon anba a — n ap mennen w nan bon fòm nan.",
    "report.tapFaultyLight": "Tape limyè lari ki gate a sou kat la",
    "report.tapOnMap": "Tape sou kat la",
    "report.tapToDropPin": "Tape pou mete yon pin sou limyè ki gate a",
    "report.title": "Rapòte yon pwoblèm",
    "report.trackRequests": "Swiv demann mwen yo",
    "report.viewDetails": "Wè detay →",
    "services.allServices": "Tout sèvis",
    "services.backToServices": "Retounen nan Sèvis",
    "services.backToServicesAria": "Retounen nan sèvis",
    "services.continue": "Kontinye",
    "services.dcAttachPrompt": "Tape pou tache devi reparasyon an (PDF, JPG)",
    "services.dcAttachQuotes": "Tache devi reparasyon",
    "services.dcAuthorize": "Mwen konfime reklamasyon sa a kòrèk epi mwen konprann ke fo reklamasyon ka lakòz refi ak aksyon sou kont lan dapre kondisyon sèvis Pelican Energy TCI yo.",
    "services.dcClaimReference": "Referans reklamasyon",
    "services.dcClaimSubmitted": "Reklamasyon voye",
    "services.dcDescribeLabel": "Dekri ekipman oswa pwopriyete ki andomaje a",
    "services.dcDescribePlaceholder": "egz. konpresè AC, frijidè, TV — dekri dega a ak estimasyon pri reparasyon an",
    "services.dcIntro": "Soumèt nan lespas 10 jou apre pàn nan. Desizyon nan 15 jou ouvrab.",
    "services.dcNeedHelp": "Bezwen èd?",
    "services.dcOutageDate": "Dat pàn nan",
    "services.dcOutageDateValue": "Dat pàn ou an",
    "services.dcQuoteFilename": "repair-quote.pdf",
    "services.dcQuoteSize": "180 KB",
    "services.dcReceivedMsg": "Nou resevwa reklamasyon pou dega ou a. Desizyon nan lespas 15 jou ouvrab.",
    "services.dcSubmit": "Voye reklamasyon pou dega",
    "services.dcTitle": "Reklamasyon pou dega",
    "services.dcViewProcess": "Gade pwosesis reklamasyon an sou pelicanenergytci.com",
    "services.districtArea": "Distri / Zòn",
    "services.newRequest": "Nouvo demann",
    "services.noRequests": "Poko gen demann sèvis.",
    "services.serviceAddress": "Adrès sèvis",
    "services.serviceNotFound": "Nou pa jwenn sèvis la.",
    "services.sstAddressSubConfirm": "Konfime adrès sèvis aktyèl ou a",
    "services.sstAddressSubStart": "Antre adrès kote ou bezwen sèvis la",
    "services.sstAuthConfirm": "Mwen konfime enfòmasyon yo bay yo kòrèk epi mwen otorize Pelican Energy TCI pou trete demann sa a. Mwen konprann ke fo enfòmasyon ka retade tretman an.",
    "services.sstAuthSubtitle": "Revize epi otorize demann sèvis ou a.",
    "services.sstConfirmSubtitle": "Nou resevwa demann sèvis ou a epi l ap trete.",
    "services.sstConfirmTitle": "Demann voye",
    "services.sstDateNote": "Pelican Energy TCI ap konfime dat egzak tretman an nan lespas 1 jou ouvrab.",
    "services.sstDateSubtitle": "Kilè chanjman sa a ta dwe antre an vigè? Minimòm 2 jou ouvrab apati jodi a.",
    "services.sstDistrictPlaceholder": "The Bight, Providenciales",
    "services.sstDocFilename": "passport-scan.pdf",
    "services.sstDocFormats": "PDF, JPG, oswa PNG · Maks 10 MB",
    "services.sstDocPrompt": "Tape pou chwazi yon fichye",
    "services.sstDocSize": "245 KB · Telechaje kounye a",
    "services.sstDocsSubtitle": "Telechaje yon idantite ak foto ki valab ak prèv pwopriyete oswa lokasyon.",
    "services.sstDocsTitle": "Dokiman sipò",
    "services.sstEffectiveValue": "dat kòmansman ou chwazi a",
    "services.sstExpectedCompletion": "Finalizasyon prevwa: 5–7 jou ouvrab",
    "services.sstNewAddress": "Nouvo adrès",
    "services.sstNewDistrictPlaceholder": "Distri, Zile",
    "services.sstNewStreetPlaceholder": "Antre nouvo adrès la",
    "services.sstOptStartDesc": "W ap antre nan yon pwopriyete ki bezwen yon nouvo koneksyon",
    "services.sstOptStartLabel": "Kòmanse nouvo sèvis",
    "services.sstOptStopDesc": "W ap demenaje epi ou bezwen fèmen kont lan",
    "services.sstOptStopLabel": "Sispann sèvis ki egziste a",
    "services.sstOptTransferDesc": "W ap demenaje nan yon nouvo adrès epi ou vle kenbe kont ou",
    "services.sstOptTransferLabel": "Transfere sèvis",
    "services.sstReferenceNumber": "Nimewo referans",
    "services.sstReqStop": "Sispann sèvis",
    "services.sstRequestedDate": "Dat mande",
    "services.sstSelectedDate": "Dat ou chwazi a",
    "services.sstStepAddress": "Adrès",
    "services.sstStepAuthorize": "Otorizasyon",
    "services.sstStepConfirmation": "Konfimasyon",
    "services.sstStepDate": "Dat efektif",
    "services.sstStepDocuments": "Dokiman",
    "services.sstStepType": "Kalite demann",
    "services.sstStreetPlaceholder": "14 Bight Park Lane",
    "services.sstSubmit": "Voye demann",
    "services.sstSummaryAccount": "Kont:",
    "services.sstSummaryAddress": "Adrès:",
    "services.sstSummaryEffective": "Efektif:",
    "services.sstSummaryRequest": "Demann:",
    "services.sstTypeSubtitle": "Kòmanse, sispann oswa transfere sèvis elektrik ou — san ou pa bezwen ale nan biwo a.",
    "services.sstTypeTitle": "Kisa ou ta renmen fè?",
    "services.sstUploadAria": "Telechaje yon dokiman",
    "services.startNewRequest": "Kòmanse yon nouvo demann →",
    "services.startRequest": "Kòmanse yon demann",
    "services.streetAddress": "Adrès lari",
    "services.subtitle": "Mande yon chanjman sèvis, soumèt fòm, oswa depoze yon reklamasyon — nou okipe papye yo pou ou pa bezwen ale nan biwo a.",
    "services.title": "Sèvis",
    "services.track": "Swiv ({count})",
    "services.trackAria": "Swiv demann yo ({count} aktif)",
    "services.trackSubtitle": "Gade estati demann sèvis, reklamasyon, ak chanjman kont ou yo.",
    "services.trackTitle": "Swiv demann mwen yo",
    "serviceStatus.activeOutages": "{count} pàn aktif",
    "serviceStatus.allNormal": "Tout sistèm nòmal nan tout uit zile yo",
    "serviceStatus.eta": "ETA {eta}",
    "serviceStatus.hurricanePrep": "Preparasyon siklòn",
    "serviceStatus.lastRestoration": "Dènye retablisman: plis pase 24 èdtan pase · Sèvis ap fonksyone nòmalman",
    "serviceStatus.outagesAcross": "{count} pàn aktif nan {islandCount} zile",
    "serviceStatus.stormApproaching": "{name} ap pwoche",
    "serviceStatus.viewMap": "Gade kat la",
    "serviceStatus.viewOutageMap": "Gade kat pàn →",
    "serviceStatus.yourService": "Sèvis ou ({island}): gade kat la",
    "serviceStatus.yourServiceNormal": "Sèvis ou nan {island}: nòmal · Pa gen pàn aktif",
    "signin.biometricAria": "Konekte ak byometri",
    "signin.biometricButton": "Konekte ak Face ID / anprint dijital",
    "signin.biometricCancel": "Sèvi ak modpas pito",
    "signin.biometricFallback": "Sèvi ak modpas",
    "signin.biometricNotEnrolledBody": "Tanpri konfigire Face ID oswa anprint dijital nan Paramèt, oswa konekte ak imèl ak modpas.",
    "signin.biometricNotEnrolledTitle": "Pa gen byometri anrejistre",
    "signin.biometricPrompt": "Konekte nan Pelican Energy TCI",
    "signin.biometricUnavailableBody": "Aparèy sa a pa sipòte otantifikasyon byometrik.",
    "signin.biometricUnavailableTitle": "Byometri pa disponib",
    "signin.continueAs": "Kontinye kòm {name} →",
    "signin.credentialsHint": "Nenpòt imèl ak modpas fonksyone nan apèsi a.",
    "signin.emailLabel": "Adrès imèl",
    "signin.emailPlaceholder": "ou@imel.com",
    "signin.errorEmpty": "Tanpri antre imèl ou ak modpas ou.",
    "signin.heading": "Konekte",
    "signin.hide": "Kache",
    "signin.hidePasswordAria": "Kache modpas",
    "signin.orChooseDifferent": "Oswa chwazi yon lòt pèsonaj",
    "signin.passwordLabel": "Modpas",
    "signin.quickPickTitle": "Chwazi pèsonaj rapid (rakousi pou prezantatè)",
    "signin.show": "Montre",
    "signin.showPasswordAria": "Montre modpas",
    "signin.signInAsAria": "Konekte kòm {name}",
    "signin.signInButton": "Konekte",
    "signin.signingIn": "Ap konekte…",
    "signin.subtitle": "Chwazi yon pwofil pou antre nan apèsi a — oswa itilize nenpòt imèl ak modpas.",
    "signin.subtitlePreview": "Sèvis pwòp tèt kliyan · Apèsi",
    "signin.useCredentials": "Oswa konekte ak imèl + modpas",
    "signin.welcomeBack": "Byenveni, {name}",
    "srDetail.completed": "Konplete {date}",
    "srDetail.decisionBy": "Desizyon pou {date}",
    "srDetail.expectedBy": "Prevwa pou {date}",
    "srDetail.received": "Resevwa {date}",
    "srStatus.comingSoon": "Talè konsa",
    "srStatus.completed": "Fini",
    "srStatus.inProgress": "An kou",
    "srStatus.inReview": "An revizyon",
    "srStatus.received": "Resevwa",
    "srType.accountUpdate": "Mizajou kont",
    "srType.damageClaim": "Reklamasyon pou dega",
    "srType.duskToDawnLight": "Limyè aswè-a-maten",
    "srType.outageReport": "Rapò pàn",
    "srType.startService": "Kòmanse sèvis",
    "srType.stopService": "Sispann sèvis",
    "srType.streetlightReport": "Rapò limyè lari",
    "srType.transferService": "Transfere sèvis",
    "stubs.accountClosure.description": "Fèmen kont sèvis ou pou tout tan lè w ap demenaje, ak rezime dènye fakti a ak pwosesis ranbousman depo a.",
    "stubs.accountClosure.name": "Fèmen kont mwen",
    "stubs.accountClosure.why": "Fèmen yon kont sèvi ak menm verifikasyon dènye lekti ak règleman ak yon transfè, kidonk l ap vini lè flux sa a fin estabilize.",
    "stubs.accountUpdate.description": "Mete ajou enfòmasyon kontak, adrès postal, ak preferans kominikasyon ou.",
    "stubs.accountUpdate.name": "Mizajou kont",
    "stubs.accountUpdate.why": "Kenbe enfòmasyon kontak ou ajou se baz tout rès la, se poutèt sa li te soti nan premye vèsyon an.",
    "stubs.applyNewService.description": "Mande yon nouvo koneksyon sèvis elektrik nan yon pwopriyete — aplikasyon inisyal, dokiman sipò, pwograme dat koneksyon an.",
    "stubs.applyNewService.link": "Fòm aktyèl sou pelicanenergytci.com",
    "stubs.applyNewService.name": "Aplike pou nouvo sèvis",
    "stubs.applyNewService.why": "Konekte yon pwopriyete tou nèf mande pou pwograme epi swiv yon vizit sou plas — se etap pwogramasyon sa a n ap bati apre.",
    "stubs.autopay.description": "Konfigire peman otomatik fakti mansyèl ou soti nan yon kat ki anrejistre.",
    "stubs.autopay.name": "Peman otomatik",
    "stubs.autopay.why": "Gade yon kat ak ase sekirite pou preleve li otomatikman mande yon pwoteksyon nivo bank, ke n ap mete an plas.",
    "stubs.availableNow": "Disponib kounye a",
    "stubs.comingTitle": "Byento",
    "stubs.comingWhen": "Disponib {when}",
    "stubs.damageClaims.description": "Soumèt yon reklamasyon pou dega yon pàn kouran te lakòz — nan lespas 10 jou, ak devi reparasyon tache. Desizyon nan 15 jou ouvrab.",
    "stubs.damageClaims.link": "Pwosesis aktyèl sou pelicanenergytci.com",
    "stubs.damageClaims.name": "Reklamasyon pou dega",
    "stubs.damageClaims.why": "Pwosesis reklamasyon an te deja egziste — nou mete l nan aplikasyon an pou ou pa bezwen chèche l.",
    "stubs.duskToDawn.description": "Mande enstalasyon oswa ranplasman yon limyè rezidansyèl bò lari a, ansanm ak kantite ki nesesè ak kote a.",
    "stubs.duskToDawn.name": "Aplike pou limyè aswè-a-maten",
    "stubs.duskToDawn.why": "N ap fini demann yo itilize plis yo an premye. Sa a bezwen yon fòm ki anrejistre konbyen limyè ou bezwen ak kote egzak la.",
    "stubs.feedback.description": "Kòmantè ou yo ede defini sa n ap konstwi apre pou kliyan Pelican Energy TCI yo.",
    "stubs.feedback.name": "Voye kòmantè",
    "stubs.feedback.why": "Nou vle tande sa k ap mache ak sa k pa mache pandan aplikasyon an ap pran fòm toujou.",
    "stubs.hazard.description": "Liy kouran tonbe, fil dekouvri, pyebwa danjere sou liy, oswa lòt enkyetid sekirite. Chaje foto sipòte.",
    "stubs.hazard.name": "Rapòte yon danje",
    "stubs.hazard.why": "N ap bati sistèm pou voye foto ak koneksyon dirèk ak ekip sou teren yo yon rapò sekirite depann de yo.",
    "stubs.liveChat.description": "Chat an tan reyèl ak yon ajan sèvis kliyan Pelican Energy TCI pandan lè travay yo.",
    "stubs.liveChat.name": "Chat an dirèk ak sipò Pelican Energy TCI",
    "stubs.liveChat.why": "Chat an dirèk itil sèlman si gen yon moun toujou la pou reponn, kidonk n ap prepare sèvis sipò a an premye.",
    "stubs.meterTools.description": "Soumèt yon lekti manyèl kontè ou lè pa gen yon lekti otomatik, oswa gade melanj enèji k ap alimante adrès ou.",
    "stubs.meterTools.name": "Zouti kontè",
    "stubs.meterTools.why": "Zouti sa yo bezwen yon koneksyon dirèk ak kontè ou, epi n ap konfime kijan kontè prepeye yo antre ladan l.",
    "stubs.notifications.description": "Chwazi kanal livrezon yo (Email, SMS, Push) epi mete lè silans pou chak kalite notifikasyon.",
    "stubs.notifications.name": "Kanal notifikasyon ak lè silans",
    "stubs.notifications.why": "Voye mesaj tèks ak imèl san pwoblèm — epi sonje egzakteman kilès ou vle — se pati n ap bati kounye a.",
    "stubs.notifyAlert": "N ap avize w lè {name} disponib.",
    "stubs.notifyMe": "Avize m lè li pare",
    "stubs.notifyMeAria": "Avèti m lè {name} pare",
    "stubs.ownersConsent.description": "Otorize yon chanjman sèvis sou yon pwopriyete ou posede lè moun k ap viv la ap fè demann nan — ak kapti siyati.",
    "stubs.ownersConsent.name": "Voye konsantman pwopriyetè a",
    "stubs.ownersConsent.why": "Sa a bezwen yon fason sekirize pou pran siyati nan aplikasyon an anvan nou ka aksepte l.",
    "stubs.personalGuarantee.description": "Bay yon garanti pèsonèl pou yon koneksyon oswa amelyorasyon sèvis kote Pelican mande sa.",
    "stubs.personalGuarantee.name": "Voye garanti pèsonèl",
    "stubs.personalGuarantee.why": "Li bezwen menm etap siyati sekirize ak Konsantman Pwopriyetè a, kidonk toude ap rive ansanm.",
    "stubs.powerLineClearance.description": "SafeMoves (deplase gwo ekipman), High-Load (machin twò gwo), Line Locate (fouye) — mande otorizasyon sekirite nan men Pelican Energy TCI.",
    "stubs.powerLineClearance.link": "SafeMoves sou pelicanenergytci.com",
    "stubs.powerLineClearance.name": "Fòm otorizasyon liy elektrik",
    "stubs.powerLineClearance.why": "Travay degaje liy yo enplike kontraktè ou an ansanm ak ou — n ap byen regle demann ou fè poukont ou yo an premye.",
    "stubs.shareBill.description": "Voye yon kopi bòdwo sa a kòm prèv adrès — pa imèl, WhatsApp, oswa yon PDF ou ka enprime.",
    "stubs.shareBill.name": "Pataje bòdwo a",
    "stubs.shareBill.why": "Pataje yon bòdwo kòm prèv adrès vle di kreye yon PDF pwòp epi voye l sou WhatsApp oswa imèl — se sa n ap konstwi.",
    "stubs.startStopTransfer.description": "Antre nan yon pwopriyete, fèmen yon kont, oswa transfere sèvis nan yon nouvo adrès — tout bagay sou telefòn ou, san ou pa bezwen ale nan biwo a.",
    "stubs.startStopTransfer.link": "Fòm aktyèl sou pelicanenergytci.com",
    "stubs.startStopTransfer.name": "Kòmanse, sispann oswa transfere sèvis",
    "stubs.startStopTransfer.why": "Demenaje se demann nou tande pi plis la, kidonk se premye bagay nou te bati.",
    "stubs.streetlight.description": "Tape limyè lari a sou kat la OSWA antre nimewo poto ki make sou poto a.",
    "stubs.streetlight.name": "Rapòte yon limyè lari ki gate",
    "stubs.streetlight.why": "Rapòte yon lari ki fè nwa ta dwe pran kèk segonn, kidonk nou te kòmanse ak kat la ak rechèch nimewo poto a.",
    "stubs.upgradeExtend.description": "Mande yon amelyorasyon kapasite (egz. soti nan monofaz pou trifaz, ogmante anperaj) oswa yon ekstansyon rezo nan yon pwopriyete aleka.",
    "stubs.upgradeExtend.name": "Amelyore sèvis oswa ekstansyon rezo",
    "stubs.upgradeExtend.why": "Yon amelyorasyon bezwen yon etid enjenyè sou rezo ou anvan yon moun ka bay yon pri. N ap chèche kijan pou pwograme sa nan aplikasyon an.",
    "stubs.vacationMode.description": "Fè Pelican konnen lè ou pa la — n ap siveye itilizasyon ki pa nòmal epi n ap avize w.",
    "stubs.vacationMode.name": "Mòd vakans",
    "stubs.vacationMode.why": "Anpil kay isit la rete vid pandan yon pati nan ane a, kidonk sa te vo lapèn bati bonè.",
    "stubs.viewDetails": "Wè detay →",
    "stubs.voiceAlexa.description": "Mande Alexa: «Ki balans Pelican mwen an?» / «Rapòte yon pàn kouran».",
    "stubs.voiceAlexa.name": "Entegrasyon vwa Amazon Alexa",
    "stubs.voiceAlexa.why": "N ap mande kliyan yo si yo ta vrèman itilize vwa a anvan nou bati l.",
    "stubs.whyLater": "Poukisa pita:",
    "stubs.whyNow": "Poukisa kounye a:",
    "support.aiCta": "Poze yon kesyon →",
    "support.aiDescription": "Poze nenpòt kesyon sou kont ou, fakti ou, oswa sèvis Pelican Energy TCI yo — repons yo site done reyèl kont ou.",
    "support.aiTitle": "Asistan Pelican",
    "support.backToSupport": "Retounen nan Sipò",
    "support.open": "Louvri →",
    "support.subtitle": "Jwenn èd ak kont ou — asistan AI nou an disponib 24/7, oswa kontakte yon moun pandan lè travay yo.",
    "support.title": "Sipò Kliyan",
    "toolbar.activePersona": "Pwofil aktif",
    "toolbar.collapse": "Fèmen kontwòl demo",
    "toolbar.exit": "Vizite pelicanenergytci.com",
    "toolbar.expand": "Ouvri kontwòl demo",
    "toolbar.label": "Mòd demo",
    "toolbar.payLockHint": "Fini oswa anile peman an avan",
    "toolbar.personaTypeCommercial": "Komèsyal",
    "toolbar.personaTypeHotel": "Otèl / Komèsyal",
    "toolbar.personaTypeProperty": "Jesyon Pwopriyete",
    "toolbar.personaTypeResidential": "Rezidansyèl",
    "toolbar.reset": "Rekòmanse demo",
    "toolbar.resetConfirmation": "Rekòmansman fini",
  },
  es: {
    "aboutPelican.certsDisclosure": "Certificaciones y premios ({isoCount} ISO + {awardCount} industria)",
    "aboutPelican.heading": "Pelican Energy TCI",
    "aboutPelican.isoBizCont": "Continuidad del negocio",
    "aboutPelican.isoEnvMgmt": "Gestión ambiental",
    "aboutPelican.isoInfoSec": "Seguridad de la información",
    "aboutPelican.isoOHS": "Salud/seguridad ocupacional",
    "aboutPelican.isoServiceMgmt": "Gestión de servicios",
    "aboutPelican.narrative": "Pelican Energy TCI es el proveedor público de electricidad que sirve a ocho islas de Turcas y Caicos, con la visión de \"Transformar la Energía en las Islas Turcas y Caicos\" bajo el lema \"Energy for Good™\". Dirigido por un equipo ejecutivo con sede en Providenciales, con 88% de fuerza laboral isleña de Turcas y Caicos, la empresa opera como subsidiaria de Vision Ridge Partners (inversionista global en activos reales sostenibles) y posee cinco certificaciones ISO y múltiples premios de la industria.",
    "aboutPelican.overline": "SOBRE PELICAN ENERGY TCI",
    "aboutPelican.source": "Fuente:",
    "aboutPelican.statCustomers": "Clientes",
    "aboutPelican.statReliability": "Fiabilidad (3 años)",
    "aboutPelican.statStaff": "Personal",
    "aboutPelican.statWorkforce": "Fuerza laboral TC",
    "aboutPreview.builtFor": "Diseñado para clientes como {name}",
    "aboutPreview.builtForGeneric": "Diseñado para clientes como tú",
    "aboutPreview.bullet1": "4 perfiles de cliente para alternar — residencial, comercial, hotel, administrador de propiedades",
    "aboutPreview.bullet2": "Web y móvil, misma experiencia con reconocimiento de perfil",
    "aboutPreview.bullet3": "Programas para clientes residenciales, comerciales, hoteleros y administradores",
    "aboutPreview.bullet4": "Las 8 islas habitadas de Turcas y Caicos",
    "aboutPreview.heading": "Sobre esta vista previa",
    "aboutPreview.overline": "SOBRE ESTA VISTA PREVIA",
    "aboutPreview.p1": "Esta vista previa es una iniciativa interna de Pelican Energy TCI que muestra lo que puede ser la experiencia del cliente de la empresa. Nada se conecta a cuentas, facturación o pagos reales. Cada interacción funciona con datos sintéticos. Existe para mostrar, de principio a fin, cómo se ve el autoservicio para las Islas Turcas y Caicos.",
    "aboutPreview.p2": "Los clientes de Pelican hoy acceden a su cuenta a través del portal actual de la empresa para pagar facturas y ver consumo. Esta vista previa muestra qué pueden agregar las explicaciones de facturas en español claro, móvil con reconocimiento de perfil y modo de tormenta sin conexión — extendiendo lo que existe, sin reemplazar las partes que funcionan.",
    "access.heading": "Ayuda, instalación y cobertura",
    "access.helpTitle": "Obtener ayuda",
    "access.mobileAlt": "Pantalla de inicio móvil de Pelican Energy TCI",
    "access.mobileDesc": "App móvil nativa — diseñada para la resiliencia en modo tormenta",
    "access.mobileTitle": "Compañero móvil",
    "access.overline": "COMIENCE",
    "access.territoryDesc": "Pelican Energy TCI sirve ocho islas habitadas en las Islas Turcas y Caicos.",
    "access.territoryTitle": "Territorio de servicio",
    "access.viewMap": "Ver mapa interactivo →",
    "account.accountNumber": "Cuenta #{number}",
    "account.billingPrefs": "Preferencias de facturación",
    "account.channelEmail": "Correo",
    "account.channelPush": "Push",
    "account.channelSms": "SMS",
    "account.commPrefs": "Preferencias de comunicación",
    "account.contactInfo": "Información de contacto",
    "account.datePlaceholder": "YYYY-MM-DD",
    "account.eBilling": "Facturación electrónica",
    "account.eBillingDesc": "Recibe las facturas por correo electrónico en lugar de correo postal",
    "account.eBillingToggleAria": "Activar o desactivar facturación electrónica",
    "account.emailAddress": "Correo electrónico",
    "account.feedbackImprove": "¿Qué podríamos mejorar?",
    "account.feedbackPlaceholder": "Tus comentarios...",
    "account.feedbackRateAria": "Calificar {n} de 5",
    "account.feedbackRateLegend": "¿Cómo calificarías tu experiencia?",
    "account.feedbackSubmit": "Enviar comentarios",
    "account.feedbackSubtitle": "Dinos qué funciona y qué no — tus comentarios definen lo que viene después.",
    "account.feedbackThankBody": "Tu opinión ayuda a definir lo que construiremos a continuación para los clientes de Pelican Energy TCI.",
    "account.feedbackThankTitle": "Gracias por tus comentarios",
    "account.feedbackTitle": "Enviar comentarios",
    "account.fieldName": "Nombre",
    "account.from": "Desde",
    "account.fullName": "Nombre completo",
    "account.mailingAddress": "Dirección postal",
    "account.phone": "Teléfono",
    "account.saveChanges": "Guardar cambios",
    "account.saveVacation": "Guardar modo vacaciones",
    "account.title": "Cuenta y ajustes",
    "account.to": "Hasta",
    "account.updateSuccess": "Perfil actualizado correctamente",
    "account.updateTitle": "Actualización de cuenta",
    "account.vacActivate": "Activar modo vacaciones",
    "account.vacActive": "Modo vacaciones activo",
    "account.vacActiveRange": "Activo del {from} al {to}",
    "account.vacationSubtitle": "Avísale a Pelican cuando estés fuera — vigilaremos el uso inusual",
    "account.vacationTitle": "Modo vacaciones",
    "account.vacBullet1": "Avisarte si el uso aumenta inesperadamente (detección de fugas)",
    "account.vacBullet2": "Enviar resúmenes de uso diarios en lugar de alertas en tiempo real",
    "account.vacBullet3": "Marcar cualquier anomalía del medidor para revisarla a tu regreso",
    "account.vacBullet4": "Ajustar automáticamente las recomendaciones de temperatura del HVAC (si está conectado)",
    "account.vacFootnote": "El modo vacaciones es una función nativa de TCI diseñada para propietarios snowbird y viajeros frecuentes — para clientes que pasan parte del año fuera de la isla.",
    "account.vacSaved": "Modo vacaciones guardado",
    "account.vacSetDates": "Configura las fechas abajo y luego actívalo",
    "account.vacToggleAria": "Activar o desactivar modo vacaciones",
    "account.vacWhileAway": "Mientras estés fuera, Pelican hará lo siguiente:",
    "ai.askAnything": "Pregunta a Pelican sobre tu cuenta — prueba uno de estos:",
    "ai.assistantDescription": "El asistente de IA puede responder preguntas sobre cortes, energía solar, demanda y más.",
    "ai.assistantName": "Asistente Pelican",
    "ai.backToTopics": "Volver a los temas",
    "ai.closeAria": "Cerrar asistente",
    "ai.footerDisclaimer": "Prototipo de vista previa — solo datos sintéticos · No es asesoramiento financiero",
    "ai.inputPlaceholder": "Pregunta sobre tu cuenta…",
    "ai.openAssistant": "Abrir asistente →",
    "ai.panelAria": "Asistente Pelican",
    "ai.preview": "Vista previa",
    "ai.processing": "Procesando",
    "ai.sendAria": "Enviar mensaje",
    "ai.standardExplanation": "IA en vivo no disponible — mostrando explicación estándar",
    "ai.thinking": "Pensando…",
    "ai.wantToAsk": "¿Quieres preguntar algo más?",
    "ask.ariaLabelInput": "Haz una pregunta al asistente",
    "ask.ariaLabelSubmit": "Preguntar al asistente",
    "ask.ctaAskAnother": "Preguntar otra",
    "ask.ctaSignIn": "Inicia sesión en la vista previa y continúa con un perfil",
    "ask.ctaSubmit": "Preguntar",
    "ask.ctaSwitchPersona": "Cambiar perfil",
    "ask.disclaimer": "Solo datos sintéticos · basado en tu perfil activo",
    "ask.errorAiDown": "El asistente no está disponible. Prueba un ejemplo o inicia sesión.",
    "ask.errorNetwork": "Problema de red. Inténtalo de nuevo o usa un ejemplo.",
    "ask.errorQuotaExhausted": "Has usado las preguntas en vivo de hoy: vuelve mañana o inicia sesión para seguir explorando. Los ejemplos de arriba siempre están disponibles.",
    "ask.errorRateLimited": "Demasiadas preguntas ahora mismo. Prueba un ejemplo de arriba.",
    "ask.heading": "Pregunta. Obtén respuestas citadas a tus datos.",
    "ask.inputPlaceholder": "Haz tu propia pregunta…",
    "ask.inputPlaceholderShort": "Haz una pregunta…",
    "ask.loading": "Pensando",
    "ask.moduleDesc": "Pregunta sobre una factura, un corte, tu consumo — las respuestas citan los datos detrás de ellas.",
    "ask.moduleDisclaimer": "Dirige al asistente de vista previa — solo datos sintéticos.",
    "ask.overline": "PREGUNTA LO QUE QUIERAS",
    "ask.quotaWarning": "Quedan {remaining} preguntas en vivo hoy",
    "ask.subhead": "Activo: {persona} · perfil {type}",
    "autopay.comingSoon": "Autopago — en la hoja de ruta",
    "balance.currentBalance": "Saldo actual",
    "balance.dueDate": "Vence {date}",
    "balance.noBalanceDue": "Sin saldo pendiente",
    "balance.paidInFull": "Pagado en su totalidad",
    "balance.payNow": "Pagar ahora",
    "balance.setUpAutopay": "Configurar autopago",
    "batchPay.processedOn": "Pago por lote procesado {date}",
    "bill.accountAddress": "Cuenta #{account} · {address}",
    "bill.aiBadge": "IA",
    "bill.aiDisclaimer": "Explicación generada por IA a partir de los datos de tu factura. Se aplican tu consumo y tus tarifas reales.",
    "bill.aiExplainer": "Explicador de Factura IA",
    "bill.aiExplainerSub": "Explicación en lenguaje sencillo basada en tus datos de consumo",
    "bill.askAnythingSub": "El asistente de IA puede responder preguntas sobre cortes, energía solar, demanda y más.",
    "bill.askAnythingTitle": "¿Quieres preguntar algo más?",
    "bill.askFollowUp": "Haz una pregunta de seguimiento",
    "bill.balanceDue": "Saldo pendiente",
    "bill.batchPayAllAccounts": "Pagar Todas las Cuentas",
    "bill.billAssistant": "Asistente de facturación",
    "bill.billingPeriod": "Período de facturación",
    "bill.billTotal": "Total de la factura",
    "bill.chargeDetail": "{kwh} × ${rate}/kWh",
    "bill.charges": "Cargos",
    "bill.confusedAboutBill": "¿Confundido con tu factura? Pregunta al asistente de IA",
    "bill.currentBill": "Factura Actual",
    "bill.currentBillLink": "Factura actual",
    "bill.customerCharge": "Cargo del Cliente",
    "bill.demandCharge": "Cargo por Demanda",
    "bill.demandDetail": "{kw} kW pico × $15.00/kW",
    "bill.demandFee": "Cargo por Demanda",
    "bill.downloadPdf": "Descargar PDF",
    "bill.downloadStatement": "Descargar estado de cuenta (PDF)",
    "bill.dueBadge": "Vence {date}",
    "bill.electricCharge": "Cargo Eléctrico",
    "bill.energyLabel": "Energía",
    "bill.explainAccountLine": "{month} · Cuenta #{account}",
    "bill.explainGroundedTip": "Cada afirmación en esta página se basa en los datos reales de tu factura. Si una afirmación no puede citarse a partir de tus registros, no se muestra.",
    "bill.explainMyBill": "Explicar mi factura",
    "bill.fixedFee": "Tarifa fija",
    "bill.fuelFactor": "Factor de Combustible",
    "bill.generatingExplanation": "Generando explicación…",
    "bill.historyAccountLine": "Cuenta #{account} · {count} pagos",
    "bill.historyCountTotalOne": "{count} pago · {total} en total",
    "bill.historyCountTotalOther": "{count} pagos · {total} en total",
    "bill.historyEmpty": "No hay pagos en este período.",
    "bill.kitchenAnomaly": "Cocina +18% vs. lo que va del mes — evento de brunch",
    "bill.meterAggregate": "Agregado de {count} Medidores",
    "bill.meterIdLocation": "ID del Medidor: {id} · Ubicación: {location}",
    "bill.meterRowAria": "Detalles del medidor {name} — {kwh}",
    "bill.meterUsage": "Consumo: {kwh}",
    "bill.monthlyBaseFee": "Cargo base mensual",
    "bill.monthsFilter": "{months} m",
    "bill.multiMeterBreakdown": "Desglose de varios medidores",
    "bill.net": "neto",
    "bill.noPriorBills": "No hay facturas anteriores registradas",
    "bill.openAssistant": "Abrir asistente →",
    "bill.openDesktopFullView": "Abrir en escritorio para la vista completa",
    "bill.openPortfolioDesktopAria": "Abrir cartera completa en escritorio",
    "bill.paymentHistory": "Historial de Pagos",
    "bill.paymentHistorySub": "Ver todos los pagos anteriores y descargar estados de cuenta",
    "bill.payNow": "Pagar {amount}",
    "bill.portfolioBreakdown": "Desglose de la cartera",
    "bill.portfolioTotal": "Total de la Cartera",
    "bill.preparingPdf": "Preparando PDF…",
    "bill.priorPeriod": "Período anterior",
    "bill.rangeMonths": "{count}m",
    "bill.shareBill": "Compartir Factura",
    "bill.smallCommercial": "Comercial pequeño",
    "bill.solar": "solar",
    "bill.sourceLabel": "Fuente: {badge}",
    "bill.sources": "Fuentes:",
    "bill.stmtRoadmapBody": "La descarga de estados de cuenta está en la hoja de ruta.",
    "bill.stmtRoadmapTitle": "Hoja de ruta",
    "bill.subtotal": "Subtotal",
    "bill.tariffRefCore": "Referencia: tarifa Pelican Energy TCI §4.2 (CORE)",
    "bill.tariffRefUore": "§4.3 (UORE)",
    "bill.thAmount": "Monto",
    "bill.thDate": "Fecha",
    "bill.thisPeriod": "Este período",
    "bill.thMethod": "Método",
    "bill.thMonth": "Mes",
    "bill.thRef": "Ref",
    "bill.thStatus": "Estado",
    "bill.thTotal": "Total",
    "bill.thUsage": "Consumo (kWh)",
    "bill.thVsPrior": "vs. anterior",
    "bill.totalDue": "Total a Pagar",
    "bill.totalPaidRange": "Total pagado (últimos {count} meses)",
    "bill.transactionOne": "{count} transacción",
    "bill.transactionOther": "{count} transacciones",
    "bill.trendFootnote": "Historial completo de 12 meses · Vista de detalle mensual en la hoja de ruta",
    "bill.trendPast12": "Últimos 12 meses",
    "bill.trendTitle": "Tendencia de Consumo y Costo de 12 Meses",
    "bill.twelveMonthHistory": "Historial de 12 meses",
    "bill.understandTitle": "Entiende tu factura",
    "bill.usageLabel": "Consumo",
    "bill.viewBill": "Ver factura",
    "bill.viewSourceAria": "Ver fuente: {label}",
    "bill.whyHigher": "¿Por qué es más alta mi factura?",
    "billing.nextBillLate": "Próxima factura prevista a finales de {month}",
    "billing.paidOn": "Pagado {date}",
    "brand.homeAria": "Inicio de Pelican Energy TCI",
    "common.back": "Atrás",
    "common.backToHome": "Volver al inicio",
    "common.continue": "Continuar",
    "common.deliveryRoadmap": "En la hoja de ruta",
    "common.dismissAlert": "Descartar alerta",
    "common.done": "Listo",
    "common.goBack": "Volver",
    "common.loading": "Cargando",
    "common.notificationsOff": "Las notificaciones están desactivadas",
    "common.openDeviceSettingsAria": "Abrir la configuración del dispositivo",
    "common.openSettings": "Abrir Configuración →",
    "demo.backToOverview": "← Volver al resumen",
    "demo.banner": "Prototipo de vista previa — datos sintéticos únicamente",
    "desktopOnly.batchPaySummary": "Pague las 4 cuentas gestionadas en una sola transacción. Disponible en el escritorio.",
    "desktopOnly.batchPayTitle": "Pagar todas las cuentas en lote",
    "desktopOnly.copied": "✓ ¡Copiado!",
    "desktopOnly.copyUrl": "Copiar URL",
    "desktopOnly.copyUrlAria": "Copiar URL al portapapeles",
    "desktopOnly.ecorSummary": "Ajuste la tasa de ocupación en tiempo real para ver el costo de energía por noche de habitación. Optimizado para portátil.",
    "desktopOnly.ecorTitle": "Control deslizante de ocupación ECOR en vivo",
    "desktopOnly.esgSummary": "Descargue el informe de huella de carbono e intensidad energética de su cartera.",
    "desktopOnly.esgTitle": "Exportar informe ESG",
    "desktopOnly.optimisedNote": "Esta vista está optimizada para portátil / escritorio.",
    "desktopOnly.portfolioSummary": "6 medidores · cuadrícula de análisis detallada · tendencia plurianual. Mejor en una pantalla grande.",
    "desktopOnly.portfolioTitle": "Cartera de hotel / administrador",
    "desktopOnly.scanToOpen": "Escanee para abrir en el escritorio",
    "errors.connectionIssue": "Problema de conexión",
    "errors.dateRangeInvalid": "La fecha de regreso debe ser posterior a la de salida.",
    "errors.emailInvalid": "Ingresa un correo electrónico válido.",
    "errors.emailRequired": "El correo electrónico es obligatorio.",
    "errors.fieldRequired": "{field} es obligatorio.",
    "errors.gatewayUnreachable": "No se pudo conectar con la pasarela de pago. Inténtalo de nuevo.",
    "errors.ratingRequired": "Selecciona una calificación antes de enviar.",
    "errors.resetDemoState": "Restablecer estado de demostración",
    "errors.somethingWrong": "Algo salió mal",
    "errors.tryAgain": "Intentar de nuevo",
    "followUp.compareLastMay": "Comparar con este período del año pasado",
    "followUp.fuelFactor": "¿Qué es el factor de combustible?",
    "followUp.reduceBill": "¿Cómo puedo reducir mi factura?",
    "footer.accessibility": "Accesibilidad",
    "footer.disclaimer": "Solo datos sintéticos · Sin cuentas reales · Sin pagos reales",
    "footer.forms": "Formularios",
    "footer.initiative": "Vista Previa de Experiencia del Cliente — una iniciativa interna de Pelican Energy TCI.",
    "footer.linkApplyService": "Solicitar servicio",
    "footer.linkAskAssistant": "Preguntar al asistente",
    "footer.linkCore": "CORE",
    "footer.linkDamageClaim": "Reclamo por daños",
    "footer.linkEvCharging": "Carga de VE",
    "footer.linkHurricanePrep": "Preparación para huracanes",
    "footer.linkOutageMap": "Mapa de cortes",
    "footer.linkPayBill": "Paga tu factura",
    "footer.linkReportOutage": "Reportar corte",
    "footer.linkSignIn": "Iniciar sesión",
    "footer.linkStopService": "Suspender servicio",
    "footer.linkStreetlight": "Reportar alumbrado",
    "footer.linkUore": "UORE",
    "footer.previewBadge": "Vista previa",
    "footer.privacy": "Privacidad: Solo datos sintéticos · Sin PII recopilada",
    "footer.programs": "Programas",
    "footer.quicklinks": "Enlaces Rápidos",
    "footer.siteLinks": "Enlaces del sitio",
    "footer.subfooter": "Pelican Energy TCI · Vista Previa de Experiencia del Cliente · Solo datos sintéticos · Construido en el espíritu de Energía para el Bien",
    "greeting.afternoon": "Buenas tardes, {name}",
    "greeting.evening": "Buenas noches, {name}",
    "greeting.morning": "Buenos días, {name}",
    "help.ai.desc": "Respuestas de IA con citas de los datos sintéticos de su cuenta.",
    "help.ai.title": "Preguntar al asistente",
    "help.banner": "Esta vista previa muestra lo que tu futura experiencia de cliente de Pelican puede ser. Para cualquier cosa que afecte tu cuenta real hoy — preguntas de facturación, cortes reales, cambios de cuenta — contacta a Pelican Energy TCI usando el teléfono o email de arriba.",
    "help.banner.link": "O visite pelicanenergytci.com →",
    "help.email.title": "Email a Pelican Energy TCI",
    "help.phone.hours": "Horario: ver pelicanenergytci.com →",
    "help.phone.title": "Llamar a Pelican Energy TCI",
    "hero.checkMap": "Ver mapa",
    "hero.enterAs": "Entrar como {name} →",
    "hero.enterGeneric": "Entrar a la vista previa →",
    "hero.exploreAs": "Elige un cliente para explorar",
    "hero.exploringAs": "Explorando como {name} · perfil {type}. Cambia en cualquier momento.",
    "hero.exploringGeneric": "Cambia de perfil en cualquier momento.",
    "hero.eyebrow": "VISTA PREVIA DE EXPERIENCIA DEL CLIENTE",
    "hero.headlineAccent": "hecha para estas islas.",
    "hero.headlinePrimary": "Energía,",
    "hero.langCommitment": "Disponible en English · Kreyòl Ayisyen · Español",
    "hero.langHonestScope": "La página de inicio y el panel de tu cuenta están disponibles en los tres idiomas; las páginas más detalladas aún se están traduciendo.",
    "hero.openHurricanePrep": "Abrir preparación para huracanes →",
    "hero.reportOutage": "Reportar corte",
    "hero.statusAllClear": "Todos los sistemas normales · Servicio operando en las ocho islas",
    "hero.statusPersona": "Servicio en {island}: normal · Todos los sistemas operando",
    "hero.stormActive": "modo de preparación activo",
    "hero.stormEtaBanner": "{name} — ETA {eta}",
    "hero.subhead": "La experiencia del cliente para Pelican Energy TCI — paga tu factura, prepárate para tormentas, pregunta lo que quieras, todo en un solo lugar.",
    "hero.trustMicrocopy": "30 segundos para empezar · Sin registro",
    "home.accountsCount": "{count} cuentas",
    "home.accountsCountDue": "{count} cuentas · Vence {date}",
    "home.accountsCountPaid": "{count} cuentas · Pagado {date} ✓",
    "home.activeOutagesAriaOne": "{count} corte activo, ver mapa",
    "home.activeOutagesAriaOther": "{count} cortes activos, ver mapa",
    "home.activeRequests": "Solicitudes activas",
    "home.activity.batchPayment": "Pago por lote {amount}",
    "home.activity.billIssued": "Factura emitida {amount}",
    "home.activity.billsIssuedTotal": "{count} facturas emitidas — {amount} en total",
    "home.activity.demandChargeApplied": "Cargo por demanda aplicado",
    "home.activity.demandNearMiss": "Demanda casi al límite {load}/{cap} kW",
    "home.activity.highUsageAlertProperty": "Alerta de consumo alto — {property}",
    "home.activity.highUsageAlertSent": "Alerta de consumo alto enviada",
    "home.activity.kitchenMeterAnomaly": "Anomalía del medidor de cocina {pct}",
    "home.activity.outageResolved": "Corte resuelto — zona de {area}",
    "home.activity.paymentReceived": "Pago recibido {amount}",
    "home.activity.portfolioTrend": "Tendencia de cartera {pct}",
    "home.activity.solarExport": "Exportación solar {kwh} kWh",
    "home.activity.solarExportCredited": "Exportación solar {kwh} kWh acreditada",
    "home.activity.usageAbovePrior": "Consumo {pct} por encima del ciclo anterior",
    "home.activity.vacantAnomaly": "Anomalía en vacancia — {property}",
    "home.aiCalloutSub": "Explicación en lenguaje sencillo con citas de tus datos de consumo",
    "home.alert.anomaly": "Anomalía detectada",
    "home.alert.countOne": "{count} alerta",
    "home.alert.countOther": "{count} alertas",
    "home.alert.demand": "Demanda cerca del umbral",
    "home.alert.storm": "{name}",
    "home.allPowerOn": "Todo con energía",
    "home.anomaly": "Anomalía",
    "home.askNow": "Preguntar ahora →",
    "home.contextHighlightDiveDay": "costo prom. por día de buceo",
    "home.demand": "Demanda",
    "home.demandShedHint": "Carga actual dentro del {pct} del umbral de {cap} kW — considera reducir el aire acondicionado en habitaciones desocupadas.",
    "home.ecorPerRoomNight": "por noche de habitación ocupada",
    "home.etaLabel": "Hora estimada:",
    "home.kwValue": "{value} kW",
    "home.liveOccupancySlider": "Control de ocupación en vivo →",
    "home.liveOccupancySliderDesktop": "Control de ocupación en vivo (escritorio) →",
    "home.managedProperties": "Propiedades gestionadas",
    "home.managedPropertiesSub": "{count} propiedades · monitoreo de anomalías",
    "home.nearThreshold": "cerca del umbral",
    "home.networkStatus": "Estado de la red",
    "home.noActiveRequests": "Sin solicitudes activas",
    "home.noRecentActivity": "Sin actividad reciente",
    "home.ofKwThreshold": " / {cap} kW umbral",
    "home.openEcorDesktopAria": "Abrir control ECOR en vivo en escritorio",
    "home.openPortfolio": "Abrir cartera →",
    "home.outageActiveAria": "Corte de energía activo en {circuit} — toca para ver detalles",
    "home.outageCountOne": "{count} corte",
    "home.outageCountOther": "{count} cortes",
    "home.outageIn": "Corte en {circuit}",
    "home.peakDemand": "Demanda máxima",
    "home.peakDemandAria": "Demanda máxima {load} kW de un umbral de {cap} kW",
    "home.pelicanInsights": "Perspectivas Pelican",
    "home.portfolioBalance": "Saldo de cartera",
    "home.portfolioDashboard": "Panel de cartera",
    "home.portfolioMetersSub": "{count} medidores · ocupación · detección de anomalías",
    "home.powerOn": "Energía activa",
    "home.propertiesFlagged": "{count} de {total} propiedades marcadas este período",
    "home.recentActivity": "Actividad reciente",
    "home.report": "Reportar →",
    "home.reportOutageAria": "Reportar un corte de energía",
    "home.reportPowerOut": "¿Sin energía? Repórtalo ahora",
    "home.reportPowerOutSub": "Un toque — coloca un pin en {address} o elige otra dirección",
    "home.solarCapacityPanels": "{kw} kW CORE · {panels} paneles",
    "home.solarExportedOffset": "{kwh} exportado · {pct}% del consumo compensado",
    "home.solarThisMonth": "Solar este mes",
    "home.tapForPrepMode": "Toca para modo preparación →",
    "home.time.lastMonth": "El mes pasado",
    "home.time.lastWeek": "La semana pasada",
    "home.time.thisCycle": "Este ciclo",
    "home.time.thisMonth": "Este mes",
    "home.time.today": "Hoy",
    "home.usage12mo": "Consumo (12 meses)",
    "home.usageAnomalyDetected": "Anomalía de consumo detectada",
    "home.usageCostTrend": "{sign}{pct}% de costo vs. ciclo anterior",
    "home.usageLastMonth": "{kwh} el mes pasado",
    "home.usageThisMonth": "Consumo este mes",
    "home.usageVsPriorCycle": "{sign}{pct}% vs. ciclo anterior",
    "home.viewActivity": "Ver actividad →",
    "home.viewAll": "Ver todo",
    "home.viewAllRequestsAria": "Ver todas las solicitudes",
    "home.viewAnomalyAria": "Ver detalles de la anomalía",
    "home.viewHurricaneChecklistAria": "Ver lista de preparación para huracanes",
    "home.viewInvestigation": "Ver investigación →",
    "home.viewMap": "Ver mapa",
    "home.viewProperties": "Ver propiedades →",
    "hotel.alerts.demandNearMiss": "Demanda casi excedida: {actual} kW / umbral de {threshold} kW",
    "hotel.alerts.demandNearMissSub": "Resuelto automáticamente",
    "hotel.alerts.kitchen": "Medidor de cocina y A&B +18% frente al mes anterior a la fecha",
    "hotel.alerts.kitchenSub": "evento de brunch",
    "hotel.alerts.panelMaintenance": "Mantenimiento de panel vencido — {meter}",
    "hotel.alerts.panelMaintenanceSub": "Panel de distribución de piscina y spa",
    "hotel.alerts.timeLastMonth": "El mes pasado",
    "hotel.alerts.timeTwoMonthsAgo": "Hace 2 meses",
    "hotel.band.occupancy": "{pct}% de ocupación",
    "hotel.ecor.aboveBy": "{pct}% por encima",
    "hotel.ecor.ariaEcor": "ECOR: {amount} por habitación ocupada por noche",
    "hotel.ecor.ariaSlider": "{pct}% de ocupación — ECOR {amount}",
    "hotel.ecor.avgSuffix": "promedio",
    "hotel.ecor.barCaribbeanLuxury": "Lujo del Caribe",
    "hotel.ecor.barTciAvg": "Promedio turístico de TCI",
    "hotel.ecor.barThisHotel": "Este hotel (actual)",
    "hotel.ecor.benchmarkLine": "Referencia de lujo del Caribe ajustada a TCI {amount} — estás {delta}",
    "hotel.ecor.bestNights": "Las 3 mejores noches ({month})",
    "hotel.ecor.betterBy": "{pct}% mejor",
    "hotel.ecor.compareHeading": "¿Cómo se compara mi ECOR?",
    "hotel.ecor.currentSeason": "{pct}% (actual)",
    "hotel.ecor.dragHint": "Desliza el control de ocupación de arriba para ver cómo la carga cambia tu posición frente a las referencias.",
    "hotel.ecor.fullSeason": "{pct}% (completo)",
    "hotel.ecor.industryBenchmarks": "Referencias del sector",
    "hotel.ecor.kwhPerGuestNight": "kWh por noche de huésped",
    "hotel.ecor.lowSeason": "{pct}% (temporada baja)",
    "hotel.ecor.occupancy": "Ocupación",
    "hotel.ecor.perRoomNight": "por habitación ocupada por noche",
    "hotel.ecor.renewableAvg": "% renovable promedio",
    "hotel.ecor.stubBody": "Disponible solo para cuentas hoteleras. Cambia a Long Bay Reef Resort (P3).",
    "hotel.ecor.stubTitle": "Control ECOR",
    "hotel.ecor.subtitle": "Costo de energía por habitación ocupada por noche",
    "hotel.ecor.titleSuffix": "en vivo",
    "hotel.ecor.worstNights": "Las 3 peores noches ({month})",
    "hotel.esg.actionHvacDetail": "Instala sensores en cada una de las {suites} suites para reducir el aire acondicionado automáticamente cuando las habitaciones estén vacías.",
    "hotel.esg.actionHvacSaving": "~8% de energía de climatización",
    "hotel.esg.actionHvacTitle": "Climatización con sensor de ocupación",
    "hotel.esg.actionLedDetail": "Cambia las luces de sendero de halogenuro metálico de 400 W restantes por equivalentes LED de 40 W en todos los terrenos.",
    "hotel.esg.actionLedSaving": "~3.200 kWh al mes",
    "hotel.esg.actionLedTitle": "Mejora de iluminación LED en exteriores",
    "hotel.esg.actionSolarDetail": "Sustituye los calentadores eléctricos de resistencia de la piscina por colectores solares térmicos montados en el techo.",
    "hotel.esg.actionSolarSaving": "~15 kW de reducción de demanda",
    "hotel.esg.actionSolarTitle": "Calentamiento solar térmico de piscina",
    "hotel.esg.co2Avoided": "CO₂e evitado",
    "hotel.esg.coreProgramme": "Programa CORE",
    "hotel.esg.currentCycle": "Ciclo actual",
    "hotel.esg.energySummary": "Resumen energético actual",
    "hotel.esg.exportPdf": "Exportar PDF",
    "hotel.esg.generating": "Generando…",
    "hotel.esg.goalHeatPump": "Instalar calentamiento de agua con bomba de calor en las {suites} suites",
    "hotel.esg.goalKwh": "Reducir los kWh por noche de huésped por debajo de 35 antes de fin de año",
    "hotel.esg.goalLeed": "Obtener la certificación LEED Silver para 2027",
    "hotel.esg.goalRenewable": "Alcanzar un 40% de participación renovable para 2027",
    "hotel.esg.goalsFootnote": "Programa de Metas de Sostenibilidad del DOI — objetivos alineados con el Departamento de Medio Ambiente de TCI",
    "hotel.esg.goalsHeading": "Metas de sostenibilidad {year}",
    "hotel.esg.grossConsumption": "Consumo bruto",
    "hotel.esg.industryAvg": "Promedio del sector {value}",
    "hotel.esg.industryAvgPct": "Promedio del sector {value}%",
    "hotel.esg.netBilled": "kWh netos facturados",
    "hotel.esg.policyReferences": "Referencias normativas",
    "hotel.esg.renewableLine": "Renovable (solar + red verde)",
    "hotel.esg.stubBody": "Disponible solo para cuentas hoteleras. Cambia a Long Bay Reef Resort (P3).",
    "hotel.esg.stubTitle": "Informe ESG",
    "hotel.esg.suggestedActions": "Acciones sugeridas para mejorar tu puntuación",
    "hotel.esg.title": "Informe energético ESG",
    "hotel.esg.totalCost": "Costo total de energía",
    "hotel.esg.uoreProgramme": "Programa UORE",
    "hotel.esg.vsGridBaseline": "frente a la línea base de la red",
    "hotel.kpi.ecor": "ECOR",
    "hotel.kpi.ecorSub": "por habitación ocupada por noche",
    "hotel.kpi.kwhPerGuestNight": "kWh por noche de huésped",
    "hotel.kpi.kwhPerGuestNightSub": "promedio del sector {value}",
    "hotel.kpi.pctRenewable": "% renovable",
    "hotel.kpi.pctRenewableSub": "promedio del sector {pct}%",
    "hotel.kpi.peakDemand": "Demanda máxima",
    "hotel.kpi.peakDemandSub": "umbral {kw} kW",
    "hotel.mobile.meterMainKitchen": "Cocina Principal",
    "hotel.mobile.meterPoolSpa": "Piscina y Spa",
    "hotel.mobile.metersSummaryOne": "{name} · {count} medidor",
    "hotel.mobile.metersSummaryOther": "{name} · {count} medidores",
    "hotel.mobile.meterSuiteBlockA": "Bloque de Suites A",
    "hotel.mobile.occupancyAtSync": "Ocupación en la última sincronización · {pct}%",
    "hotel.mobile.openDashboardDesktop": "Abrir el panel del hotel en el escritorio",
    "hotel.mobile.propertyOverview": "Resumen de la propiedad",
    "hotel.mobile.topMeters": "Medidores principales de este período",
    "hotel.portfolio.actionsAria": "Acciones de la cartera",
    "hotel.portfolio.anomalyBadge": "Anomalía",
    "hotel.portfolio.anomalyDetail": "+18% frente al mes anterior a la fecha — evento de brunch",
    "hotel.portfolio.ecorSlider": "Control ECOR en vivo",
    "hotel.portfolio.esgReport": "Informe ESG",
    "hotel.portfolio.kpisHeading": "Indicadores",
    "hotel.portfolio.loadShedPlaybook": "Plan de reducción de carga",
    "hotel.portfolio.metersHeading": "{count} medidores",
    "hotel.portfolio.nearPeakDemand": "Cerca de la demanda máxima",
    "hotel.portfolio.occupancyAria": "Ocupación {pct}% — desliza el control en la página de ECOR",
    "hotel.portfolio.occupancyBadge": "{pct}% de ocupación · desliza →",
    "hotel.portfolio.payAllMeters": "Pagar los {count} medidores",
    "hotel.portfolio.pctOfTotal": "{pct}% del total",
    "hotel.portfolio.projected": "proyectado",
    "hotel.portfolio.recentAlerts": "Alertas recientes",
    "hotel.portfolio.setDemandAlert": "Crear alerta de demanda",
    "hotel.portfolio.stubBody": "Esta vista solo está disponible para cuentas hoteleras. Cambia a Long Bay Reef Resort & Spa (P3) para ver el panel de la cartera.",
    "hotel.portfolio.stubTitle": "Cartera hotelera",
    "hotel.portfolio.thisMonthToDate": "Este mes hasta la fecha",
    "hotel.portfolio.viewDetails": "Ver detalles →",
    "hotel.portfolioLink": "Cartera",
    "hurricane.activeAdvisory": "Aviso activo",
    "hurricane.alertTitle": "⚠ Aviso de huracán",
    "hurricane.atlanticSeason": "Temporada Atlántica:",
    "hurricane.autoActivates": "Se activa automáticamente cuando una tormenta se acerca a tu área de servicio.",
    "hurricane.callContactAria": "Llamar a {name}",
    "hurricane.check": "Marcar",
    "hurricane.checklistCharger": "Cargador portátil de teléfono",
    "hurricane.checklistFlashlights": "Linternas + baterías",
    "hurricane.checklistFood": "Alimentos no perecederos",
    "hurricane.checklistMedication": "Suministro de medicamentos para 7 días",
    "hurricane.checklistProgress": "{done}/{total} completado",
    "hurricane.checklistWater": "Agua (2 gal × personas × 3 días)",
    "hurricane.connectivityBand": "Diseñado para la experiencia real de tormentas del Caribe: el modo tormenta sin conexión en el móvil y el SMS de respaldo están en la hoja de ruta de entrega.",
    "hurricane.contactDdmeDetail": "Autoridad oficial de gestión de emergencias",
    "hurricane.contactHospitalDetail": "Hospital principal, Providenciales",
    "hurricane.contactHotlineDetail": "Preparación para tormentas e información de refugios",
    "hurricane.contactOutageDetail": "Cortes de energía y emergencias",
    "hurricane.emergencyContacts": "Contactos de emergencia",
    "hurricane.etaLabel": "ETA",
    "hurricane.explorePrep": "Explorar preparación para huracanes",
    "hurricane.genCriticalLoads": "Cargas críticas identificadas",
    "hurricane.genCriticalLoadsDetail": "Seguridad vital, cámaras frías de cocina y ascensores de huéspedes en los circuitos del generador",
    "hurricane.generatorCoordination": "Coordinación del generador",
    "hurricane.generatorIntro": "Preparación del generador previa a la tormenta, específica para hoteles, para Long Bay Reef Resort.",
    "hurricane.genFuelLevel": "Nivel de combustible",
    "hurricane.genFuelLevelDetail": "Reserva mínima de 72 horas (objetivo: tanque al 100%)",
    "hurricane.genMaintenanceLog": "Registro de mantenimiento actualizado",
    "hurricane.genMaintenanceLogDetail": "Última fecha de servicio y próximo servicio programado registrados",
    "hurricane.genManualTest": "Prueba manual",
    "hurricane.genManualTestDetail": "Enciende el generador principal 30 min bajo carga",
    "hurricane.genTransferSwitch": "Interruptor de transferencia probado",
    "hurricane.genTransferSwitchDetail": "Verifica la transferencia automática dentro de 10 segundos tras un fallo de la red",
    "hurricane.heading": "Listo para tormentas, siempre.",
    "hurricane.loadingStormMap": "Cargando mapa de tormenta…",
    "hurricane.offSeasonIntro": "La temporada de huracanes va del 1 Jun al 30 Nov. Los clientes de Pelican Energy TCI obtienen un modo de preparación personalizado, rastreador de tormentas en vivo, lista de preparación, contactos de emergencia y seguimiento de restauración post-tormenta.",
    "hurricane.offSeasonMessage": "La temporada de huracanes va del 1 Jun al 30 Nov. Vuelve más cerca de la temporada.",
    "hurricane.openPrep": "Abrir preparación para huracanes",
    "hurricane.overline": "LISTO PARA TORMENTAS",
    "hurricane.preparedness": "La temporada de huracanes va del 1 Jun al 30 Nov. Mantén tu lista de preparación actualizada.",
    "hurricane.prepChargeDevices": "Carga todos los dispositivos al 100%",
    "hurricane.prepChecklist": "Lista de preparación",
    "hurricane.prepChecklistTitle": "Lista de preparación",
    "hurricane.prepFillBathtub": "Llena la bañera con agua",
    "hurricane.prepFillCoolers": "Llena las neveras con hielo",
    "hurricane.prepIdentifyShelter": "Identifica la ubicación de tu refugio",
    "hurricane.prepIdentifyShelterDetail": "Lista de refugios del gobierno de TCI: gov.tc/dcr",
    "hurricane.prepLocateFlashlights": "Localiza linternas y baterías",
    "hurricane.prepModeLink": "Modo de preparación →",
    "hurricane.prepModeTitle": "Modo de preparación para huracanes",
    "hurricane.prepMoveFurniture": "Mete los muebles de exterior",
    "hurricane.prepRefillPrescriptions": "Reabastece tus recetas médicas",
    "hurricane.prepSecureDocuments": "Guarda los documentos importantes en una bolsa impermeable",
    "hurricane.prepSecureDocumentsDetail": "Pasaportes, seguros, escrituras de propiedad",
    "hurricane.prepStockFood": "Abastece 3 días de alimentos no perecederos y agua",
    "hurricane.prepStockFoodDetail": "1 galón de agua por persona por día",
    "hurricane.prepTestGenerator": "Prueba el generador de respaldo",
    "hurricane.prepTestGeneratorDetail": "Enciéndelo 15 min; revisa el nivel de combustible y el interruptor de transferencia",
    "hurricane.projectedTrack": "{name} — trayectoria proyectada",
    "hurricane.reEnableAlerts": "Vuelva a activarlo en Configuración para enviar alertas de huracán.",
    "hurricane.sampleChecklist": "Lista de preparación de muestra",
    "hurricane.seasonActive": "Temporada de huracanes",
    "hurricane.seasonActiveBadge": "Temporada activa",
    "hurricane.seasonDates": "1 Jun – 30 Nov",
    "hurricane.seasonIndicator": "Indicador de temporada de huracanes",
    "hurricane.seeFullChecklist": "Ver lista completa →",
    "hurricane.seeFullTracker": "Ver rastreador completo →",
    "hurricane.shelterDept": "Departamento de Gestión de Desastres y Emergencias",
    "hurricane.shelterRegister": "Registro Oficial de Refugios de TCI",
    "hurricane.stormApproaching": "{name} aproximándose · ETA {eta}",
    "hurricane.stormBannerMessage": "Temporada de huracanes activa — {name} aproximándose a Provo, ETA {eta}. Toca para el modo de preparación.",
    "hurricane.stormEta": "ETA:",
    "hurricane.stormName": "Nombre:",
    "hurricane.stormTracker": "Rastreador de tormentas",
    "hurricane.trackerAria": "Mapa rastreador de tormenta que muestra la trayectoria proyectada de {name}",
    "hurricane.trackerDisclaimer": "Trayectoria sintetizada solo para fines de demostración — no son datos en vivo del NHC.",
    "hurricane.uncheck": "Desmarcar",
    "hurricane.viewChecklist": "Ver lista de preparación →",
    "hurricane.viewFullChecklist": "Ver lista completa (12 elementos) →",
    "hurricane.viewOutageMap": "Ver mapa de cortes",
    "insights.cta.claimCredit": "Reclamar crédito",
    "insights.cta.scheduleTechnician": "Programar técnico",
    "insights.cta.tellMeMore": "Cuéntame más",
    "insights.cta.viewDetail": "Ver detalle",
    "insights.duration.hoursMinutes": "{hours} h {minutes} min",
    "insights.duration.hoursOnly": "{hours} h",
    "insights.duration.minutesOnly": "{minutes} min",
    "insights.leadFigure.kwhPerDay": "{value} kWh/día",
    "insights.p1OutageSpoilage.body": "Interrupción del alimentador de Bight Park el {date} — podría calificar para un crédito por deterioro de hasta $25.",
    "insights.p1SolarApril.body": "en crédito por exportación solar este ciclo — tu mejor registro (38% del consumo compensado).",
    "insights.p1UsageTrend.body": "consumo este ciclo frente al anterior — principalmente aire acondicionado los fines de semana por la noche (12% por encima del promedio entre semana).",
    "insights.p2DiveDayCost.body": "costo eléctrico promedio por día de buceo este ciclo — el ciclo del compresor de aire es tu mayor partida.",
    "insights.p2GrandTurkFuel.body": "factor de combustible de Grand Turk este mes — ligeramente por debajo del 0.1564 de Provo por el calendario de envíos de combustible.",
    "insights.p2WeeklyPattern.body": "aumento de consumo cada martes/miércoles — probablemente llenado de tanques con el compresor tras los buceos del fin de semana.",
    "insights.p3DemandNearMiss.body": "demanda máxima el miércoles pasado — aplazar la lavandería de 2 a 6 AM podría evitar la próxima superación del umbral.",
    "insights.p3EsgOffset.body": "del consumo de este ciclo compensado por tus 80 kW de solar CORE — el referente de lujo de TCI es 12%, y los +200 kW aprobados por la junta cierran la brecha.",
    "insights.p3KitchenAnomaly.body": "medidor de Cocina y F&B de martes a jueves {recency} — coincide con el evento de brunch en tu calendario.",
    "insights.p4PortfolioTrend.body": "consumo de la cartera este ciclo frente al anterior (5,568 frente a 5,580 kWh) — estacionalmente estable en 4 propiedades; la anomalía de Sea Breeze es la única excepción.",
    "insights.p4SandyCoveSavings.body": "tasa de consumo de Villa Sandy Cove frente al valor de referencia previo a la auditoría — una auditoría de medidor por cambio de inquilino detectó una bomba de pozo en marcha 24/7.",
    "insights.p4VillaAnomaly.body": "Villa Sea Breeze durante 2 semanas de desocupación — posible equipo siempre encendido, se sospecha del calentador de agua.",
    "insights.recencyLastWeek": "la semana pasada",
    "install.androidCta": "Descargar .apk",
    "install.androidDesc": "App nativa real. Escanea para descargar el último .apk e instalar en Android.",
    "install.browserCta": "Continuar a la vista previa →",
    "install.browserDesc": "Experiencia web completa en cualquier dispositivo. Recomendado para escritorio.",
    "install.gotIt": "Entendido",
    "install.iphoneDesc": "Escanea con la cámara de tu iPhone, luego toca 'Agregar a pantalla de inicio' en Safari.",
    "install.iphoneModalLabel": "Instalar en iPhone",
    "install.iphoneModalTitle": "Agregar a pantalla de inicio del iPhone",
    "install.iphoneSteps": "Ver instrucciones paso a paso",
    "install.step1Open": "Abre",
    "install.step1Safari": "en Safari en tu iPhone.",
    "install.step2Share": "Compartir",
    "install.step2TapThe": "Toca el botón",
    "install.step2Toolbar": "(cuadro con flecha) en la barra de herramientas de Safari.",
    "install.step3AddHome": "\"Agregar a pantalla de inicio\"",
    "install.step3ScrollTap": "Desplázate hacia abajo y toca",
    "install.step4Add": "Agregar",
    "install.step4Confirm": "para confirmar. El icono de Pelican aparece en tu pantalla de inicio.",
    "install.step4Tap": "Toca",
    "install.tablistLabel": "Ruta de instalación",
    "landing.backToTop": "Volver arriba",
    "latest.ariaLabel": "Últimas noticias de Pelican Energy TCI",
    "latest.heading": "Lo último de Pelican Energy TCI",
    "latest.more": "Más de Pelican Energy TCI",
    "more.aiAssistant": "Asistente Pelican",
    "more.changeLanguageAria": "Cambiar idioma. Actual: {name}",
    "more.sectionAccount": "Cambiar de propiedad",
    "more.sectionLanguage": "Idioma",
    "more.sectionNavigate": "Navegar",
    "more.sectionPersona": "Persona",
    "more.sectionSession": "Sesión",
    "more.sectionShortcuts": "Accesos directos",
    "more.signOut": "Cerrar sesión",
    "more.tapToCycle": "Toca para cambiar",
    "more.viewAccountAria": "Ver propiedad {name}",
    "nav.account": "Cuenta",
    "nav.bill": "Factura",
    "nav.home": "Inicio",
    "nav.menu": "Menú",
    "nav.outageMap": "Mapa de Cortes",
    "nav.pay": "Pagar",
    "nav.report": "Reportar",
    "nav.services": "Servicios",
    "nav.support": "Soporte",
    "notifications.allShown": "Todas las notificaciones",
    "notifications.ariaOne": "Notificaciones ({count} sin leer)",
    "notifications.ariaOther": "Notificaciones ({count} sin leer)",
    "notifications.close": "Cerrar notificaciones",
    "notifications.markAll": "Marcar todas como leídas",
    "notifications.title": "Notificaciones",
    "outage.activeIncidentsOne": "{count} incidente activo",
    "outage.activeIncidentsOther": "{count} incidentes activos",
    "outage.activeOutagesOne": "{count} corte activo",
    "outage.activeOutagesOther": "{count} cortes activos",
    "outage.advanceState": "Avanzar estado (demo) →",
    "outage.affected": "{count} afectados",
    "outage.allNormal": "Todos los sistemas normales",
    "outage.backToMap": "Mapa de cortes",
    "outage.closeDetail": "Cerrar detalles del corte",
    "outage.crew": "Cuadrilla",
    "outage.crewNotDispatched": "Cuadrilla aún no enviada",
    "outage.crewOnSite": "Cuadrilla en el sitio — 2 técnicos, Camión n.º 14",
    "outage.crewStatus": "Estado de la cuadrilla",
    "outage.customersAffected": "{count} clientes afectados",
    "outage.customersCountOne": "{count} cliente",
    "outage.customersCountOther": "{count} clientes",
    "outage.detailAria": "Detalles del corte — {circuit}",
    "outage.dismissReportAria": "Descartar la confirmación del reporte de corte",
    "outage.distanceKm": "{km} km",
    "outage.distanceToSite": "Distancia al sitio",
    "outage.eta": "ETA",
    "outage.getNotified": "Recibir aviso cuando se restablezca",
    "outage.lastUpdate": "Última actualización",
    "outage.legendActiveEtaSet": "Activo — con ETA",
    "outage.legendActiveNoEta": "Activo — sin ETA",
    "outage.legendHide": "Ocultar leyenda del mapa",
    "outage.legendResolved": "Resuelto",
    "outage.legendScheduled": "Programado",
    "outage.legendShow": "Mostrar leyenda del mapa",
    "outage.legendTitle": "Leyenda",
    "outage.listAria": "Lista de cortes",
    "outage.listView": "Ver lista",
    "outage.loadingMap": "Cargando mapa…",
    "outage.mapAppAria": "Mapa de cortes de TCI",
    "outage.mapTitle": "Mapa de cortes",
    "outage.mapView": "Ver mapa",
    "outage.metaAffected": "Afectados",
    "outage.metaCause": "Causa",
    "outage.metaCircuit": "Circuito",
    "outage.metaReported": "Reportado",
    "outage.minAgo": "hace {min} min",
    "outage.moduleHeading": "Cortes y preparación para tormentas",
    "outage.notFound": "Corte no encontrado.",
    "outage.notifPushBody": "{circuit} está en línea de nuevo. Tu servicio debería estar activo.",
    "outage.notifPushTitle": "Energía restaurada",
    "outage.notifReEnable": "Vuelva a activarlo en Configuración para suscribirse a las novedades de cortes.",
    "outage.notifyConfirm": "Se le notificará cuando se restablezca la energía. (Demo: llega en 5 s.)",
    "outage.notifySubtitle": "Reciba una notificación cuando vuelva la energía",
    "outage.notifyTitle": "Avisar cuando se restablezca",
    "outage.notifyToggleAria": "Alternar notificación de restablecimiento de corte",
    "outage.pinAria": "Corte {status} — {circuit}",
    "outage.prepModeActive": "Modo de preparación activo · ETA {eta}",
    "outage.recentUpdates": "Actualizaciones recientes",
    "outage.reporter.confirmingSubmit": "Reportando…",
    "outage.reporter.dismiss": "Descartar",
    "outage.reporter.idleSubmit": "Reportar ahora",
    "outage.reporter.idleTitle": "¿Sin energía en su ubicación?",
    "outage.reporter.reference": "Referencia",
    "outage.reporter.submittedSuffix": "Le avisaremos cuando se despachen las cuadrillas.",
    "outage.reporter.submittedTitle": "Corte reportado — gracias",
    "outage.reportOutage": "Reportar un corte →",
    "outage.scheduled": "Programado",
    "outage.serviceLocationAria": "Tu ubicación de servicio",
    "outage.simulatedStatus": "Estado de circuito simulado en las ocho islas.",
    "outage.started": "Iniciado {date}",
    "outage.statusTimeline": "Cronología de estado",
    "outage.step.crewDispatched": "Cuadrilla enviada",
    "outage.step.investigating": "Investigando",
    "outage.step.received": "Recibido por despacho",
    "outage.step.resolved": "Energía restaurada",
    "outage.step.restoring": "Restaurando energía",
    "outage.step.submitted": "Reporte enviado",
    "outage.stepCurrent": "actual",
    "outage.stormLabel": "Tormenta {name}",
    "outage.subscribed": "Suscrito — le avisaremos cuando se restablezca la energía",
    "outage.timeline.crewDispatched": "Cuadrilla enviada",
    "outage.timeline.investigating": "Investigando",
    "outage.timeline.received": "Recibido",
    "outage.timeline.resolved": "Resuelto",
    "outage.timeline.restoring": "Restableciendo",
    "outage.timeline.submitted": "Enviado",
    "outage.timelineAria": "Cronología del progreso del corte",
    "outage.timelineTitle": "Cronología",
    "outage.viewLatest": "Ver el último corte",
    "outage.viewMap": "Ver el mapa de cortes →",
    "outage.viewTimeline": "Ver cronología completa",
    "outage.yourCircuit": "Tu circuito",
    "outageStatus.activeNoEta": "Activo — sin ETA",
    "outageStatus.activeWithEta": "Activo — cuadrilla en camino",
    "outageStatus.resolved": "Resuelto",
    "outageStatus.scheduled": "Mantenimiento programado",
    "pay.accountLabel": "Cuenta #{account}",
    "pay.addMethod": "+ Agregar nuevo método",
    "pay.amountExceedsBalance": "Eso supera su saldo actual de {amount}.",
    "pay.amountOptionsLegend": "Opciones de monto de pago",
    "pay.amountProcessed": "{amount} ha sido procesado.",
    "pay.batchPayAll": "Pagar Todas las Cuentas",
    "pay.cancel": "Cancelar",
    "pay.cancelAria": "Cancelar el pago",
    "pay.confirmation": "Confirmación #",
    "pay.confirmBatchPayment": "Confirmar Pago por Lote",
    "pay.confirmBiometric": "Confirmar con Face ID / huella",
    "pay.confirmPayment": "Confirmar Pago",
    "pay.confirmTitle": "Confirmar pago",
    "pay.copyConfirmation": "Copiar número de confirmación",
    "pay.customAmount": "Monto personalizado",
    "pay.customAmountLabel": "Monto personalizado en USD",
    "pay.dismiss": "Descartar",
    "pay.doneReturnDashboard": "Listo — Volver al Panel",
    "pay.emailReceipt": "Recibo por correo",
    "pay.enterCustomAmountAria": "Ingresar monto personalizado",
    "pay.expires": "Vence {expiry}",
    "pay.fullBalance": "Saldo total",
    "pay.identityVerified": "Identidad verificada",
    "pay.lastMonth": "El mes pasado",
    "pay.lastPayment": "Último pago",
    "pay.makePayment": "Hacer un pago",
    "pay.masterConfirmation": "Confirmación principal #",
    "pay.memoValue": "Pago de factura — {month}",
    "pay.meterLabel": "Medidor {id}",
    "pay.methodAria": "{brand} terminada en {last4}",
    "pay.monthsAgo": "hace {count} meses",
    "pay.newBalance": "Nuevo saldo: {amount} — actualizado en el próximo ciclo de facturación",
    "pay.noMethod": "No hay método de pago registrado.",
    "pay.noRecentPayments": "No hay pagos recientes",
    "pay.onFile": "Registrada",
    "pay.paidInFull": "Pagado en su totalidad",
    "pay.paidInFullBody": "Esta cuenta está pagada en su totalidad — no hay nada pendiente ahora.",
    "pay.payFullAmountAria": "Pagar el monto total {amount}",
    "pay.payInFull": "Pagar el total",
    "pay.paymentArrangement": "Configurar un acuerdo de pago",
    "pay.paymentMethodTitle": "Método de pago",
    "pay.paymentProcessed": "Tu pago ha sido procesado.",
    "pay.paymentSuccessful": "¡Pago realizado!",
    "pay.payOnlyMeter": "Pagar solo este medidor",
    "pay.payOther": "Pagar otro monto",
    "pay.paySpecificBills": "Pagar facturas específicas",
    "pay.perAccountConfirmations": "Confirmaciones por cuenta",
    "pay.plannedForDelivery": "Previsto para entrega",
    "pay.processing": "Procesando tu pago…",
    "pay.processingAria": "Procesando pago",
    "pay.processingSubtitle": "Por favor no cierres esta página",
    "pay.processingTitle": "Procesando tu pago",
    "pay.progressLabel": "Progreso del pago",
    "pay.recentBatch": "Pagos por lote recientes",
    "pay.retry": "Reintentar",
    "pay.retryAria": "Reintentar el pago",
    "pay.securedDisclaimer": "Seguro · Prototipo de demo — ningún pago real procesado",
    "pay.selectAmount": "Selecciona el monto del pago",
    "pay.selectMethod": "Selecciona el método de pago",
    "pay.smsReceipt": "Recibo por SMS",
    "pay.stepAmount": "Seleccionar Monto",
    "pay.stepConfirm": "Confirmar",
    "pay.stepDone": "Listo",
    "pay.stepMethod": "Seleccionar Método",
    "pay.stepProcessing": "Procesando",
    "pay.summaryAccount": "Cuenta",
    "pay.summaryAmount": "Monto",
    "pay.summaryMemo": "Concepto",
    "pay.summaryMethod": "Método de pago",
    "pay.title": "Pagar ahora",
    "pay.total": "Total",
    "pay.underThresholdNote": "Los lotes de menos de {amount} omiten la verificación biométrica adicional.",
    "pay.verifyBiometrics": "Verificar con biometría (simulado)",
    "pay.verifying": "Verificando…",
    "pay.whyNoBankAria": "¿Por qué no hay pasarela de pago real?",
    "pay.whyNoBankBody": "La pasarela está simulada según la postura de seguridad de la vista previa. La integración de producción requeriría alcance PCI-DSS y credenciales bancarias reales — fuera del alcance de esta vista previa.",
    "pay.whyNoBankTitle": "¿Por qué no hay conexión bancaria real?",
    "payStatus.confirmed": "Confirmado",
    "payStatus.failed": "Fallido",
    "payStatus.pending": "Pendiente",
    "persona.lockedAria": "Cambio de perfil desactivado durante el pago",
    "persona.lockedHint": "Termine el pago para cambiar",
    "persona.switchAria": "Cambiar de perfil",
    "persona.switchTo": "Cambiar a {name}",
    "pm.accountDetails": "Detalles de la cuenta",
    "pm.accountNotFound": "Cuenta no encontrada.",
    "pm.actions.makeRequest": "Hacer una solicitud",
    "pm.actions.payBill": "Pagar factura",
    "pm.actions.reportOutage": "Reportar corte",
    "pm.actions.viewBill": "Ver factura",
    "pm.allAccountsCount": "Todas las propiedades ({count})",
    "pm.anomaly.actionHvac": "Revisar la programación de climatización desde el portal del termostato inteligente",
    "pm.anomaly.actionTenant": "Contactar al inquilino para confirmar el cambio en el patrón de ocupación",
    "pm.anomaly.actionThermostat": "Revisar el termostato del calentador de agua — programar técnico",
    "pm.anomaly.allOthersNormal": "Todas las demás cuentas están dentro del rango normal.",
    "pm.anomaly.badgeSummary": "+18% semana contra semana frente a la misma semana del año pasado",
    "pm.anomaly.causeHeaterDetail": "El consumo del circuito {meter} subió 8 kWh al día desde el 28 de abril — posible falla del termostato [medición]",
    "pm.anomaly.causeHeaterTitle": "Exceso de consumo del calentador de agua",
    "pm.anomaly.causeHvacDetail": "El tiempo de funcionamiento del aire acondicionado aumentó un 22% desde marzo — la programación pudo reiniciarse tras la interrupción eléctrica de abril [medición]",
    "pm.anomaly.causeHvacTitle": "Desajuste en la programación de climatización",
    "pm.anomaly.causeTenantDetail": "La cuenta muestra 2 cambios de inquilino durante el último año [registro CIS]",
    "pm.anomaly.causeTenantTitle": "Cambio de inquilino — nuevo patrón de ocupación",
    "pm.anomaly.dailyKwh": "kWh diarios — últimos 7 días",
    "pm.anomaly.dayFri": "Vie",
    "pm.anomaly.dayMon": "Lun",
    "pm.anomaly.daySun": "Dom",
    "pm.anomaly.elevated": "Consumo de energía elevado",
    "pm.anomaly.likelyCauses": "Causas probables",
    "pm.anomaly.recentAnomalies": "Anomalías recientes en tu cartera",
    "pm.anomaly.recentBadge": "+18% sem. contra sem.",
    "pm.anomaly.recentDate": "Este mes",
    "pm.anomaly.scheduleTechnician": "Programar visita técnica",
    "pm.anomaly.subtitle": "{property} · Cuenta n.º {account}",
    "pm.anomaly.suggestedActions": "Acciones sugeridas",
    "pm.anomaly.title": "Anomalía de energía",
    "pm.breadcrumbAria": "Ruta de navegación",
    "pm.dueDate": "vence {date}",
    "pm.managedAccountsAria": "Propiedades gestionadas",
    "pm.managedProperties": "{count} propiedades gestionadas",
    "pm.metaAccountNum": "Cuenta #",
    "pm.metaAddress": "Dirección",
    "pm.metaLastMonthUsage": "Consumo del mes pasado",
    "pm.metaMeters": "Medidores",
    "pm.meterCountOne": "{count} medidor",
    "pm.meterCountOther": "{count} medidores",
    "pm.portfolio": "Cartera",
    "pm.portfolioView": "Vista de cartera",
    "pm.portfolioViewP4Only": "Esta vista está disponible para el perfil de administrador de propiedades (P4).",
    "pm.property": "Propiedad",
    "pm.quickActionsAria": "Acciones rápidas",
    "pm.selectAccount": "Selecciona una propiedad",
    "pm.statusNormal": "Normal",
    "pm.switchAccount": "Cambiar de propiedad:",
    "pm.switchAria": "Cambiar a otra propiedad gestionada",
    "pm.thBalance": "Saldo",
    "pm.thisMonth": "Este mes",
    "pm.thStatus": "Estado",
    "pm.thUsage": "Consumo",
    "pm.usage": "de consumo",
    "pm.vacant": "Desocupada",
    "pm.vacantAnomaly.guidance": "Esto puede indicar una fuga de plomería, una falla de electrodoméstico u ocupación no autorizada. Considera programar una inspección en el sitio.",
    "pm.vacantAnomaly.markedVacant": "{property} está marcada como desocupada.",
    "pm.vacantAnomaly.title": "Anomalía detectada en propiedad desocupada",
    "pm.viewPropertyAria": "Ver {name}",
    "publicNav.about": "Acerca de",
    "publicNav.askPelican": "Preguntar",
    "publicNav.enterPreview": "Entrar a la vista previa",
    "publicNav.help": "Ayuda",
    "publicNav.home": "Inicio",
    "publicNav.hurricane": "Huracán",
    "publicNav.sectionNavLabel": "Secciones de la página",
    "publicNav.status": "Estado",
    "report.attachPhoto": "Adjuntar una foto (opcional)",
    "report.availableNow": "Disponible ahora",
    "report.descriptionLabel": "Descripción (opcional)",
    "report.descriptionPlaceholder": "p. ej. Luz parpadeando, completamente apagada, vidrio roto",
    "report.enterPoleNumber": "Ingresar número de poste",
    "report.mapAreaAria": "Área del mapa — toque para colocar un pin en la farola averiada",
    "report.mapRoadLabel": "Leeward Hwy",
    "report.outageDescription": "Coloca un pin en el mapa o elige tu dirección; sigue la restauración en tiempo real.",
    "report.outageName": "Reportar un corte de energía",
    "report.photoFilename": "streetlight-photo.jpg",
    "report.photoUploaded": "1.2 MB · Subido hace un momento",
    "report.pinPlaced": "Pin colocado cerca de Leeward Highway",
    "report.poleNumber": "Número de poste",
    "report.poleNumberHint": "Busca el número estampado o etiquetado en el poste de metal (p. ej. TCI-4821)",
    "report.poleNumberPlaceholder": "p. ej. TCI-4821",
    "report.reference": "Referencia",
    "report.reportNow": "Reportar ahora →",
    "report.slSubmittedTitle": "Reporte enviado",
    "report.slSubtitle": "Toca la luz en el mapa O ingresa el número de poste impreso en el poste.",
    "report.slTitle": "Reportar una farola defectuosa",
    "report.submitReport": "Enviar reporte",
    "report.subtitle": "¿Qué tipo de problema estás reportando? Toca una opción abajo — te llevaremos al formulario correcto.",
    "report.tapFaultyLight": "Toca la farola defectuosa en el mapa",
    "report.tapOnMap": "Tocar en el mapa",
    "report.tapToDropPin": "Toca para colocar un pin en la luz defectuosa",
    "report.title": "Reportar un problema",
    "report.trackRequests": "Seguir mis solicitudes",
    "report.viewDetails": "Ver detalles →",
    "services.allServices": "Todos los servicios",
    "services.backToServices": "Volver a Servicios",
    "services.backToServicesAria": "Volver a servicios",
    "services.continue": "Continuar",
    "services.dcAttachPrompt": "Toca para adjuntar el presupuesto de reparación (PDF, JPG)",
    "services.dcAttachQuotes": "Adjuntar presupuestos de reparación",
    "services.dcAuthorize": "Confirmo que este reclamo es correcto y entiendo que los reclamos falsos pueden resultar en denegación y acción sobre la cuenta según los términos de servicio de Pelican Energy TCI.",
    "services.dcClaimReference": "Referencia del reclamo",
    "services.dcClaimSubmitted": "Reclamo enviado",
    "services.dcDescribeLabel": "Describe el equipo o la propiedad dañada",
    "services.dcDescribePlaceholder": "p. ej. compresor de aire acondicionado, refrigerador, TV — describe el daño y el costo estimado de reparación",
    "services.dcIntro": "Envía dentro de los 10 días del corte. Decisión en 15 días hábiles.",
    "services.dcNeedHelp": "¿Necesitas ayuda?",
    "services.dcOutageDate": "Fecha del corte",
    "services.dcOutageDateValue": "Tu fecha de corte",
    "services.dcQuoteFilename": "repair-quote.pdf",
    "services.dcQuoteSize": "180 KB",
    "services.dcReceivedMsg": "Tu reclamo por daños ha sido recibido. Decisión dentro de 15 días hábiles.",
    "services.dcSubmit": "Enviar reclamo por daños",
    "services.dcTitle": "Reclamo por daños",
    "services.dcViewProcess": "Ver el proceso de reclamos en pelicanenergytci.com",
    "services.districtArea": "Distrito / Área",
    "services.newRequest": "Nueva solicitud",
    "services.noRequests": "Aún no hay solicitudes de servicio.",
    "services.serviceAddress": "Dirección del servicio",
    "services.serviceNotFound": "Servicio no encontrado.",
    "services.sstAddressSubConfirm": "Confirma tu dirección de servicio actual",
    "services.sstAddressSubStart": "Ingresa la dirección donde necesitas el servicio",
    "services.sstAuthConfirm": "Confirmo que la información proporcionada es correcta y autorizo a Pelican Energy TCI a procesar esta solicitud. Entiendo que la información falsa puede retrasar el procesamiento.",
    "services.sstAuthSubtitle": "Revisa y autoriza tu solicitud de servicio.",
    "services.sstConfirmSubtitle": "Tu solicitud de servicio ha sido recibida y se está procesando.",
    "services.sstConfirmTitle": "Solicitud enviada",
    "services.sstDateNote": "Pelican Energy TCI confirmará la fecha exacta de procesamiento dentro de 1 día hábil.",
    "services.sstDateSubtitle": "¿Cuándo debe entrar en vigencia este cambio? Mínimo 2 días hábiles a partir de hoy.",
    "services.sstDistrictPlaceholder": "The Bight, Providenciales",
    "services.sstDocFilename": "passport-scan.pdf",
    "services.sstDocFormats": "PDF, JPG o PNG · Máx. 10 MB",
    "services.sstDocPrompt": "Toca para seleccionar un archivo",
    "services.sstDocSize": "245 KB · Subido hace un momento",
    "services.sstDocsSubtitle": "Sube una identificación con foto válida y prueba de propiedad o arrendamiento.",
    "services.sstDocsTitle": "Documentos de respaldo",
    "services.sstEffectiveValue": "la fecha de inicio que seleccionaste",
    "services.sstExpectedCompletion": "Finalización estimada: 5–7 días hábiles",
    "services.sstNewAddress": "Nueva dirección",
    "services.sstNewDistrictPlaceholder": "Distrito, Isla",
    "services.sstNewStreetPlaceholder": "Ingresa la nueva dirección",
    "services.sstOptStartDesc": "Te mudas a una propiedad que necesita una nueva conexión",
    "services.sstOptStartLabel": "Iniciar nuevo servicio",
    "services.sstOptStopDesc": "Te mudas y necesitas cerrar la cuenta",
    "services.sstOptStopLabel": "Suspender servicio existente",
    "services.sstOptTransferDesc": "Te mudas a una nueva dirección y quieres conservar tu cuenta",
    "services.sstOptTransferLabel": "Transferir servicio",
    "services.sstReferenceNumber": "Número de referencia",
    "services.sstReqStop": "Suspender servicio",
    "services.sstRequestedDate": "Fecha solicitada",
    "services.sstSelectedDate": "Tu fecha seleccionada",
    "services.sstStepAddress": "Dirección",
    "services.sstStepAuthorize": "Autorización",
    "services.sstStepConfirmation": "Confirmación",
    "services.sstStepDate": "Fecha de vigencia",
    "services.sstStepDocuments": "Documentos",
    "services.sstStepType": "Tipo de solicitud",
    "services.sstStreetPlaceholder": "14 Bight Park Lane",
    "services.sstSubmit": "Enviar solicitud",
    "services.sstSummaryAccount": "Cuenta:",
    "services.sstSummaryAddress": "Dirección:",
    "services.sstSummaryEffective": "Vigencia:",
    "services.sstSummaryRequest": "Solicitud:",
    "services.sstTypeSubtitle": "Inicia, suspende o transfiere tu servicio eléctrico — sin visitar la oficina.",
    "services.sstTypeTitle": "¿Qué te gustaría hacer?",
    "services.sstUploadAria": "Subir un documento",
    "services.startNewRequest": "Iniciar una nueva solicitud →",
    "services.startRequest": "Iniciar una solicitud",
    "services.streetAddress": "Dirección",
    "services.subtitle": "Solicita un cambio de servicio, envía formularios o presenta un reclamo — nosotros nos encargamos del papeleo para que no tengas que ir a la oficina.",
    "services.title": "Servicios",
    "services.track": "Seguimiento ({count})",
    "services.trackAria": "Seguir solicitudes ({count} activas)",
    "services.trackSubtitle": "Consulta el estado de tus solicitudes de servicio, reclamos y cambios de cuenta.",
    "services.trackTitle": "Seguir mis solicitudes",
    "serviceStatus.activeOutages": "{count} cortes activos",
    "serviceStatus.allNormal": "Todos los sistemas normales en las ocho islas",
    "serviceStatus.eta": "ETA {eta}",
    "serviceStatus.hurricanePrep": "Preparación para huracanes",
    "serviceStatus.lastRestoration": "Última restauración: hace más de 24 horas · Servicio operando normalmente",
    "serviceStatus.outagesAcross": "{count} cortes activos en {islandCount} islas",
    "serviceStatus.stormApproaching": "{name} se aproxima",
    "serviceStatus.viewMap": "Ver mapa",
    "serviceStatus.viewOutageMap": "Ver mapa de cortes →",
    "serviceStatus.yourService": "Tu servicio ({island}): ver mapa",
    "serviceStatus.yourServiceNormal": "Tu servicio en {island}: normal · Sin cortes activos",
    "signin.biometricAria": "Iniciar sesión con biometría",
    "signin.biometricButton": "Iniciar sesión con Face ID / huella",
    "signin.biometricCancel": "Usar contraseña en su lugar",
    "signin.biometricFallback": "Usar contraseña",
    "signin.biometricNotEnrolledBody": "Configura Face ID o huella en Ajustes, o inicia sesión con correo y contraseña.",
    "signin.biometricNotEnrolledTitle": "Sin biometría registrada",
    "signin.biometricPrompt": "Iniciar sesión en Pelican Energy TCI",
    "signin.biometricUnavailableBody": "Este dispositivo no admite autenticación biométrica.",
    "signin.biometricUnavailableTitle": "Biometría no disponible",
    "signin.continueAs": "Continuar como {name} →",
    "signin.credentialsHint": "Cualquier email y contraseña funcionan en esta vista previa.",
    "signin.emailLabel": "Correo electrónico",
    "signin.emailPlaceholder": "tu@correo.com",
    "signin.errorEmpty": "Por favor ingresa tu email y contraseña.",
    "signin.heading": "Iniciar sesión",
    "signin.hide": "Ocultar",
    "signin.hidePasswordAria": "Ocultar contraseña",
    "signin.orChooseDifferent": "O elija una persona diferente",
    "signin.passwordLabel": "Contraseña",
    "signin.quickPickTitle": "Selección rápida de persona (atajo del presentador)",
    "signin.show": "Mostrar",
    "signin.showPasswordAria": "Mostrar contraseña",
    "signin.signInAsAria": "Iniciar sesión como {name}",
    "signin.signInButton": "Iniciar sesión",
    "signin.signingIn": "Iniciando sesión…",
    "signin.subtitle": "Elige un perfil para entrar — o usa cualquier email y contraseña.",
    "signin.subtitlePreview": "Autoservicio para clientes · Vista previa",
    "signin.useCredentials": "O inicia sesión con email + contraseña",
    "signin.welcomeBack": "Bienvenido, {name}",
    "srDetail.completed": "Completado {date}",
    "srDetail.decisionBy": "Decisión para {date}",
    "srDetail.expectedBy": "Previsto para {date}",
    "srDetail.received": "Recibido {date}",
    "srStatus.comingSoon": "Próximamente",
    "srStatus.completed": "Completado",
    "srStatus.inProgress": "En curso",
    "srStatus.inReview": "En revisión",
    "srStatus.received": "Recibido",
    "srType.accountUpdate": "Actualización de cuenta",
    "srType.damageClaim": "Reclamo por daños",
    "srType.duskToDawnLight": "Luz de anochecer a amanecer",
    "srType.outageReport": "Reporte de corte",
    "srType.startService": "Iniciar servicio",
    "srType.stopService": "Suspender servicio",
    "srType.streetlightReport": "Reporte de farola",
    "srType.transferService": "Transferir servicio",
    "stubs.accountClosure.description": "Cierra permanentemente tu cuenta de servicio al mudarte, con resumen de la factura final y flujo de reembolso del depósito.",
    "stubs.accountClosure.name": "Cerrar mi cuenta",
    "stubs.accountClosure.why": "Cerrar una cuenta usa las mismas verificaciones de lectura final y liquidación que una transferencia, así que llega cuando ese flujo esté consolidado.",
    "stubs.accountUpdate.description": "Actualiza tu información de contacto, dirección postal y preferencias de comunicación.",
    "stubs.accountUpdate.name": "Actualización de cuenta",
    "stubs.accountUpdate.why": "Mantener tus datos de contacto al día es la base de todo lo demás, por eso salió en la primera versión.",
    "stubs.applyNewService.description": "Solicita una nueva conexión de servicio eléctrico en una propiedad — solicitud inicial, documentos de respaldo, programar la fecha de conexión.",
    "stubs.applyNewService.link": "Formulario actual en pelicanenergytci.com",
    "stubs.applyNewService.name": "Solicitar nuevo servicio",
    "stubs.applyNewService.why": "Conectar una propiedad nueva requiere agendar y dar seguimiento a una visita técnica; ese paso de programación es lo próximo que estamos construyendo.",
    "stubs.autopay.description": "Configura el pago automático de tu factura mensual desde una tarjeta guardada.",
    "stubs.autopay.name": "Pago automático",
    "stubs.autopay.why": "Guardar una tarjeta con la seguridad suficiente para cobrarla automáticamente requiere protección de nivel bancario, que estamos implementando.",
    "stubs.availableNow": "Disponible ahora",
    "stubs.comingTitle": "Próximamente",
    "stubs.comingWhen": "Disponible {when}",
    "stubs.damageClaims.description": "Presenta un reclamo por daños causados por un corte — dentro de 10 días, con presupuestos de reparación adjuntos. Decisión en 15 días hábiles.",
    "stubs.damageClaims.link": "Proceso actual en pelicanenergytci.com",
    "stubs.damageClaims.name": "Reclamos por daños",
    "stubs.damageClaims.why": "El proceso de reclamos ya existía; lo trajimos a la aplicación para que no tengas que buscarlo.",
    "stubs.duskToDawn.description": "Solicita la instalación o el reemplazo de una luz residencial al borde de la calle, incluyendo la cantidad necesaria y la ubicación.",
    "stubs.duskToDawn.name": "Solicitar luz de anochecer a amanecer",
    "stubs.duskToDawn.why": "Primero estamos terminando las solicitudes más usadas. Esta necesita un formulario que registre cuántas luces necesitas y en qué lugar exacto.",
    "stubs.feedback.description": "Tus comentarios ayudan a definir lo que construiremos a continuación para los clientes de Pelican Energy TCI.",
    "stubs.feedback.name": "Enviar comentarios",
    "stubs.feedback.why": "Queremos saber qué funciona y qué no mientras la aplicación todavía está tomando forma.",
    "stubs.hazard.description": "Línea eléctrica caída, cables expuestos, árbol peligroso sobre la línea u otra preocupación de seguridad. Se admite carga de fotos.",
    "stubs.hazard.name": "Reportar un peligro",
    "stubs.hazard.why": "Estamos construyendo la carga de fotos y la conexión directa con las cuadrillas de campo de las que depende un reporte de seguridad.",
    "stubs.liveChat.description": "Chat en tiempo real con un agente de servicio al cliente de Pelican Energy TCI durante el horario laboral.",
    "stubs.liveChat.name": "Chat en vivo con soporte de Pelican Energy TCI",
    "stubs.liveChat.why": "El chat en vivo solo sirve si siempre hay alguien para responder, así que primero estamos preparando el equipo de soporte.",
    "stubs.meterTools.description": "Envía una lectura manual de tu medidor cuando no haya una lectura automática, o consulta la combinación energética que alimenta tu dirección.",
    "stubs.meterTools.name": "Herramientas del medidor",
    "stubs.meterTools.why": "Estas herramientas necesitan una conexión en vivo con tu medidor, y estamos confirmando cómo encajan los medidores prepago.",
    "stubs.notifications.description": "Elige los canales de entrega (Email, SMS, Push) y establece horas de silencio para cada tipo de notificación.",
    "stubs.notifications.name": "Canales de notificación y horas de silencio",
    "stubs.notifications.why": "Enviar mensajes de texto y correos de forma confiable, y recordar exactamente cuáles quieres, es la parte que estamos construyendo ahora.",
    "stubs.notifyAlert": "Te avisaremos cuando {name} esté disponible.",
    "stubs.notifyMe": "Avísame cuando esté listo",
    "stubs.notifyMeAria": "Avisarme cuando {name} esté listo",
    "stubs.ownersConsent.description": "Autoriza un cambio de servicio en una propiedad de tu propiedad cuando el ocupante realiza la solicitud — con captura de firma.",
    "stubs.ownersConsent.name": "Enviar consentimiento del propietario",
    "stubs.ownersConsent.why": "Esta necesita captura segura de firma en la aplicación antes de que podamos aceptarla.",
    "stubs.personalGuarantee.description": "Proporciona una garantía personal para una conexión o mejora de servicio cuando Pelican lo requiera.",
    "stubs.personalGuarantee.name": "Enviar garantía personal",
    "stubs.personalGuarantee.why": "Necesita el mismo paso de firma segura que el Consentimiento del Propietario, así que ambos llegan juntos.",
    "stubs.powerLineClearance.description": "SafeMoves (mover equipo pesado), High-Load (vehículo sobredimensionado), Line Locate (excavación) — solicita el despeje de seguridad a Pelican Energy TCI.",
    "stubs.powerLineClearance.link": "SafeMoves en pelicanenergytci.com",
    "stubs.powerLineClearance.name": "Formularios de despeje de líneas eléctricas",
    "stubs.powerLineClearance.why": "El despeje de líneas involucra a tu contratista además de a ti; primero estamos afinando las solicitudes que haces por tu cuenta.",
    "stubs.shareBill.description": "Envía una copia de esta factura como comprobante de domicilio: por correo electrónico, WhatsApp o PDF imprimible.",
    "stubs.shareBill.name": "Compartir factura",
    "stubs.shareBill.why": "Compartir una factura como comprobante de domicilio significa generar un PDF limpio y enviarlo por WhatsApp o correo electrónico: eso es lo que estamos construyendo.",
    "stubs.startStopTransfer.description": "Múdate a una propiedad, cierra una cuenta o transfiere el servicio a una nueva dirección — todo desde tu teléfono, sin visitar la oficina.",
    "stubs.startStopTransfer.link": "Formulario actual en pelicanenergytci.com",
    "stubs.startStopTransfer.name": "Iniciar, suspender o transferir servicio",
    "stubs.startStopTransfer.why": "Mudarse es la solicitud que más recibimos, así que fue lo primero que construimos.",
    "stubs.streetlight.description": "Toca la farola en el mapa O ingresa el número de poste estampado en el poste.",
    "stubs.streetlight.name": "Reportar una farola defectuosa",
    "stubs.streetlight.why": "Reportar una calle a oscuras debería tomar segundos, así que empezamos con el mapa y la búsqueda por número de poste.",
    "stubs.upgradeExtend.description": "Solicita una mejora de capacidad (p. ej. de monofásico a trifásico, mayor amperaje) o una extensión de red a una propiedad remota.",
    "stubs.upgradeExtend.name": "Mejorar servicio o extensión de red",
    "stubs.upgradeExtend.why": "Una ampliación requiere un estudio de ingeniería de tu suministro antes de poder cotizarla. Estamos definiendo cómo agendarlo desde la aplicación.",
    "stubs.vacationMode.description": "Avísale a Pelican cuando estés fuera — vigilaremos el uso inusual y te avisaremos.",
    "stubs.vacationMode.name": "Modo vacaciones",
    "stubs.vacationMode.why": "Muchas casas aquí quedan vacías parte del año, así que valía la pena construir esto desde temprano.",
    "stubs.viewDetails": "Ver detalles →",
    "stubs.voiceAlexa.description": "Pregúntale a Alexa: «¿Cuál es mi saldo de Pelican?» / «Reportar un corte de energía».",
    "stubs.voiceAlexa.name": "Integración de voz con Amazon Alexa",
    "stubs.voiceAlexa.why": "Estamos preguntando a los clientes si realmente usarían la voz antes de construirlo.",
    "stubs.whyLater": "Por qué más adelante:",
    "stubs.whyNow": "Por qué ahora:",
    "support.aiCta": "Hacer una pregunta →",
    "support.aiDescription": "Haz cualquier pregunta sobre tu cuenta, tu factura o los servicios de Pelican Energy TCI — las respuestas citan los datos reales de tu cuenta.",
    "support.aiTitle": "Asistente Pelican",
    "support.backToSupport": "Volver a Atención al cliente",
    "support.open": "Abrir →",
    "support.subtitle": "Obtén ayuda con tu cuenta — nuestro asistente de IA está disponible 24/7, o comunícate con una persona durante el horario laboral.",
    "support.title": "Atención al cliente",
    "toolbar.activePersona": "Perfil activo",
    "toolbar.collapse": "Cerrar controles del demo",
    "toolbar.exit": "Visitar pelicanenergytci.com",
    "toolbar.expand": "Abrir controles del demo",
    "toolbar.label": "Modo demostración",
    "toolbar.payLockHint": "Completa o cancela el pago primero",
    "toolbar.personaTypeCommercial": "Comercial",
    "toolbar.personaTypeHotel": "Hotel / Comercial",
    "toolbar.personaTypeProperty": "Administrador",
    "toolbar.personaTypeResidential": "Residencial",
    "toolbar.reset": "Reiniciar demo",
    "toolbar.resetConfirmation": "Reinicio completado",
  },
};
